import type { Translations } from './ar';

// TypeScript enforces structural equality with `ar`. Missing keys here is a
// compile error; mismatched shapes are a compile error.
export const he: Translations = {
  fulfillment: {
    deliveryOnly: 'פעולה זו זמינה להזמנות משלוח בלבד.',
    pickupOnly: 'פעולה זו זמינה להזמנות איסוף עצמי בלבד.',
    busy: 'נתוני ההזמנה מתעדכנים. נסו שוב ובדקו את הפרטים.',
    amountOutOfRange: 'הסכום מחוץ לטווח הנתמך',
    clientUpdateRequired: 'יש לרענן את הדף כדי להמשיך באישור ההזמנה.',
    pickupStockNotice: 'המלאי מופחת בעת אישור ההזמנה.',
    pickupNext: 'יש לאסוף מהמקום המוצג. פנו לחנות לפרטים.',
    collected: 'נאסף',
    legacySubtotal: 'סכום הפריטים — דמי המשלוח לא נשמרו',
    quoteFailed: 'לא ניתן לחשב את הסכום. נסו שוב.',
    quoteLoading: 'מחשבים את הסכום',
    loadFailed: 'לא ניתן לטעון את האפשרויות. נסו שוב.',
    optionsChanged: 'האפשרויות השתנו. יש לבדוק את הפרטים והסכום ולאשר מחדש.',
    unavailable: 'משלוח ואיסוף אינם זמינים כרגע',
    chooseMethod: 'יש לבחור משלוח או איסוף עצמי',
    pickupPlace: 'מקום האיסוף',
    freePickup: 'איסוף עצמי ללא עלות',
    freeDelivery: 'משלוח חינם',
    deliveryFee: 'דמי משלוח',
    pickup: 'איסוף עצמי',
    delivery: 'משלוח',
    title: 'אופן קבלת ההזמנה',
  },
  common: {
    save: 'שמור',
    cancel: 'ביטול',
    delete: 'מחק',
    loading: 'טוען...',
    error: 'אירעה שגיאה',
    retry: 'נסה שוב',
    search: 'חיפוש',
    call: 'שיחה',
    actions: {
      close: 'סגירה',
    },
    phoneCountry: {
      IL: 'ישראל',
      PS: 'פלסטין',
      JO: 'ירדן',
      SY: 'סוריה',
      LB: 'לבנון',
      EG: 'מצרים',
      TR: 'טורקיה',
      US: 'ארצות הברית',
      international: 'מספר בינלאומי',
    },
    languageNames: {
      ar: 'ערבית',
      he: 'עברית',
      en: 'אנגלית',
    },
    errors: {
      permissionDenied: 'אין לך הרשאה לפעולה זו.',
      networkFailed: 'החיבור נכשל. בדוק את הרשת ונסה שוב.',
      storeNotFound: 'החנות הזו אינה קיימת עוד. רענן את הדף.',
      unknown: 'משהו השתבש. נסה שוב.',
    },
  },
  auth: {
    signup: {
      title: 'יצירת חשבון',
      subtitle: 'פתח את החנות שלך',
      emailLabel: 'אימייל',
      passwordLabel: 'סיסמה',
      passwordConfirmLabel: 'אימות סיסמה',
      submit: 'צור חשבון',
      submitting: 'יוצר חשבון...',
      haveAccount: 'יש לך חשבון?',
      signInLink: 'התחבר',
      showPassword: 'הצג סיסמה',
      hidePassword: 'הסתר סיסמה',
      errors: {
        emailRequired: 'אימייל נדרש',
        emailInvalid: 'כתובת אימייל לא תקינה',
        passwordTooShort: 'הסיסמה חייבת להיות לפחות 8 תווים',
        passwordConfirmRequired: 'נדרש אימות סיסמה',
        passwordMismatch: 'הסיסמאות אינן תואמות',
        emailAlreadyExists: 'אימייל זה כבר רשום',
        rateLimited: 'יותר מדי ניסיונות. נסה שוב בעוד מספר דקות.',
        networkFailed: 'החיבור נכשל. בדוק את הרשת.',
        accountCreatedSignInFailed: 'חשבונך נוצר. נסה שוב בעוד רגע.',
        unknown: 'אירעה שגיאה. נסה שוב.',
        noNegativeInventory: 'admin.barcode.errors.noNegativeInventory',
      },
    },
    callback: {
      title: 'מאמת...',
    },
    phoneOtp: {
      phoneLabel: 'מספר טלפון',
      phoneHint: 'הכנס מספר עם קידומת מדינה או בחר מדינה.',
      codeLabel: 'קוד אימות',
      codeHint: 'הכנס קוד בן 6 ספרות.',
      requestCode: 'שלח קוד',
      requestingCode: 'שולח...',
      verifyCode: 'אמת קוד',
      verifyingCode: 'מאמת...',
      retryHandoff: 'נסה שוב',
      resendCode: 'שלח קוד חדש',
      changePhone: 'שנה טלפון',
      sentMessage: 'שלחנו קוד אימות לטלפון שלך.',
      smsOnly: 'נשלח את הקוד ב-SMS.',
      existingEmailFallback: 'אין לך טלפון מאומת?',
      useEmailFallback: 'השתמש באימייל וסיסמה',
      usePhoneOtp: 'השתמש בקוד טלפון',
      errors: {
        phoneRequired: 'מספר טלפון נדרש',
        phoneInvalid: 'מספר הטלפון לא תקין',
        codeRequired: 'קוד אימות נדרש',
        codeInvalid: 'הכנס קוד בן 6 ספרות',
        invalidCode: 'הקוד שגוי או פג תוקף',
        customerAccountMissing: 'לא קיים חשבון לקוח לטלפון הזה. צור חשבון קודם.',
        adminAccountMissing: 'לא קיים חשבון סוחר לטלפון הזה.',
        rateLimited: 'יותר מדי ניסיונות. נסה שוב בעוד רגע.',
        networkFailed: 'החיבור נכשל. בדוק את הרשת.',
        cartHandoffFailed: 'התחברת, אך לא הצלחנו להעביר את העגלה. נסה שוב.',
        profileEnsureFailed: 'המספר אומת, אבל לא הצלחנו להכין את חשבון הלקוח. נסו שוב.',
        unknown: 'משהו השתבש. נסה שוב.',
      },
    },
  },
  catalog: {
    products: 'מוצרים',
    outOfStock: 'אזל מהמלאי',
  },
  customer: {
    phoneCountryLabel: 'קידומת מדינה',
    phoneCountry: {
      IL: 'ישראל',
      PS: 'פלסטין',
      JO: 'ירדן',
      SY: 'סוריה',
      LB: 'לבנון',
      EG: 'מצרים',
      TR: 'טורקיה',
      US: 'ארצות הברית',
    },
    signup: {
      title: 'המשך עם טלפון',
      subtitle: 'קוד אימות אחד מאפשר להמשיך בקנייה.',
      fullNameLabel: 'שם מלא',
      fullNameHint: 'כפי שתרצה שהמוכר יראה אותך',
      emailLabel: 'אימייל',
      emailHint: 'כתובת זו תשמש להתחברות',
      passwordLabel: 'סיסמה',
      passwordHint: '8 תווים לפחות',
      passwordConfirmLabel: 'אימות סיסמה',
      phoneLabel: 'מספר טלפון (לא חובה)',
      phoneHint: 'עוזר למוכר ליצור איתך קשר לגבי ההזמנה',
      phoneCountryLabel: 'קידומת מדינה',
      phoneCountry: {
        IL: 'ישראל',
        PS: 'פלסטין',
        JO: 'ירדן',
        SY: 'סוריה',
        LB: 'לבנון',
        EG: 'מצרים',
        TR: 'טורקיה',
        US: 'ארצות הברית',
      },
      showPassword: 'הצג סיסמה',
      hidePassword: 'הסתר סיסמה',
      submit: 'צור חשבון',
      submitting: 'יוצר חשבון...',
      haveAccount: 'כבר יש לך חשבון?',
      signInLink: 'התחבר',
      successToast: 'החשבון נוצר בהצלחה!',
      errors: {
        fullNameRequired: 'נדרש שם מלא',
        fullNameTooShort: 'השם קצר מדי',
        fullNameTooLong: 'השם ארוך מדי',
        emailRequired: 'אימייל נדרש',
        emailInvalid: 'כתובת אימייל לא תקינה',
        passwordTooShort: 'הסיסמה חייבת להיות לפחות 8 תווים',
        passwordConfirmRequired: 'נדרש אימות סיסמה',
        passwordMismatch: 'הסיסמאות אינן תואמות',
        phoneInvalid: 'מספר הטלפון לא תקף עבור המדינה שנבחרה',
        emailAlreadyExists:
          'כתובת האימייל הזו כבר רשומה. אם את/ה בעל/ת חנות, אפשר להתחבר עם אותו חשבון כדי לקנות.',
        rateLimited: 'יותר מדי ניסיונות. נסה שוב בעוד דקה.',
        networkFailed: 'החיבור נכשל. בדוק את הרשת.',
        accountCreatedSignInFailed: 'החשבון נוצר. נסה להתחבר בעוד רגע.',
        unknown: 'אירעה שגיאה. נסה שוב.',
      },
    },
    header: {
      signUpLink: 'המשך עם טלפון',
      signInLink: 'התחברות',
      avatarMenuLabel: 'תפריט חשבון',
      signOut: 'יציאה',
      myProfile: 'הפרופיל שלי',
      myAddresses: 'הכתובות שלי',
      myOrders: 'ההזמנות שלי',
    },
    login: {
      title: 'המשך עם טלפון',
      subtitle: 'לקוחות חדשים וחוזרים משתמשים באותו קוד טלפון.',
      emailLabel: 'דוא"ל',
      emailHint: 'הכתובת שהזנת ביצירת החשבון',
      passwordLabel: 'סיסמה',
      showPassword: 'הצג סיסמה',
      hidePassword: 'הסתר סיסמה',
      submit: 'התחבר',
      submitting: 'מתחבר…',
      forgotPasswordLink: 'שכחת סיסמה?',
      noAccountYet: 'אין לך חשבון?',
      signUpLink: 'צור חשבון',
      phoneOnlyHint: 'אין צורך באימייל או סיסמה.',
      errors: {
        emailRequired: 'דוא"ל הוא שדה חובה',
        emailInvalid: 'כתובת דוא"ל לא תקינה',
        passwordRequired: 'סיסמה הינה שדה חובה',
        invalidCredentials: 'פרטי התחברות שגויים. נסה שוב.',
        rateLimited: 'יותר מדי ניסיונות. נסה שוב בעוד מספר דקות.',
        networkFailed: 'החיבור נכשל. בדוק את הרשת.',
        unknown: 'משהו השתבש. נסה שוב.',
      },
    },
    passwordReset: {
      request: {
        title: 'איפוס סיסמה',
        subtitle: 'נשלח קישור איפוס לדוא"ל שלך.',
        emailLabel: 'דוא"ל',
        submit: 'שלח קישור איפוס',
        submitting: 'שולח…',
        successTitle: 'בדוק את הדוא"ל שלך',
        successMessage: 'אם יש חשבון עם דוא"ל זה, תקבל הודעה עם קישור איפוס בעוד מספר דקות.',
        backToSignIn: 'חזרה להתחברות',
        errors: {
          emailRequired: 'דוא"ל הוא שדה חובה',
          emailInvalid: 'כתובת דוא"ל לא תקינה',
          rateLimited: 'יותר מדי ניסיונות. נסה שוב בעוד מספר דקות.',
          networkFailed: 'החיבור נכשל. בדוק את הרשת.',
          unknown: 'משהו השתבש. נסה שוב.',
        },
      },
      confirm: {
        title: 'בחר סיסמה חדשה',
        subtitle: 'הכנס סיסמה חדשה כדי להשלים את האיפוס.',
        passwordLabel: 'סיסמה חדשה',
        passwordHint: 'לפחות 8 תווים',
        passwordConfirmLabel: 'אישור סיסמה',
        showPassword: 'הצג סיסמה',
        hidePassword: 'הסתר סיסמה',
        submit: 'שמור סיסמה חדשה',
        submitting: 'שומר…',
        sessionMissingTitle: 'קישור האיפוס פג',
        sessionMissingMessage: 'בקש קישור חדש.',
        sessionMissingCta: 'בקש קישור חדש',
        successToast: 'הסיסמה שונתה. ברוך שובך!',
        errors: {
          passwordTooShort: 'הסיסמה חייבת להכיל לפחות 8 תווים',
          passwordMismatch: 'הסיסמאות אינן תואמות',
          rateLimited: 'יותר מדי ניסיונות. נסה שוב בעוד מספר דקות.',
          networkFailed: 'החיבור נכשל. בדוק את הרשת.',
          unknown: 'משהו השתבש. נסה שוב.',
        },
      },
    },
    profilePlaceholder: {
      title: 'דף החשבון בקרוב',
      subtitle: 'אנחנו עדיין בונים את הדף הזה. חזור בקרוב.',
      cta: 'חזרה לחנות',
      ariaLabel: 'דף חשבון זמני',
    },
    account: {
      pageTitle: 'חשבון',
      ariaLabel: 'דף חשבון',
      subtitle: 'נהל את הפרופיל, הכתובות השמורות וההזמנות שלך.',
      navLabel: 'אזורי החשבון',
      items: {
        profile: {
          title: 'פרופיל',
          description: 'עדכן את השם והשפה המועדפת.',
        },
        addresses: {
          title: 'כתובות שמורות',
          description: 'הוסף, ערוך או בחר כתובת ברירת מחדל למשלוח.',
        },
        orders: {
          title: 'הזמנות',
          description: 'צפה בהזמנות האחרונות ובסטטוס שלהן.',
        },
      },
    },
    profile: {
      pageTitle: 'פרופיל',
      ariaLabel: 'דף הפרופיל',
      editButton: 'ערוך פרופיל',
      addressesButton: 'ניהול כתובות שמורות',
      saveButton: 'שמור שינויים',
      saving: 'שומר…',
      cancelButton: 'ביטול',
      nameLabel: 'שם',
      emailLabel: 'אימייל',
      emailReadOnly: 'לא ניתן לשנות את האימייל כרגע',
      phoneLabel: 'טלפון',
      phoneOptional: 'אופציונלי',
      phoneReadOnly: 'הטלפון מחובר לכניסה ולא ניתן לשנות אותו כאן.',
      phonePlaceholder: '+972501234567',
      localeLabel: 'שפה מועדפת',
      localeAr: 'ערבית',
      localeHe: 'עברית',
      localeEn: 'English',
      successToast: 'השינויים נשמרו בהצלחה',
      signOut: 'התנתקות',
      signingOut: 'מתנתק…',
      deleteAccount: {
        title: 'מחיקת חשבון',
        warning:
          'פעולה זו אינה הפיכה. החשבון שלך יימחק לצמיתות. הזמנות פעילות יישארו גלויות למוכר עם מידע אנונימי.',
        confirmPrompt: 'הקלד "{{word}}" לאישור',
        confirmWord: 'מחק',
        confirmButton: 'מחק חשבון לצמיתות',
        deleting: 'מוחק חשבון…',
      },
      errors: {
        nameRequired: 'שם נדרש',
        nameTooLong: 'השם ארוך מדי (מקסימום 100 תווים)',
        phoneInvalid: 'מספר טלפון לא תקין',
        networkFailed: 'שגיאת חיבור. בדוק את הרשת.',
        rateLimited: 'ניסיונות רבים מדי. נסה שוב בעוד כמה דקות.',
        unknown: 'אירעה שגיאה. נסה שוב.',
        deleteFailed: 'מחיקת החשבון נכשלה. נסה שוב.',
      },
    },
    addresses: {
      pageTitle: 'הכתובות שלי',
      ariaLabel: 'דף הכתובות',
      addNewCta: 'הוספת כתובת חדשה',
      limitReached: 'הגעת למגבלה (20 כתובות). מחק כתובת ישנה כדי להוסיף חדשה.',
      defaultBadge: 'ברירת מחדל',
      makeDefault: 'הפוך לברירת מחדל',
      edit: 'עריכה',
      delete: 'מחיקה',
      actionsMenuLabel: 'פעולות על הכתובת',
      empty: {
        title: 'אין עדיין כתובות שמורות',
        body: 'הוסף כתובת כדי להאיץ את התשלום.',
        cta: 'הוסף את הכתובת הראשונה שלך',
      },
      form: {
        addTitle: 'הוספת כתובת חדשה',
        editTitle: 'עריכת כתובת',
        labelLabel: 'תווית',
        labelPlaceholder: 'לדוגמה: בית, עבודה',
        labelOptional: 'אופציונלי',
        recipientNameLabel: 'שם הנמען',
        addressLine1Label: 'כתובת',
        addressLine2Label: 'שורת כתובת שנייה',
        cityLabel: 'עיר',
        localitySearchPlaceholder: 'חיפוש עיר או יישוב',
        localitySearchPrompt: 'התחל להקליד כדי למצוא עיר או יישוב.',
        localityNoResults: 'לא נמצאה עיר או יישוב מתאים',
        regionLabel: 'מחוז',
        regionFallbackLabel: 'מדינה / מחוז',
        postalCodeLabel: 'מיקוד',
        countryLabel: 'מדינה',
        phoneLabel: 'מספר טלפון',
        phoneOptional: 'אופציונלי — המוכר עשוי להשתמש בזה לתיאום המשלוח.',
        isDefaultLabel: 'הפוך לכתובת ברירת המחדל שלי',
        saveNew: 'שמירת כתובת',
        saveEdit: 'שמירת שינויים',
        cancel: 'ביטול',
        saving: 'שומר…',
      },
      districtIL: {
        northern: 'מחוז הצפון',
        haifa: 'מחוז חיפה',
        central: 'המחוז המרכזי',
        tel_aviv: 'מחוז תל אביב',
        jerusalem: 'מחוז ירושלים',
        southern: 'מחוז הדרום',
      },
      successToast: {
        created: 'הכתובת נשמרה',
        updated: 'הכתובת עודכנה',
        deleted: 'הכתובת נמחקה',
        defaultSet: 'כתובת ברירת המחדל עודכנה',
      },
      deleteConfirm: {
        title: 'למחוק את הכתובת הזו?',
        body: 'הכתובת לא תופיע יותר באפשרויות התשלום. הזמנות קודמות לא יושפעו.',
        confirm: 'מחק',
        confirmAlias: 'admin.products.barcode.confirm',
        deleting: 'מוחק…',
      },
      errors: {
        labelTooLong: 'התווית ארוכה מדי',
        recipientNameRequired: 'שם הנמען נדרש',
        recipientNameTooLong: 'שם הנמען ארוך מדי',
        addressLine1Required: 'כתובת נדרשת',
        addressLine1TooLong: 'הכתובת ארוכה מדי',
        addressLine2TooLong: 'שורת הכתובת השנייה ארוכה מדי',
        cityRequired: 'עיר נדרשת',
        cityTooLong: 'שם העיר ארוך מדי',
        regionRequired: 'מחוז נדרש',
        regionTooLong: 'המחוז ארוך מדי',
        postalCodeRequired: 'מיקוד נדרש',
        postalCodeInvalidIL: 'המיקוד הישראלי חייב להיות 5 או 7 ספרות',
        postalCodeInvalid: 'מיקוד לא תקין',
        countryRequired: 'מדינה נדרשת',
        phoneInvalid: 'מספר טלפון לא תקין',
        networkFailed: 'החיבור נכשל. בדוק את הרשת.',
        rateLimited: 'ניסיונות רבים מדי. נסה שוב בעוד מספר דקות.',
        notFound: 'הכתובת לא נמצאה.',
        deleteFailed: 'לא ניתן למחוק את הכתובת.',
        setDefaultFailed: 'לא ניתן להגדיר את ברירת המחדל.',
        unknown: 'משהו השתבש. נסה שוב.',
      },
    },
    // DEPRECATED: F-019 replaced the orders placeholder with the real order
    // history page. These keys are retained for translator reference only.
    // No runtime code references them. Safe to remove in a future cleanup.
    ordersPlaceholder: {
      title: 'הזמנות בקרוב',
      subtitle: 'אנחנו עדיין בונים את הדף הזה. חזור בקרוב.',
      cta: 'חזרה לחנות',
      ariaLabel: 'דף הזמנות זמני',
    },
    callback: {
      title: 'מאמת...',
      loading: 'רגע בבקשה, אנו מאמתים את האימייל שלך.',
    },
    authGate: {
      title: 'אמת את הטלפון כדי ליצור קשר עם המוכר',
      subtitle: 'כדי לפנות אל {{storeName}} בנוגע ל-{{productName}}, המשך באימות טלפון.',
      signInCta: 'המשך עם טלפון',
      signUpCta: 'המשך עם טלפון',
      closeLabel: 'סגור',
      primedBanner: {
        message: 'התחברת — לחץ על "צור קשר עם המוכר" כדי לשלוח הודעה ל-{{storeName}}',
        dismissLabel: 'סגור',
      },
    },
  },
  cart: {
    errors: {
      insufficientStock: 'מישהו אחר תפס את היחידות האחרונות — נשארו רק {{available}}',
      productNotFound: 'המוצר לא נמצא',
      notAuthenticated: 'יש להתחבר כדי להמשיך',
      permissionDenied: 'אין לך הרשאה לבצע שינוי זה',
      networkFailed: 'החיבור לרשת נכשל. נסה שוב.',
      unknown: 'אירעה שגיאה בלתי צפויה. נסה שוב.',
      storeUnpublished: 'חנות זו אינה מקבלת הזמנות כרגע',
      cartItemNotFound: 'פריט זה כבר לא בעגלה שלך. אנו מרעננים את התצוגה.',
      invalidQuantity: 'לא הצלחנו לעדכן את הכמות. נסה שוב.',
      variantUnavailable: 'האפשרות הזו כבר לא זמינה',
      insufficientVariantStock: 'אין מספיק מלאי לאפשרות זו',
    },
  },
  checkout: {
    cart: 'עגלה',
    total: 'סך הכל',
  },
  reviews: {
    verifiedCustomer: 'לקוח מאומת',
    verifiedPurchase: 'רכישה מאומתת',
    merchantResponse: 'תגובת החנות',
    ratingLabel: '{{rating}} מתוך 5',
    reviewCount: '{{count}} ביקורות',
    noReviewsYet: 'אין עדיין ביקורות',
    errors: {
      notEligible: 'המוצר הזה אינו זכאי לביקורת',
      alreadyReviewed: 'כבר נכתבה ביקורת למוצר הזה',
      permissionDenied: 'אין לך הרשאה לשלוח את הביקורת הזו',
      productUnavailable: 'אי אפשר לכתוב ביקורת על המוצר הזה כרגע',
      ratingInvalid: 'בחרו דירוג מ-1 עד 5',
      textTooLong: 'הטקסט חייב להיות עד 1000 תווים',
      whitespaceOnly: 'כתבו טקסט ברור או השאירו את השדה ריק',
    },
  },
  admin: {
    newsletterSubscribers: {
      consentVersion: 'גרסת ההסכמה',
      source: 'מקור ההרשמה',
      exportError: 'לא ניתן לייצא את המנויים המוצגים. נסו שוב.',
      recentLimit: 'האחרונים, עד {{count}} מנויים',
      title: 'מנויים',
      description: 'הצגת אנשי קשר אחרונים שהסכימו להירשם לחנות.',
      limit: 'מספר אנשי קשר אחרונים',
      limitOption: '{{count}} אנשי הקשר האחרונים',
      export: 'ייצוא המנויים המוצגים',
      empty:
        'אין מנויים עדיין. הפעילו איסוף הרשמות ופרסמו את תוכן ההרשמה כדי שמבקרים יוכלו להירשם.',
      loadError: 'לא ניתן לטעון מנויים.',
      forbidden: 'העמוד זמין רק לבעלי החנות ולמנהלים.',
      contact: 'פרטי קשר',
      method: 'דרך קשר',
      status: 'סטטוס',
      subscribedAt: 'מועד ההרשמה',
      lastSubmittedAt: 'שליחה אחרונה',
      active: 'פעיל',
      suppressed: 'מושבת',
      suppress: 'השבתת הרשמה',
      suppressTitle: 'להשבית את ההרשמה?',
      suppressBody: 'ההרשמה תישאר מושבתת גם אם תישלח בקשת הרשמה נוספת.',
      suppressSuccess: 'ההרשמה הושבתה.',
      suppressError: 'לא ניתן להשבית את ההרשמה. נסו שוב.',
      email: 'דוא״ל',
      phone: 'טלפון',
    },
    websiteTemplates: {
      newsletter: {
        enabled: 'הפעלת הרשמה',
        help: 'ההרשמה כבויה כברירת מחדל. פרסמו את השינויים כדי להפעיל אותה בחנות.',
        contactMethods: 'דרכי קשר נתמכות',
        email: 'דוא״ל',
        phone: 'טלפון',
        consentVersion: 'נעשה שימוש בגרסת ההסכמה הנוכחית.',
        invalid: 'בחרו לפחות דרך קשר אחת.',
      },
      runtime: {
        reload: 'טעינת העורך מחדש',
        unsavedWarning: 'השינויים שלא נשמרו יאבדו בטעינה מחדש.',
        reloadFailed: 'העורך עדיין זקוק לגרסה חדשה יותר. נסו מאוחר יותר.',
      },
      fashion: {
        campaignPositionHint:
          'הקמפיין נשאר מקושר לקטגוריה המקורית שלו. הוא מוסתר כשהקטגוריה אינה זמינה או ריקה.',
      },
      richText: {
        hint: 'השאירו שורה ריקה בין פסקאות. התחילו שורה ב- כדי ליצור רשימת תבליטים.',
        lossy: 'בטקסט הזה יש עיצוב שיפושט אם תערכו אותו.',
      },
      gallery: {
        credits: 'קרדיטים לתמונות התבניות',
        title: 'חזית החנות',
        heading: 'בחרו תבנית כדי ליצור את החנות המקוונת שלכם',
        subheading: 'בחרו עיצוב שמתאים לעסק שלכם. אחרי הבחירה תוכלו לערוך את התוכן בקלות.',
        filterLabel: 'סינון תבניות לפי קטגוריה',
        filter: {
          all: 'כל התבניות',
        },
        badge: {
          live: 'פורסם',
          draftSaved: 'טיוטה נשמרה',
          custom: 'עוצב במיוחד לחנות שלכם',
        },
        swatchesLabel: 'צבעי התבנית',
        action: {
          previewDemo: 'תצוגת הדגמה',
          use: 'שימוש בתבנית',
          edit: 'עריכה',
          opening: 'פותח…',
          editNamed: 'עריכה: {{name}}',
          previewDemoNamed: 'תצוגת הדגמה: {{name}}',
          useTemplateNamed: 'שימוש בתבנית: {{name}}',
        },
        loadMore: 'טעינת תבניות נוספות',
        empty: 'אין עדיין תבניות בקטגוריה זו.',
        loadError: 'לא הצלחנו לטעון את התבניות.',
        designUnavailable: 'העיצוב הזה אינו זמין. בחרו תבנית.',
        notStarted: 'בחרו "שימוש בתבנית" כדי להתחיל את העיצוב הזה.',
      },
      category: {
        jewelry: 'תכשיטים',
        fashion: 'אופנה',
        beauty: 'יופי',
        electronics: 'אלקטרוניקה',
        homeLiving: 'בית ומגורים',
        food: 'מזון',
        other: 'אחר',
      },
      common: {
        retry: 'נסו שוב',
        cancel: 'ביטול',
        close: 'סגירה',
      },
      catalog: {
        'luxury-jewelry-v1': {
          title: 'תכשיטי יוקרה',
          description: 'עיצוב תכשיטים בגוני כחול עמוק וזהב, עם חוויית קנייה אחידה.',
        },
        'modern-beauty-v1': {
          title: 'ביוטי מודרני',
          description: 'עיצוב ניטרלי ומרווח למוצרי ביוטי.',
        },
        'editorial-fashion-v1': {
          title: 'אופנה אדיטוריאלית',
          description: 'קולקציות עשירות בתמונות בעיצוב נקי בשחור ולבן.',
        },
        'jewelry-atelier-v1': {
          title: 'תכשיטים',
          description: 'עיצוב אלגנטי ויוקרתי לתכשיטים ולאקססוריז.',
        },
        'apparel-stride-v1': {
          title: 'אופנה',
          description: 'עיצוב נועז לבגדים ולנעליים שמבליט את המידות.',
        },
        legacy: {
          title: 'העיצוב המקורי שלכם',
          description: 'העיצוב שהיה לחנות שלכם לפני התבניות.',
        },
      },
      preview: {
        title: 'תצוגה מקדימה: {{name}}',
        readOnly: 'תצוגה מקדימה בלבד. החנות החיה לא משתנה.',
        useThis: 'שימוש בתבנית זו',
      },
      stage: {
        applying: 'מחיל…',
        title: 'להשתמש ב-{{name}}?',
        carriedOver: 'פריטים שהועברו: {{count}}',
        notCarriedBody: 'לפריטים האלה אין מקום מתאים בתבנית החדשה, ולכן הם לא יופיעו בה.',
        confirm: 'שימוש בתבנית',
        success: 'התבנית נוספה לטיוטה.',
        originalDesignNote: 'העיצוב המקורי שלכם נשאר ברשימת התבניות, כך שתוכלו לחזור אליו.',
      },
      useTemplate: {
        noPublish: 'תיווצר טיוטה בלבד. שום דבר לא יפורסם עד שתלחצו על פרסום.',
      },
      editor: {
        back: 'חזרה',
        status: {
          live: 'פורסם',
          draft: 'טיוטה',
          unpublishedChanges: 'שינויים שלא פורסמו',
        },
        changeTemplate: 'החלפת תבנית',
        editMode: 'מצב עריכה',
        on: 'פועל',
        off: 'כבוי',
        publish: 'פרסום',
        publishChanges: 'פרסום השינויים',
        allPublished: 'כל השינויים פורסמו',
        publishing: 'מפרסם…',
        published: 'השינויים שלך פעילים עכשיו.',
        noChanges: 'אין שינויים שלא פורסמו.',
        publishedStoreHint: 'העיצוב פורסם. האתר יעלה לאוויר אחרי פרסום החנות.',
        unpublished: 'יש לך שינויים שלא פורסמו.',
        device: {
          desktop: 'תצוגת מחשב',
          mobile: 'תצוגת נייד',
        },
        reload: 'רענון',
        openLive: 'צפייה בחנות החיה',
        page: {
          home: 'דף הבית',
          catalog: 'רשימת מוצרים',
          product: 'עמוד מוצר',
          cart: 'עגלה',
          checkout: 'תשלום',
          order: 'אישור הזמנה',
          storeInfo: 'מידע על החנות',
        },
        editHint: 'בחרו בעיפרון כדי לערוך את הפריט.',
        slotMarker: 'עריכת {{label}}',
        storeLanguage: 'שפת החנות',
        legacyNotice: 'החנות הומרה לעיצוב קבוע. חלק מהרכיבים נעולים כעת.',
        legacyReport: 'הצגת פרטי ההמרה',
        unmappable:
          'לא ניתן היה להמיר את העיצוב הנוכחי אוטומטית. החנות החיה לא השתנתה. בחרו תבנית כדי להמשיך לערוך.',
        templateThumbnailAlt: 'התבנית {{name}}',
        more: 'אפשרויות נוספות',
        updateTemplate: 'עדכון התבנית',
        updateTemplateHint: 'גרסה חדשה יותר של העיצוב זמינה. התוכן שלכם נשמר היכן שהוא מתאים.',
        updating: 'מעדכן…',
        updateTemplateDone: 'התבנית עודכנה',
        updateTemplateAllKept: 'כל התוכן שלכם נשמר.',
        save: {
          notSaved: 'לא נשמר — תקנו את השדה המסומן',
          saving: 'שומר…',
          saved: 'כל השינויים נשמרו',
          savedShort: 'נשמר',
          failed: 'לא ניתן לשמור את השינויים',
          retry: 'ניסיון חוזר',
          conflict: 'זה שונה גם בחלון אחר.',
          conflictShort: 'שונה בחלון אחר',
          conflictHelp:
            'השארת הגרסה שלכם טוענת את הטיוטה העדכנית ומציבה מעליה את הטקסט שלכם מהחלון הזה, כך שהשינויים של החלון האחר באותם פריטים יוחלפו.',
          reload: 'השארת הגרסה שלי',
          rejected: 'לא ניתן לשמור פריט אחד',
        },
      },
      report: {
        title: 'פרטי ההמרה',
        mapped: 'פריטים לעריכה: {{count}}',
        frozen: 'פריטים נעולים: {{count}}',
        sourceLanguage: 'הטקסט נשמר מ: {{language}}',
      },
      leave: {
        title: 'השינויים האחרונים שלכם לא נשמרו',
        body: 'אם תצאו עכשיו, הם יאבדו.',
        saving: 'שומר את השינויים לפני היציאה…',
        leave: 'יציאה בלי לשמור',
        retry: 'ניסיון חוזר ויציאה',
        keepMine: 'השארת הגרסה שלי ויציאה',
        stay: 'הישארות',
      },
      dialog: {
        titleEdit: 'עריכת {{label}}',
        useDefault: 'שימוש בטקסט התבנית',
        leaveEmpty: 'השאירו ריק',
        textHelp: 'כתבו בדיוק את מה שהקונים יראו, בכל שפה.',
        charCount: '{{count}} / {{max}}',
        required: 'נדרש לפני פרסום.',
        conflictTitle: 'הטיוטה שונתה במקום אחר',
        conflictBody:
          'גרסה חדשה יותר נשמרה בחלון אחר. הבחירה שלכם כאן נשארת: טענו מחדש כדי להחיל אותה על הגרסה החדשה.',
        reloadDraft: 'טעינת הטיוטה מחדש',
        saveFailed: 'לא הצלחנו לשמור את השינויים. נסו שוב.',
        refreshFailed:
          'השינויים נשמרו, אך לא ניתן לטעון את הטיוטה המעודכנת. טענו מחדש את הטיוטה כדי להמשיך.',
        discardTitle: 'לבטל את השינויים שלא נשמרו?',
        discardBody: 'השינויים בחלון זה לא נשמרו.',
        keepEditing: 'המשך עריכה',
        discard: 'ביטול השינויים',
        done: 'סיום',
      },
      link: {
        shop: 'כל המוצרים',
        sales: 'מבצעים',
        choose: 'בחרו…',
        method: {
          whatsapp: 'וואטסאפ',
          phone: 'טלפון',
          email: 'אימייל',
        },
        label: 'קישור אל',
        none: 'ללא קישור',
        category: 'קטגוריה',
        product: 'מוצר',
        collection: 'אוסף',
        storePage: 'עמוד בחנות',
        contact: 'יצירת קשר',
      },
      ref: {
        noOptions: 'אין עדיין פריטים לבחירה. הוסיפו אותם קודם בקטלוג.',
        chooseCategory: 'בחירת קטגוריה',
        chooseProduct: 'בחירת מוצר',
        chooseCollection: 'בחירת אוסף',
        auto: 'בחירה אוטומטית',
      },
      media: {
        posterFailed: 'לא הצלחנו ליצור תמונת שער מהסרטון. העלו תמונת שער כדי להמשיך.',
        emptyPreview: 'אין מדיה עדיין',
        upload: 'העלאת קובץ',
        limits: {
          image: 'תמונות: JPG, PNG או WebP, עד 5MB.',
          gif: 'GIF: עד 8MB.',
          video: 'וידאו: MP4 או WebM, עד 15 שניות ו-20MB.',
        },
        poster: 'תמונת שער',
        posterHelp: 'מוצגת לפני הפעלת הווידאו וכשמצמצמים תנועה.',
        altRequired: 'הוסיפו תיאור קצר לפני שמירת התמונה',
        alt: 'תיאור לקוראי מסך',
        remove: 'הסרת המדיה הנוכחית',
        uploading: 'מעלה…',
        checking: 'בודק את הקובץ…',
        error: {
          type: 'סוג הקובץ אינו נתמך כאן.',
          mov: 'קובצי MOV אינם נתמכים. ייצאו כ-MP4 (H.264) והעלו שוב.',
          size: 'הקובץ גדול מדי.',
          dimensions: 'מידות התמונה או הווידאו מחוץ לטווח המותר.',
          duration: 'הווידאו ארוך מ-15 שניות.',
          codec: 'פורמט הווידאו אינו נתמך. השתמשו ב-MP4 (H.264) או WebM.',
          metadata: 'הווידאו מכיל מטא-נתונים שלא ניתן להסיר. ייצאו אותו שוב כ-MP4.',
          posterRequired: 'הוסיפו תמונת שער לאנימציה או לווידאו.',
          generic: 'ההעלאה נכשלה. נסו שוב.',
          corrupt: 'הקובץ פגום או שלא ניתן לפתוח אותו.',
        },
        current: 'המדיה הנוכחית',
        uploadImageOrVideo: 'העלאת תמונה או וידאו',
        uploadImage: 'העלאת תמונה',
        dropHint: 'או גררו קובץ לכאן',
        help: {
          imageOrVideo: 'העלו תמונה באיכות גבוהה או סרטון קצר שמתנגן בלולאה.',
          image: 'העלו תמונה באיכות גבוהה.',
        },
        progress: 'מעלה… {{percent}}%',
        posterAuto: 'יצרנו תמונת שער מהסרטון. אפשר להחליף אותה.',
        replacePoster: 'החלפת תמונת השער',
        useTemplateImage: 'שימוש בתמונת התבנית',
        framing: {
          title: 'מיקום וזום',
          desktop: 'מחשב',
          mobile: 'נייד',
          zoom: 'זום',
          zoomIn: 'הגדלה',
          zoomOut: 'הקטנה',
          reset: 'איפוס',
          apply: 'החלה',
          dragHint: 'גררו כדי למקם. השתמשו במקשי החצים להזזה עדינה.',
          position: 'המיקום בתוך המסגרת',
          positionStatus: 'אופקי {{x}}%, אנכי {{y}}%, זום {{zoom}}×',
          previewNote: 'בחנות המסגרת יכולה להשתנות מעט לפי גודל המסך והטקסט.',
          defaultHint: 'העלו תמונה משלכם כדי לכוונן את מיקומה',
          unappliedTitle: 'המיקום החדש לא הוחל',
          unappliedBody: 'לחצו על החלה כדי לשמור את המיקום והזום ששיניתם, או צאו בלעדיהם.',
          leaveUnapplied: 'יציאה בלי להחיל',
        },
      },
      locale: {
        title: 'שפת החנות',
        help: 'הכפתורים, העגלה, התשלום וההודעות בחנות יוצגו בשפה זו. הטקסטים שלכם נשארים בדיוק כפי שנכתבו.',
        independent: 'זה לא משנה את שפת לוח הבקרה.',
        ar: 'العربية',
        he: 'עברית',
        en: 'English',
        save: 'שמירה',
        saving: 'שומר…',
      },
      readiness: {
        missingMerchantValue: '{{label}} דורש טקסט משלכם.',
        missingRequired: '{{label}} נדרש.',
        invalidMedia: '{{label}}: הקובץ כבר לא זמין.',
        invalidReference: '{{label}}: הפריט המקושר כבר לא זמין.',
        missingLogo: 'העלו לוגו לחנות לפני פרסום.',
        goTo: 'מעבר לפריט',
      },
      publish: {
        titleDesign: 'לפרסם את {{name}}?',
        titleChanges: 'לפרסם את השינויים ב-{{name}}?',
        titleOriginal: 'לפרסם את העיצוב הזה?',
        bodyChanges: 'הקונים יראו את השינויים האחרונים שנשמרו ב-{{name}}.',
        bodyFirst: 'לחנות שלכם עדיין אין עיצוב פעיל. הקונים יראו את {{name}}.',
        bodyFirstStoreOffline:
          'לחנות שלכם עדיין אין עיצוב פעיל. הקונים יראו את {{name}} אחרי שתפרסמו את החנות.',
        bodyReplace: 'הקונים יראו את {{name}} במקום {{live}}. הטיוטה של {{live}} נשארת שמורה.',
        bodyReplaceUnknown: 'הקונים יראו את {{name}} במקום העיצוב שפעיל עכשיו.',
        bodyReplaceOriginal:
          'העיצוב הזה יחליף את העיצוב שהחנות מציגה עכשיו. הקונים יראו את העיצוב הזה.',
        stale: 'חזית החנות השתנתה בהפעלה אחרת. רעננו ונסו שוב.',
        title: 'לפרסם את השינויים בחזית החנות?',
        body: 'השינויים השמורים בחזית החנות יוצגו ללקוחות.',
        confirm: 'פרסום',
        failed: 'הפרסום נכשל. לא השתנה דבר בחנות החיה.',
        checking: 'בודקים את חזית החנות…',
        fixFirst: 'תקנו את הפריטים האלה לפני הפרסום:',
        successTitle: 'חזית החנות פורסמה',
        viewLive: 'צפייה בחנות החיה',
        goToSettings: 'מעבר להגדרות החנות',
        goToStorePublish: 'מעבר לפרסום החנות',
        warningsTitle: 'דברים שכדאי לתקן',
        warningsIntro: 'אפשר לפרסם עכשיו. כדאי לתקן את אלה, אבל הם לא חוסמים פרסום.',
        warningsToggle: 'הצג פרטים',
        warningsToggleHide: 'הסתר פרטים',
        publishAnyway: 'פרסם בכל זאת',
        flushFirst: 'עדיין לא ניתן לשמור את השינויים האחרונים. נסו שוב.',
        adsNotice:
          'המודעות הפעילות שלך מופיעות רק בעמוד החנות הנוכחי, והעיצוב הזה לא יציג אותן. שום דבר לא יימחק.',
      },
      issue: {
        missingStoreLogo: {
          warning: 'הוסף לוגו לחנות בהגדרות',
        },
        invalidReference: {
          warning: 'קישור מפנה לפריט שאינו זמין עוד',
          warningNamed: '{{label}}: הקישור מפנה לפריט שאינו זמין עוד',
        },
        missingMerchantValue: {
          warning: '{{label}} עדיין ללא טקסט',
        },
      },
      errors: {
        builderRetired: 'עורך העיצוב הישן אינו זמין עוד. השתמשו בעורך האתר.',
        slotRetired: 'פריט זה מנוהל מהעמוד שלו.',
        templateUnavailable: 'תבנית זו כבר אינה זמינה.',
        invalidValue: 'לא ניתן לשמור ערך זה. בדקו ונסו שוב.',
        unsafeText: 'הסירו תווי כיוון או בקרה מוסתרים ונסו שוב.',
        tooLong: 'הטקסט ארוך מדי.',
        rateLimited: 'יותר מדי שמירות. המתינו רגע ונסו שוב.',
        generic: 'משהו השתבש. נסו שוב.',
      },
      slot: {
        mission: {
          body: 'טקסט מסר החנות',
          ctaLabel: 'טקסט קישור המסר',
          ctaLink: 'יעד קישור המסר',
        },
        community: {
          heading: 'כותרת הקהילה',
          media: 'תמונה או סרטון של הקהילה',
          ctaLabel: 'טקסט קישור הקהילה',
          ctaLink: 'יעד קישור הקהילה',
        },
        newsletter: {
          heading: 'כותרת ההרשמה',
          body: 'טקסט ההרשמה',
          collection: 'הגדרות הרשמה',
        },

        announcement: {
          text: 'הודעה',
        },
        brand: {
          tagline: 'סלוגן',
        },
        hero: {
          heading: 'כותרת ראשית',
          subheading: 'כותרת משנה',
          ctaLabel: 'טקסט הכפתור',
          ctaLink: 'קישור הכפתור',
          media: 'תמונה או וידאו ראשי',
        },
        category: {
          tile: 'אריח קטגוריה',
          tileImage: 'תמונת אריח קטגוריה',
        },
        section: {
          heading: 'כותרת המקטע',
          body: 'טקסט המקטע',
        },
        feature: {
          title: 'כותרת הדגשה',
          body: 'טקסט הדגשה',
        },
        promo: {
          heading: 'כותרת הבאנר',
          body: 'טקסט הבאנר',
          media: 'תמונה או וידאו לבאנר',
          ctaLabel: 'טקסט כפתור הבאנר',
          ctaLink: 'קישור כפתור הבאנר',
        },
        about: {
          heading: 'כותרת "אודות"',
          body: 'אודות החנות',
          media: 'תמונת "אודות"',
        },
        policy: {
          delivery: 'מדיניות משלוחים',
          returns: 'מדיניות החזרות',
        },
        contact: {
          note: 'הערת יצירת קשר',
        },
        product: {
          careNote: 'הוראות טיפול',
          sizeGuide: 'מדריך מידות',
        },
        cart: {
          note: 'הערה בעגלה',
        },
        checkout: {
          note: 'הערה בתשלום',
        },
        confirmation: {
          message: 'הודעת תודה',
        },
        footer: {
          note: 'טקסט תחתון',
        },
        legacy: {
          text: 'טקסט',
          media: 'תמונה',
        },
        ordinal: '{{label}} {{n}}',
      },
      frame: {
        viewport: 'גודל התצוגה',
        toolbar: 'פקדי חזית החנות',
        back: 'הדף הקודם',
        forward: 'הדף הבא',
        address: 'כתובת הדף הנוכחי',
        loading: 'טוען את חזית החנות…',
        loadError: 'לא הצלחנו לטעון את חזית החנות.',
        openLiveUnavailable: 'פרסמו קודם את חזית החנות כדי לצפות בה בשידור חי.',
        resetNotice: 'טענו מחדש את תצוגת חזית החנות. השינויים השמורים נשארו.',
        draftCartNote: 'פריטים שתוסיפו לעגלה כאן הם לניסיון בלבד. לא נוצרות הזמנות.',
      },
      overlay: {
        moreItems: 'פריטים נוספים לעריכה',
        regionListTitle: 'פריטים לעריכה בדף זה',
      },
      region: {
        newsletterCollection: {
          label: 'הגדרות הרשמה',
          edit: 'עריכת הגדרות הרשמה',
        },
        heroText: {
          label: 'טקסט הבאנר הראשי',
          edit: 'עריכת טקסט הבאנר הראשי',
        },
        heroMedia: {
          label: 'תמונה או וידאו של הבאנר הראשי',
          edit: 'עריכת המדיה של הבאנר הראשי',
        },
        heroMediaMobile: {
          label: 'מדיית הכותרת (נייד)',
          edit: 'עריכת מדיית הכותרת (נייד)',
        },
        heroMediaDesktop: {
          label: 'מדיית הכותרת (מחשב)',
          edit: 'עריכת מדיית הכותרת (מחשב)',
        },
        promoText: {
          label: 'טקסט הבאנר',
          edit: 'עריכת טקסט הבאנר',
        },
        promoMedia: {
          label: 'תמונה או וידאו של הבאנר',
          edit: 'עריכת המדיה של הבאנר',
        },
        aboutText: {
          label: 'טקסט "אודות"',
          edit: 'עריכת טקסט "אודות"',
        },
        aboutMedia: {
          label: 'תמונת "אודות"',
          edit: 'עריכת תמונת "אודות"',
        },
        categoryImage: {
          label: 'תמונת קטגוריה',
          edit: 'עריכת תמונת הקטגוריה',
        },
        categoryTile: {
          label: 'הקטגוריה המוצגת',
          edit: 'בחירת הקטגוריה המוצגת',
        },
        categoriesHeading: {
          label: 'כותרת הקטגוריות',
          edit: 'עריכת כותרת הקטגוריות',
        },
        sectionHeading: {
          label: 'כותרת המקטע',
          edit: 'עריכת כותרת המקטע',
        },
        sectionText: {
          label: 'טקסט המקטע',
          edit: 'עריכת טקסט המקטע',
        },
        featureText: {
          label: 'טקסט ההדגשה',
          edit: 'עריכת טקסט ההדגשה',
        },
        announcement: {
          label: 'פס ההודעות',
          edit: 'עריכת פס ההודעות',
        },
        tagline: {
          label: 'הסלוגן של החנות',
          edit: 'עריכת הסלוגן של החנות',
        },
        footerText: {
          label: 'הטקסט התחתון',
          edit: 'עריכת הטקסט התחתון',
        },
        storeDetails: {
          label: 'פרטי החנות',
          edit: 'עריכת פרטי החנות',
        },
        storeAbout: {
          label: 'אודות החנות',
          edit: 'עריכת "אודות החנות"',
        },
        deliveryPolicy: {
          label: 'מדיניות משלוחים',
          edit: 'עריכת מדיניות המשלוחים',
        },
        returnsPolicy: {
          label: 'מדיניות החזרות',
          edit: 'עריכת מדיניות ההחזרות',
        },
        productCare: {
          label: 'הוראות טיפול',
          edit: 'עריכת הוראות הטיפול',
        },
        productSizeGuide: {
          label: 'מדריך מידות',
          edit: 'עריכת מדריך המידות',
        },
        cartNote: {
          label: 'הערה בעגלה',
          edit: 'עריכת ההערה בעגלה',
        },
        checkoutNote: {
          label: 'הערה בתשלום',
          edit: 'עריכת ההערה בתשלום',
        },
        thankYouMessage: {
          label: 'הודעת תודה',
          edit: 'עריכת הודעת התודה',
        },
        legacyText: {
          label: 'טקסט',
          edit: 'עריכת הטקסט',
        },
        legacyMedia: {
          label: 'תמונה',
          edit: 'עריכת התמונה',
        },
      },
    },
    storefrontEngine: {
      sections: {
        hero: {
          name: 'מדור הירו',
          description: 'מציג את האזור הראשון שהקונים רואים בחנות.',
        },
        header: {
          name: 'כותרת החנות',
          description: 'מציגה את לוגו החנות והניווט הראשי.',
        },
        footer: {
          name: 'תחתית החנות',
          description: 'מציגה את סימון דוקנתי וקישורי יצירת קשר זמינים.',
        },
        mobileNav: {
          name: 'ניווט במובייל',
          description: 'מציג קישורי ניווט מהירים בתחתית המסך.',
        },
        announcementBar: {
          name: 'רצועת ההודעות',
          description: 'מציגה הודעה קצרה מעל כותרת החנות עם קישור אופציונלי.',
        },
        trustBadge: {
          name: 'תג אמון',
          description: 'מציג תקציר דירוגים ליד כותרת העמוד.',
        },
        promotionalAds: {
          name: 'מודעות החנות',
          description: 'מציגה מודעות פעילות של החנות.',
        },
        categories: {
          name: 'קטגוריות',
          description: 'מציגה קטגוריות שיש בהן מוצרים מפורסמים.',
        },
        benefits: {
          name: 'יתרונות החנות',
          description: 'מציג יתרונות שהסוחר כתב עם סמלי אייקון מאושרים.',
        },
        faq: {
          name: 'שאלות נפוצות',
          description: 'מציג שאלות ותשובות שהסוחר כתב.',
        },
        about: {
          name: 'על החנות',
          description: 'מציג פסקאות חנות מתורגמות שהסוחר כתב.',
        },
        testimonials: {
          name: 'המלצות כתובות',
          description: 'מציג ציטוטים שהסוחר כתב ללא נתוני לקוחות או הזמנות.',
        },
        newsletterCta: {
          name: 'קריאה לניוזלטר',
          description: 'מציג קריאה בטוחה ואיסוף פרטי קשר בהסכמה כשהוא מופעל.',
        },
        liveOffers: {
          name: 'מבצעים פעילים',
          description: 'מציגה קמפיינים פעילים של מבצעים.',
        },
        productRail: {
          bestSellers: {
            name: 'הנמכרים ביותר',
            description: 'מציגה את המוצרים שהוזמנו הכי הרבה.',
          },
          trendingNow: {
            name: 'פופולרי עכשיו',
            description: 'מציגה מוצרים פופולריים לאחרונה.',
          },
          newArrivals: {
            name: 'חדש בחנות',
            description: 'מציגה את המוצרים החדשים שפורסמו.',
          },
          specialOffers: {
            name: 'מבצעים מיוחדים',
            description: 'מציגה מוצרים במחיר מבצע.',
          },
          customCollection: {
            name: 'אוסף מותאם',
            description: 'מציג אוסף מוצרים מסודר שהסוחר בחר.',
          },
        },
        trustSummary: {
          name: 'סיכום אמון',
          description: 'מציג סיכום רחב יותר של ביקורות.',
        },
        editorialBanner: {
          name: 'באנר עריכתי',
          description:
            'מציג תמונה, כותרת, טקסט וקריאה לפעולה שכתב בעל החנות כדי לשבור את קצב העמוד.',
        },
      },
      lifecycle: {
        duplicate: 'שכפול {{section}}',
        restore: 'שחזור {{section}}',
        add: {
          open: 'הוספת מדור',
          title: 'הוספת מדור',
          description: 'בחרו מדור בית נתמך כדי להכין אותו לטיוטה הזו.',
          empty: 'אין מדורים שאפשר להוסיף כרגע.',
          insertion: {
            afterSelected: 'נוסף אחרי {{section}}.',
            atPlacement: 'נוסף אל {{placement}}.',
          },
        },
        delete: {
          open: 'מחיקת {{section}}',
          title: 'מחיקת מדור',
          description: 'מחקו את {{section}} מהטיוטה הזו. המדור נשמר לשחזור עד שתפרסמו שינוי נוסף.',
          confirm: 'מחיקת מדור',
        },
        pending: {
          ready:
            'שינוי מחזור חיים הוכן. החל כדי לעדכן את הקנבס החי, או בטל כדי להשאיר את העמוד הנוכחי.',
          apply: 'החל',
          cancel: 'בטל',
          applied: 'שינוי מחזור החיים הוחל.',
          cancelled: 'שינוי מחזור החיים בוטל.',
          blocking: 'החל או בטל את שינוי מחזור החיים לפני שממשיכים.',
        },
      },
      inlineEditor: {
        launch: {
          open: 'פתחו עורך ישיר',
          description: 'השתמשו בקנבס חנות מלא כדי לערוך מדורים ישירות.',
        },
        toolbar: {
          label: 'סרגל כלים של עורך החנות הישיר',
          backToBuilder: 'חזרה לבילדר',
          navigationControls: 'ניווט העורך',
          statusControls: 'מצב העורך',
          deviceControls: 'מכשיר תצוגה מקדימה',
          zoomControls: 'בקרות זום',
          sectionControls: 'פקדי מדור',
          historyControls: 'פקדי היסטוריה',
          releaseControls: 'פקדי טיוטה ופרסום',
          openSettings: 'עריכת הגדרות',
          openQuickPresentation: 'תצוגה מהירה',
          addSection: 'הוספת מדור',
        },
        inspector: {
          title: 'לוח מדור',
          description: 'עריכת {{section}}.',
          emptyTitle: 'לא נבחר מדור',
          emptyBody: 'בחרו מדור בחנות כדי לערוך אותו.',
          readOnlyTitle: 'מדור לקריאה בלבד',
        },
      },
      v3: {
        shell: {
          ariaLabel: 'עורך Storefront Builder V3',
          panelDrawer: 'לוח הבילדר',
          panelDrawerDescription: 'עריכת אזור הבילדר שנבחר במגירה קומפקטית.',
          inspectorDrawer: 'לוח מקטע',
          inspectorDrawerDescription: 'עריכת המקטע שנבחר במגירת לוח קומפקטית.',
        },
        rail: {
          ariaLabel: 'אזורי הבילדר',
          templates: 'תבניות',
          design: 'עיצוב',
          sections: 'מקטעים',
          settings: 'הגדרות',
        },
        toolbar: {
          dukantiIdentity: 'Dukanti',
          storefrontIdentity: 'חזית החנות',
          back: 'חזרה לחזית החנות',
          publish: 'פרסום',
          undo: 'בטל',
          redo: 'בצע שוב',
          deviceGroup: 'מכשיר קנבס',
          status: {
            draft: 'טיוטה',
            published: 'פורסם',
          },
        },
        autosave: {
          idle: 'מוכן',
          dirty: 'שינויים שלא נשמרו',
          debouncing: 'יישמר בקרוב',
          saving: 'שומר...',
          saved: 'כל השינויים נשמרו',
          failed: 'לא ניתן לשמור',
          conflict: 'נדרש רענון',
          blocked: 'הפרסום חסום',
          details: {
            idle: 'הטיוטה מוכנה.',
            dirty: 'השינויים ממתינים לשמירה כטיוטה.',
            debouncing: 'הטיוטה תישמר בעוד רגע.',
            saving: 'הטיוטה הזו נשמרת לפני כל פרסום.',
            saved: 'הטיוטה נשמרה. החנות החיה לא השתנתה.',
            failed: 'העריכות המקומיות שלך עדיין כאן.',
            conflict: 'טענו את הטיוטה האחרונה לפני פרסום.',
            blocked: 'תקנו את השדות המסומנים לפני פרסום.',
          },
        },
        templates: {
          title: 'תבניות',
          description: 'התחילו מחזית חנות שמתאימה לסוג העסק, ואז כוונו את העיצוב והמקטעים.',
          categoriesTitle: 'סוגי עסקים',
          allCategories: 'הכל',
          results: {
            all: 'תבניות זמינות: {{count}}',
            category: 'תבניות {{category}}: {{count}}',
            allDescription: 'בחרו סוג עסק, בדקו את ההתאמה ואז החילו על הטיוטה הזו.',
          },
          metadata: {
            intent: 'מטרה: {{intent}}',
            themePreset: 'סגנון: {{theme}}',
          },
          actions: {
            apply: 'החל',
            applied: 'הוחל',
            save: 'שמור תבנית נוכחית',
            delete: 'מחק {{name}}',
          },
          intent: {
            quickStart: 'התחלה מהירה',
            campaign: 'מבוסס קמפיין',
            trust: 'מבוסס אמון',
            catalog: 'מבוסס קטלוג',
            story: 'מבוסס סיפור',
            education: 'מבוסס הדרכה',
            comparison: 'מבוסס השוואה',
            inspiration: 'מבוסס השראה',
            repeatPurchase: 'לקניה חוזרת',
            freshness: 'טרי היום',
            occasion: 'מבוסס אירוע',
            consultation: 'מבוסס ייעוץ',
          },
          categories: {
            starter: {
              name: 'התחלה כללית',
              description: 'חזיתות מאוזנות לסוחרים שרוצים פתיחה מוכנה.',
            },
            seasonal: {
              name: 'עונתי',
              description: 'פריסות שמובילות מבצעי קיץ, חורף וקמפיינים.',
            },
            story: {
              name: 'סיפור החנות',
              description: 'חזיתות עריכתיות למלאכה, זהות ובניית אמון.',
            },
            'jewellery-accessories': {
              name: 'תכשיטים ואביזרים',
              description: 'תבניות אמון לטבעות, מתנות, שעונים ואביזרים.',
            },
            fashion: {
              name: 'אופנה',
              description: 'גלישה מהירה לביגוד, נעליים ובוטיקים.',
            },
            'beauty-wellness': {
              name: 'יופי וטיפוח',
              description: 'פריסות לפי שגרה לטיפוח, קוסמטיקה ובריאות.',
            },
            electronics: {
              name: 'אלקטרוניקה',
              description: 'פריסות נוחות להשוואת מכשירים, אביזרים ומפרטים.',
            },
            'home-decor': {
              name: 'בית ועיצוב',
              description: 'פריסות השראה לעיצוב, רהיטים ומוצרי בית.',
            },
            'food-grocery': {
              name: 'מזון ומכולת',
              description: 'פריסות צפופות לקניות יומיומיות ומבצעים חוזרים.',
            },
            'bakery-prepared-food': {
              name: 'מאפים ואוכל מוכן',
              description: 'פריסות טריות למאפיות, מטבחים ותפריטי היום.',
            },
            gifts: {
              name: 'מתנות',
              description: 'תבניות לפי אירוע למתנות ומארזים אצורים.',
            },
            services: {
              name: 'שירותים',
              description: 'פריסות אמון וייעוץ לשירותים, תורים וסטודיו.',
            },
          },
          saved: {
            title: 'תבניות שמורות',
            description: 'שמרו את הטיוטה הנוכחית והשתמשו בה שוב לעונות, סניפים או קמפיינים.',
            label: 'שמרו תבנית משלכם',
            placeholder: 'לדוגמה: חורף 2027',
            savedTitle: 'התבניות השמורות שלכם',
            loading: 'טוען תבניות שמורות...',
            empty: 'עדיין אין תבניות שמורות.',
            updatedAt: 'עודכן {{value}}',
          },
          messages: {
            applied: 'התבנית הוחלה על הטיוטה.',
            saved: 'התבנית נשמרה.',
            deleted: 'התבנית השמורה נמחקה.',
            notFound: 'התבנית השמורה הזו כבר לא זמינה.',
            applyFailed: 'לא ניתן להחיל את התבנית הזו.',
            saveFailed: 'לא ניתן לשמור את התבנית הזו.',
            deleteFailed: 'לא ניתן למחוק את התבנית הזו.',
          },
        },
        design: {
          title: 'עיצוב',
          description: 'עצבו את המראה והתחושה של חזית החנות.',
          themeSummary: 'העיצוב הנוכחי',
          chooseTheme: 'בחירת ערכת עיצוב',
          colorOption: '{{role}}: {{color}}',
          baseSize: 'גודל בסיס',
          baseSizeOptions: {
            compact: 'קומפקטי',
            comfortable: 'נוח',
            large: 'גדול',
          },
          groups: {
            theme: 'ערכת עיצוב',
            colors: 'צבעים',
            typography: 'טיפוגרפיה',
            buttons: 'כפתורים',
            cards: 'כרטיסים',
            spacing: 'מרווחים',
          },
          defaults: {
            title: 'עיצובים מוכנים',
            description: 'התחילו מעיצוב חנות מלא או שמרו את הטיוטה הזו לשימוש חוזר.',
            actions: {
              apply: 'החל',
              save: 'שמור עיצוב נוכחי',
              delete: 'מחק {{name}}',
            },
            tags: {
              balanced: 'מאוזן',
              quickStart: 'התחלה מהירה',
              seasonal: 'עונתי',
              offers: 'מבצעים',
              trust: 'אמון',
              catalog: 'קטלוג',
              compact: 'קומפקטי',
              story: 'סיפור',
              spacious: 'מרווח',
              editorial: 'עריכתי',
              newArrivals: 'חדש בחנות',
              specs: 'מפרטים',
            },
            items: {
              'dukanti-starter': {
                name: 'התחלת Dukanti',
                description: 'חזית חנות מאוזנת למכירה יומיומית עם מקטעים מוכרים.',
              },
              'summer-market': {
                name: 'שוק קיץ',
                description: 'פריסה בהירה שמקדמת מבצעים וקמפיינים עונתיים.',
              },
              'winter-warmth': {
                name: 'חום חורפי',
                description: 'מקטעי סיפור ואמון חמים יותר לגלישה עונתית רגועה.',
              },
              'boutique-catalog': {
                name: 'קטלוג בוטיק',
                description: 'גרידי מוצרים קומפקטיים לחנויות שרוצות גלישה מהירה.',
              },
              'galilee-story': {
                name: 'סיפור גלילי',
                description: 'זרימה מרווחת ועריכתית לחנויות שמובילות עם מלאכה וזהות.',
              },
              'jewellery-atelier': {
                name: 'אטלייה תכשיטים',
                description: 'חזית אמון לטבעות, שעונים, מתנות ואביזרים.',
              },
              'fashion-boutique': {
                name: 'בוטיק אופנה',
                description: 'גלישה עונתית מהירה לביגוד, נעליים וקולקציות אביזרים.',
              },
              'beauty-care': {
                name: 'יופי וטיפוח',
                description: 'זרימה לפי שגרה לטיפוח עור, קוסמטיקה ומוצרי בריאות.',
              },
              'electronics-hub': {
                name: 'מרכז אלקטרוניקה',
                description: 'חזית נוחה להשוואת מכשירים, אביזרים ומבצעים.',
              },
              'home-decor': {
                name: 'עיצוב הבית',
                description: 'זרימת השראה עריכתית לעיצוב, רהיטים ומוצרי בית.',
              },
              'food-grocery': {
                name: 'מזון ומכולת',
                description: 'פריסה צפופה לצרכים יומיומיים ולקניות חוזרות.',
              },
              'bakery-kitchen': {
                name: 'מאפייה ומטבח',
                description: 'חזית טריות למאפיות, מטבחים ותפריטי היום.',
              },
              'gift-shop': {
                name: 'חנות מתנות',
                description: 'גלישה לפי אירוע למתנות, מארזים וקולקציות אצורות.',
              },
              'service-studio': {
                name: 'סטודיו שירותים',
                description: 'חזית אמון ושאלות נפוצות לשירותים, תורים וייעוצים.',
              },
            },
            custom: {
              label: 'שמרו משלכם',
              placeholder: 'לדוגמה: חורף 2027',
              savedTitle: 'עיצובים שמורים',
              loading: 'טוען עיצובים שמורים...',
              empty: 'עדיין אין עיצובים שמורים.',
              updatedAt: 'עודכן {{value}}',
            },
            messages: {
              applied: 'העיצוב המוכן הוחל על הטיוטה.',
              saved: 'העיצוב המוכן נשמר.',
              deleted: 'העיצוב השמור נמחק.',
              notFound: 'העיצוב השמור הזה כבר לא זמין.',
              applyFailed: 'לא ניתן להחיל את העיצוב המוכן הזה.',
              saveFailed: 'לא ניתן לשמור את העיצוב המוכן הזה.',
              deleteFailed: 'לא ניתן למחוק את העיצוב המוכן הזה.',
            },
          },
        },
        sections: {
          title: 'מקטעים',
          description: 'שליטה במבנה הדף, בנראות ובנקודות ההוספה.',
          add: 'הוספת מקטע',
          empty: 'אין מקטעים זמינים לדף הזה.',
          alwaysVisible: 'תמיד גלוי',
          more: 'פעולות נוספות עבור {{section}}',
          reorder: 'סידור מחדש של {{section}}. גררו או השתמשו בחץ למעלה ובחץ למטה.',
        },
        settings: {
          title: 'הגדרות',
          description: 'עריכת ניווט, חיפוש ושיתוף בחזית החנות.',
          navigation: 'ניווט',
          seo: 'חיפוש ושיתוף',
          autosaveReady: 'השינויים נשמרים אוטומטית אחרי כל עריכה תקינה.',
          invalidLocalBuffers: 'תקנו את השדה המסומן לפני שהשמירה האוטומטית יכולה להמשיך.',
        },
        gallery: {
          title: 'הוספת מקטע',
          description: 'בחרו מקטע לדף החנות הזה.',
          searchPlaceholder: 'חיפוש מקטעים',
          categoryAriaLabel: 'קטגוריות מקטעים',
          empty: 'אין מקטעים שמתאימים לקטגוריה הזו.',
          summary: {
            all: 'סוגי מקטעים זמינים: {{count}}',
            category: 'מקטעי {{category}}: {{count}}',
            search: 'תוצאות חיפוש: {{count}}',
          },
          status: {
            available: 'זמין להוספה',
            blocked: 'לא זמין כאן',
          },
          categoryDescriptions: {
            all: 'עיינו בכל סוגי המקטעים הנתמכים לטיוטה הזו.',
            featured: 'התחילו ממקטעי זהות החנות המרכזיים.',
            products: 'הוסיפו מסילות מוצרים שמשתמשות במקורות מוצר ציבוריים.',
            categories: 'הוסיפו מקטעי גילוי קטגוריות המבוססים על קטגוריות ציבוריות.',
            marketing: 'הוסיפו מקטעי מבצעים וקידום לפי חוזי הקמפיינים הקיימים.',
            content: 'הוסיפו מקטעי סיפור, אמון, שאלות נפוצות, ניוזלטר ותוכן עריכתי.',
            trust: 'הוסיפו מקטעי הוכחה שמסכמים סימני אמון גלויים לקונים.',
            global: 'בדקו מקטעי כרום גלובליים שנשלטים על ידי חוזי הבילדר.',
            layout: 'הוסיפו מקטעים מבניים רק כשהעמוד הנוכחי תומך בהם.',
            advanced: 'סוגי מקטעים מתקדמים נשארים מוגבלים על ידי אותם חוזי חנות.',
          },
          categories: {
            all: 'כל המקטעים',
            featured: 'מומלצים',
            products: 'מוצרים',
            categories: 'קטגוריות',
            marketing: 'שיווק',
            content: 'תוכן',
            trust: 'אמון',
            global: 'גלובלי',
            layout: 'פריסה',
            advanced: 'מתקדם',
          },
        },
        inspector: {
          close: 'סגור לוח עריכה',
          tabList: 'קבוצות הגדרות הלוח',
          tabs: {
            content: 'תוכן',
            design: 'עיצוב',
            settings: 'הגדרות',
          },
          empty: {
            title: 'בחרו מקטע לעריכה',
            body: 'בחרו מקטע בקנבס החנות האמיתי או ברשימת המבנה.',
          },
          hero: {
            kicker: 'מקטע הירו',
            mediaTitle: 'מדיית הירו',
            mediaHelp: 'בחרו קודם תמונת מחשב, ואז הוסיפו חיתוך למובייל כשהוא משפר את הקומפוזיציה.',
            desktopRecommendation: 'תמונת מחשב מומלצת: 1440 × 720 פיקסלים, חיתוך רחב.',
            mobileRecommendation: 'תמונת מובייל מומלצת: 900 × 1200 פיקסלים, חיתוך מרכזי.',
            mobileCrop: 'חיתוך מובייל אופציונלי',
            mediaSelected: 'נבחרה תמונה',
            mediaAvailable: 'זמינה לתמונת הירו זו',
            mediaUnavailable: 'בחרו תמונה אחרת למקטע ההירו הזה.',
            mediaCurrent: 'תמונת הירו הנוכחית',
            mediaMissing: 'עדיין לא נבחרה תמונה.',
            noImage: 'לא נבחרה תמונה',
            browseLibrary: 'עיון בספריית התמונות',
            changeImage: 'החלפת תמונה',
            mediaUploadHint: 'JPEG, PNG או WebP. עד 5MB ו-4096 פיקסלים.',
            copyTitle: 'טקסט מתורגם',
            copyHelp: 'ערכו שפה אחת בכל פעם. ערבית, עברית ואנגלית נשארות יחד בשקופית הזו.',
            localeTabs: 'שפות תוכן הירו',
            characterCount: '{{count}} / {{max}} תווים',
            previewLabel: 'תצוגת פריסה',
            scheduleTimezone: 'השעות מוצגות לפי שעון ישראל ונשמרות כ-UTC.',
            scheduleInvalid: 'יש להזין תאריך ושעה מלאים לפני שמירת התזמון.',
            specificCategoryHelp:
              'הכפתור מקשר לקטגוריה שנבחרה. החליפו קטגוריה מתוך בורר הקטגוריות כשהפקד זמין.',
            selectedCategory: 'קטגוריה שנבחרה: {{category}}',
            categorySearch: 'חיפוש קטגוריות',
            title: 'תוכן הירו',
            description: 'עריכת מדיה, טקסט ופעולות הירו.',
          },
        },
        overlay: {
          editShort: 'עריכה',
          edit: 'עריכת {{section}}',
          drag: 'גרירת {{section}}',
          more: 'פעולות נוספות עבור {{section}}',
          addAfter: 'הוספת מקטע אחרי {{section}}',
        },
        publish: {
          readyTitle: 'מוכן לפרסום',
          readyDescription: 'פרסמו את הטיוטה השמורה האחרונה לחנות החיה.',
          blockedTitle: 'תקנו {{count}} בעיות לפני הפרסום',
          blockedDescription: 'עברו על כל בעיה, ואז פרסמו כשהטיוטה מוכנה.',
          failedTitle: 'הפרסום נכשל',
          failedRetry: 'הפרסום נכשל. שום דבר לא השתנה בחנות החיה.',
          publishedTitle: 'החנות פורסמה',
          publishedDescription: 'חזית החנות החיה משקפת עכשיו את הטיוטה הזו.',
          confirm: 'פרסום החנות',
          copyLink: 'העתקת קישור לחנות',
          viewLiveStore: 'צפייה בחנות החיה',
          noBlockingIssues: 'לא נמצאו בעיות שמונעות פרסום.',
          summary: {
            store: 'חנות',
            link: 'קישור לחנות',
            sections: 'מקטעים',
            sectionCount: '{{count}} מקטעים',
            devices: 'תצוגות זמינות',
            deviceViews: 'מחשב, טאבלט, טלפון',
            impact: 'השפעה על החנות החיה',
          },
          impact: {
            ready: 'שום דבר לא משתנה לקונים עד לאישור.',
            blocked: 'החנות החיה נשארת ללא שינוי בזמן תיקון הבעיות.',
            savingDraft: 'הטיוטה הזו נשמרת קודם; הקונים עדיין רואים את החנות החיה הנוכחית.',
            validating: 'בודקים תוכן ציבורי בטוח לפני שמשהו עולה לאוויר.',
            publishing: 'הפרסום מחליף עכשיו את החנות החיה.',
            published: 'קונים יכולים לראות עכשיו את הטיוטה שפורסמה.',
            failed: 'הטיוטה השמורה עדיין זמינה; החנות החיה לא השתנתה.',
          },
          issue: {
            hero: 'מקטע הירו',
            fixHero: 'הוסיפו תוכן הירו לפני הפרסום.',
          },
        },
        errors: {
          validationFailed: 'תקנו את השדה המסומן לפני שהשמירה האוטומטית תמשיך.',
        },
        conflict: {
          replaceLocalChanges: 'לטעון את הגרסה האחרונה שנשמרה לחנות? השינויים המקומיים שלך יימחקו.',
          staleDraft: 'הטיוטה השתנתה במקום אחר. רעננו לפני פרסום.',
        },
      },
      builder: {
        title: 'חזית החנות',
        subtitle: 'סדרו את מדורי דף הבית ובחרו מה יוצג לקונים.',
        sectionListTitle: 'מדורי דף הבית',
        source: {
          draft: 'עורכים טיוטה שמורה',
          published: 'עורכים את הגרסה שפורסמה',
          default: 'עורכים את ברירת המחדל',
        },
        sourceDescriptors: {
          cardTitle: 'מקור',
          workspaceTitle: 'הנחיות מקור',
          metrics: {
            selectedCount: '{{count}} נבחרו',
            visibleLimit: 'מציג עד {{count}}',
          },
          badges: {
            automatic: 'אוטומטי',
            manual: 'בחירה ידנית',
            customCollection: 'מבוסס אוסף',
            publishedEligibility: 'כשירות לפרסום',
            hidden: 'מוסתר',
            disabled: 'מושבת',
            draftDeleted: 'נמחק בטיוטה',
            nonRendered: 'לא מוצג',
            invalid: 'דורש בדיקה',
          },
          warnings: {
            emptyManualSelection: 'בחרו לפחות פריט אחד לפני תצוגה מקדימה או פרסום.',
            invalidSourceShape:
              'הגדרת המקור אינה תקינה. החילו מחדש את המקור לפני תצוגה מקדימה או פרסום.',
            publishedEligibilityRisk:
              'תצוגה מקדימה ופרסום משתמשים רק בפריטים שנשארים ציבוריים וכשירים.',
            customCollectionReadinessRisk:
              'תצוגה מקדימה ופרסום בודקים שלאוסף הזה עדיין יש מוצרים שפורסמו.',
            hiddenSection: 'המדור מוסתר בבילדר ולא מוצג לקונים.',
            disabledSection: 'המדור מושבת ולא יוצג עד שחוזה המדור יתוקן.',
            draftDeletedSection: 'המדור נמחק בטיוטה. שחזרו אותו לפני עריכת המקור.',
            nonRenderedSection: 'המדור אינו מוצג כרגע בתצוגה המקדימה.',
          },
          modes: {
            productAutoBestSellers: {
              label: 'הנמכרים ביותר',
              summary: 'מסילת מוצרים אוטומטית ממוצרים ציבוריים נמכרים.',
              guidance: 'משתמשת בסדר המרצנדייזינג הציבורי הקיים ובמגבלה שהוגדרה.',
            },
            productAutoTrendingNow: {
              label: 'פופולרי עכשיו',
              summary: 'מסילת מוצרים אוטומטית ממוצרים ציבוריים פופולריים.',
              guidance: 'משתמשת בסדר המרצנדייזינג הציבורי הקיים ובמגבלה שהוגדרה.',
            },
            productAutoNewArrivals: {
              label: 'חדש בחנות',
              summary: 'מסילת מוצרים אוטומטית מהמוצרים הציבוריים החדשים ביותר.',
              guidance: 'משתמשת בסדר המרצנדייזינג הציבורי הקיים ובמגבלה שהוגדרה.',
            },
            productAutoSpecialOffers: {
              label: 'מבצעים מיוחדים',
              summary: 'מסילת מוצרים אוטומטית ממוצרים ציבוריים עם מבצעים פעילים.',
              guidance: 'משתמשת בסדר המרצנדייזינג הציבורי הקיים ובמגבלה שהוגדרה.',
            },
            productManualSelection: {
              label: 'מוצרים ידניים',
              summary: 'מסילת מוצרים ידנית ממוצרים ציבוריים שנבחרו.',
              guidance: 'רק מוצרים שנבחרו ונשארים מפורסמים וכשירים יכולים להופיע.',
            },
            productCustomCollection: {
              label: 'אוסף מותאם',
              summary: 'מסילת מוצרים שמבוססת על אוסף מותאם שהוגדר.',
              guidance: 'רק מוצרים מפורסמים מהאוסף שהוגדר יכולים להופיע לקונים.',
            },
            categoryAutoPublic: {
              label: 'קטגוריות ציבוריות',
              summary: 'מסילת קטגוריות אוטומטית מקטגוריות ציבוריות שפורסמו.',
              guidance: 'משתמשת בסדר הקטגוריות הציבורי הקיים ובמגבלה שהוגדרה.',
            },
            categoryManualSelection: {
              label: 'קטגוריות ידניות',
              summary: 'מסילת קטגוריות ידנית מקטגוריות ציבוריות שנבחרו.',
              guidance: 'רק קטגוריות שנבחרו ונשארות מפורסמות וכשירות יכולות להופיע.',
            },
            adsAutoActive: {
              label: 'מודעות פעילות',
              summary: 'אזור מודעות אוטומטי ממודעות קידום פעילות.',
              guidance: 'משתמש בסדר המודעות הקיים ובמגבלה שהוגדרה.',
            },
            adsManualSelection: {
              label: 'מודעות ידניות',
              summary: 'אזור מודעות ידני ממודעות קידום שנבחרו.',
              guidance: 'רק מודעות שנבחרו ונשארות פעילות וכשירות יכולות להופיע.',
            },
            offersAutoLiveCampaigns: {
              label: 'קמפיינים חיים',
              summary: 'מסילת מבצעים אוטומטית מקמפייני מבצעים חיים.',
              guidance: 'משתמשת בפותר הקמפיינים הקיים ובמגבלה שהוגדרה.',
            },
            invalidSource: {
              label: 'מקור לא תקין',
              summary: 'למדור המסחרי הזה יש הגדרת מקור שהבילדר לא יכול לקרוא.',
              guidance: 'החילו מחדש את הגדרות המקור לפני תצוגה מקדימה או פרסום.',
            },
          },
        },
        states: {
          clean: 'אין שינויים שלא נשמרו',
          dirty: 'יש שינויים שלא נשמרו',
          saving: 'שומר שינויים',
          saved: 'הטיוטה נשמרה',
          failed: 'לא ניתן לשמור את השינויים',
          stale: 'חזית החנות השתנתה במקום אחר. רעננו או אפסו לפני פרסום.',
          validationBlocked: 'תקנו את בעיות המדורים לפני פרסום',
        },
        actions: {
          moveUp: 'העבר למעלה',
          moveDown: 'העבר למטה',
          moveUpSection: 'העבר את {{section}} למעלה',
          moveDownSection: 'העבר את {{section}} למטה',
          enableSection: 'הצג מדור',
          hideSection: 'הסתר מדור',
          enableNamedSection: 'הצג את {{section}}',
          hideNamedSection: 'הסתר את {{section}}',
          reset: 'איפוס',
          refresh: 'רענן',
          openPreview: 'פתח תצוגה מקדימה',
          openSectionSettings: 'פתח הגדרות עבור {{section}}',
        },
        reorder: {
          position: 'מיקום {{position}} מתוך {{count}}',
          movedUp: '{{section}} הועבר למעלה.',
          movedDown: '{{section}} הועבר למטה.',
          movedBefore: '{{section}} הועבר לפני {{target}}.',
          movedAfter: '{{section}} הועבר אחרי {{target}}.',
          blockedBoundary: 'המדור כבר נמצא בקצה המיקום שלו.',
          blockedCrossPlacement: 'אפשר לסדר מדורים רק בתוך המיקום הנוכחי שלהם.',
          blockedProtected: 'אי אפשר לסדר מחדש את המדור המוגן הזה.',
          blockedDisabled: 'אי אפשר לסדר מחדש את המדור המושבת הזה.',
          blockedDeleted: 'שחזרו את המדור שנמחק מהטיוטה לפני סידור מחדש.',
          blockedInvalid: 'שינוי סדר המדור הזה אינו תקין.',
          blockedBusy: 'המתינו לסיום פעולת הבילדר הנוכחית לפני סידור מחדש.',
          blockedStale: 'רעננו או אפסו את חזית החנות שהתיישנה לפני סידור מחדש.',
          blockedWorkspace: 'החילו או בטלו שינויי סביבת עבודה לפני סידור מדורים.',
          blockedLifecycle: 'החילו או בטלו את שינוי מחזור החיים המדורג לפני סידור מחדש.',
          invalidRowLabel: 'מדור לא תקין',
          invalidRowDescription: 'השורה נעולה כי לא ניתן לאמת את חוזה המדור.',
          aria: {
            moveUp: 'העבר את {{section}} למעלה',
            moveDown: 'העבר את {{section}} למטה',
            locked: 'סידור המדור נעול',
          },
        },
        liveCanvas: {
          title: 'קנבס חי',
          description: 'מציג את החנות לפי תצורת הבילדר שהוחלה.',
          iframeTitle: 'קנבס חי של בונה החנות',
          status: {
            idle: 'הקנבס במנוחה',
            loadingFrame: 'טוען מסגרת',
            waitingReady: 'ממתין לקנבס',
            initializing: 'מאתחל קנבס',
            loading: 'טוען קנבס',
            ready: 'הקנבס מוכן',
            syncing: 'מסנכרן שינויים',
            synced: 'השינויים סונכרנו',
            timeout: 'הקנבס לא הגיב',
            timeoutWithRetry: 'הקנבס לא הגיב. נסה שוב.',
            invalidPayload: 'הקנבס דחה את התצורה הזו',
            renderFailed: 'לא ניתן להציג את הקנבס',
            lostFrame: 'הקנבס נטען מחדש',
            permissionDenied: 'הקנבס החי אינו זמין',
          },
          actions: {
            retry: 'נסה שוב',
            reloadFrame: 'טען מסגרת מחדש',
            openPreview: 'פתח תצוגה מקדימה',
          },
          controls: {
            toolbarLabel: 'בקרות תצוגת הקנבס',
            previewModesLabel: 'גדלי תצוגה מקדימה',
            device: {
              desktop: 'מחשב',
              tablet: 'טאבלט',
              mobile: 'נייד',
            },
            deviceAction: {
              desktop: 'מעבר לתצוגת מחשב',
              tablet: 'מעבר לתצוגת טאבלט',
              mobile: 'מעבר לתצוגת נייד',
            },
            zoomControlsLabel: 'בקרות זום',
            zoomIn: 'הגדל',
            zoomOut: 'הקטן',
            zoomReset: 'אפס זום',
            zoomFit: 'התאם',
            zoomFitLabel: 'התאמת הקנבס לרוחב הזמין',
            zoomValue: '{{value}}%',
            zoomLabel: 'זום {{value}}%',
            currentState: '{{device}} · רוחב {{width}} פיקסלים · זום {{zoom}}%',
          },
          selection: {
            selected: 'המקטע שנבחר: {{section}}',
            none: 'לא נבחר מדור',
            clickToEdit: 'בחרו מקטע בקנבס כדי לערוך את ההגדרות שלו כאן.',
            unavailable: 'אי אפשר לבחור את המקטע הזה מהקנבס.',
            invalid: 'בחירה לא תקינה מהקנבס נדחתה.',
            applied: 'השינויים הוחלו על הקנבס החי.',
            unappliedPending: 'החילו או בטלו את שינויי סביבת העבודה לפני בחירת מקטע אחר.',
            chromeLabel: 'מסומן בקנבס',
            editUnavailable: 'אי אפשר לערוך את המדור הזה מהקנבס.',
          },
          errors: {
            invalidOrigin: 'מקור הקנבס שהוגדר אינו מהימן.',
            invalidNonce: 'לא ניתן לאמת את סשן הקנבס.',
            invalidMessage: 'הודעת הקנבס אינה תקינה.',
            invalidConfig: 'תצורת הקנבס אינה תקינה.',
            invalidSection: 'אי אפשר לבחור את המדור הזה בקנבס.',
          },
        },
        inlineText: {
          title: 'עורך טקסט בקנבס',
          localeTabs: 'שפות הטקסט',
          characterCount: '{{count}} / {{max}}',
          locales: {
            ar: 'ערבית',
            he: 'עברית',
            en: 'אנגלית',
          },
          actions: {
            apply: 'החל',
            cancel: 'בטל',
          },
          fields: {
            heroHeadline: 'כותרת הירו',
            heroEyebrow: 'טקסט עליון בהירו',
            heroDescription: 'תיאור הירו',
            heroPrimaryActionLabel: 'כפתור הירו ראשי',
            contentBenefitsHeading: 'כותרת יתרונות',
            contentBenefitsBody: 'טקסט יתרונות',
            contentBenefitTitle: 'כותרת יתרון',
            contentBenefitBody: 'טקסט יתרון',
            contentFaqHeading: 'כותרת שאלות נפוצות',
            contentFaqBody: 'פתיח שאלות נפוצות',
            contentFaqQuestion: 'שאלה נפוצה',
            contentFaqAnswer: 'תשובה נפוצה',
            contentAboutHeading: 'כותרת אודות החנות',
            contentAboutParagraph: 'פסקת אודות החנות',
            contentTestimonialsHeading: 'כותרת ציטוטים',
            contentTestimonialsBody: 'פתיח ציטוטים',
            contentTestimonialQuote: 'ציטוט',
            contentTestimonialName: 'שם לציטוט',
            contentTestimonialContext: 'הקשר לציטוט',
            contentNewsletterHeading: 'כותרת קריאת מעקב',
            contentNewsletterBody: 'טקסט קריאת מעקב',
            contentNewsletterButtonLabel: 'כפתור קריאת מעקב',
            contentEditorialBannerHeading: 'כותרת הבאנר',
            contentEditorialBannerBody: 'טקסט הבאנר',
            contentEditorialBannerButtonLabel: 'כפתור הבאנר',
          },
          errors: {
            unknownField: 'אי אפשר לערוך את שדה הטקסט הזה.',
            wrongSectionType: 'שדה הטקסט הזה אינו שייך למדור שנבחר.',
            staleSection: 'רעננו את הבילדר לפני עריכת הטקסט הזה.',
            nonEditableField: 'אי אפשר לערוך את הטקסט הזה מהקנבס.',
            missingRequiredLocale: 'השלימו ערבית, עברית ואנגלית לפני החלה.',
            unsafeText:
              'השתמשו בטקסט רגיל בלבד. HTML, סקריפטים, קישורי Markdown וכתובות URL גולמיות נחסמים.',
            oversizedText: 'הטקסט ארוך מהמגבלה המותרת.',
            invalidValue: 'ערך הטקסט אינו תקין.',
            invalidConfig: 'שינוי הטקסט אינו עובר את אימות המדור.',
          },
        },
        inlineMedia: {
          title: 'בחירת מדיה בקנבס',
          actions: {
            apply: 'החל',
            cancel: 'בטל',
          },
          fields: {
            heroDesktop: 'תמונת שקופית הירו למחשב',
            heroMobile: 'תמונת שקופית הירו למובייל',
            trustBadgeImage: 'תמונת תג אמון',
            editorialBannerDesktop: 'תמונת הבאנר למחשב',
            editorialBannerMobile: 'תמונת הבאנר לנייד',
          },
          errors: {
            unknownField: 'אי אפשר לערוך את שדה המדיה הזה.',
            wrongSectionType: 'שדה המדיה הזה אינו שייך למדור שנבחר.',
            staleSection: 'רעננו את הבילדר לפני החלפת המדיה הזו.',
            nonEditableField: 'אי אפשר לערוך את המדיה הזו מהקנבס.',
            invalidReference: 'בחירת המדיה הזו אינה זמינה לחזית החנות.',
            invalidConfig: 'שינוי המדיה אינו עובר את אימות המדור.',
          },
        },
        inlineRichContent: {
          targetOpened: 'נפתח שדה תוכן עשיר: {{field}}',
          fields: {
            contentBenefitsBody: 'גוף יתרונות',
            contentBenefitBody: 'גוף יתרון',
            contentFaqBody: 'פתיח שאלות נפוצות',
            contentFaqAnswer: 'תשובה נפוצה',
            contentAboutParagraph: 'פסקת על החנות',
            contentTestimonialsBody: 'פתיח ציטוטים',
            contentTestimonialQuote: 'ציטוט',
            contentNewsletterBody: 'טקסט קריאת מעקב',
          },
          errors: {
            unknownField: 'אי אפשר לערוך את שדה התוכן העשיר הזה.',
            wrongSectionType: 'שדה התוכן העשיר הזה אינו שייך למדור שנבחר.',
            staleSection: 'רעננו את הבילדר לפני עריכת התוכן העשיר הזה.',
            nonEditableField: 'אי אפשר לערוך את התוכן העשיר הזה מהקנבס.',
            invalidConfig: 'נקודת הכניסה לתוכן העשיר אינה עוברת את אימות המדור.',
          },
        },
        inlineQuick: {
          title: 'תצוגה מהירה',
          description: 'בקרות תצוגה מהירה עבור {{section}}.',
          actions: {
            open: 'פתחו בקרות תצוגה מהירה עבור {{section}}',
            close: 'סגרו בקרות תצוגה מהירה',
          },
          errors: {
            unavailable: 'בקרות התצוגה המהירה אינן זמינות למדור הזה.',
          },
        },
        visibility: {
          enabled: 'גלוי לקונים',
          hidden: 'מוסתר מקונים',
          disabled: 'מושבת',
        },
        placement: {
          globalHeader: 'כותרת העמוד',
          homeMain: 'תוכן העמוד',
          globalFooter: 'תחתית העמוד',
          mobileNav: 'ניווט במובייל',
          globalAnnouncementBar: 'מעל כותרת העמוד',
        },
        empty: 'אין מדורים לעריכה בעמוד הזה.',
        blocked: {
          invalidMove: 'אי אפשר להעביר את המדור למיקום אחר.',
          disabledSection: 'המדור מושבת ואי אפשר לשנות אותו מכאן.',
          unsupportedSection: 'המדור אינו נתמך ואי אפשר לפרסם אותו.',
          unsupportedEngineVersion: 'אי אפשר לערוך כאן את גרסת מנוע חזית החנות הזו.',
          unsupportedSectionType: 'סוג המדור הזה אינו נתמך.',
          invalidPlacement: 'אי אפשר למקם את המדור כאן.',
          invalidConfig: 'שינוי מחזור החיים הזה אינו תקין לעמוד הנוכחי.',
          protectedSection: 'אי אפשר לשנות מכאן את המדור המוגן הזה.',
          duplicateProtectedSection: 'המדור המוגן הזה כבר קיים.',
          notDraftDeleted: 'אפשר לשחזר רק מדורים שנמחקו בטיוטה.',
        },
        validation: {
          issueCount: '{{count}} בעיות במדורים',
        },
        history: {
          actions: {
            undo: '',
            redo: '',
          },
          tooltips: {
            undoCommand: '',
            redoCommand: '',
          },
          disabled: {
            noUndo: '',
            noRedo: '',
            busy: '',
            stale: '',
            workspaceDirty: '',
            pendingLifecycle: '',
            unavailable: '',
            invalidConfig: '',
            invalidHistory: '',
          },
          commands: {
            reorderSection: '',
            canvasReorderSection: '',
            applyLifecycle: '',
            applySettings: '',
            applyDesignDefault: '',
            applyInlineText: '',
            applyInlineMedia: '',
            applyTheme: '',
            resetTheme: '',
            applySeo: '',
            resetSeo: '',
            applyChrome: '',
            resetChrome: '',
          },
          messages: {
            undone: '',
            redone: '',
            blocked: '',
            noChange: '',
          },
        },
        shell: {
          regions: {
            toolbar: 'סרגל כלים',
            sections: 'מקטעים',
            canvas: 'אזור תצוגה מקדימה',
            workspace: 'סביבת עבודה',
            status: 'סטטוס',
          },
          canvas: {
            title: 'קנבס חי יתווסף בהמשך',
            body: 'השתמשו בתצוגה מקדימה כדי לבדוק את חזית החנות האמיתית. אזור זה יארח עריכה חיה בגרסה מאוחרת יותר.',
            selectedSection: 'מקטע נבחר: {{section}}',
            noSelection: 'בחרו מקטע כדי לראות את סביבת העריכה שלו.',
          },
          workspace: {
            emptyTitle: 'לא נבחר מקטע',
            emptyBody: 'בחרו מקטע מהלוח כדי לראות הגדרות.',
            readOnlyTitle: 'מקטע לקריאה בלבד',
            readOnlyBody: 'אפשר לבדוק את המקטע כאן, אך לא לערוך אותו בגרסה זו.',
            editableTitle: 'הגדרות ניתנות לעריכה',
            footerUnsaved: 'יש שינויים שלא הוחלו בסביבת העבודה',
            applyBeforeSwitch: 'החילו או בטלו את השינויים לפני בחירת מקטע אחר.',
            sectionSelectedFromCanvas: '{{section}} נבחר מהקנבס החי.',
            applyBeforeCanvasUpdate:
              'יש שינויים שלא הוחלו. השינויים לא יופיעו בקנבס עד שתלחצו החלה.',
            metadata: 'נתוני המקטע',
            metadataLabels: {
              placement: 'מיקום',
              status: 'סטטוס',
              visibility: 'נראות במכשירים',
              dataSource: 'מקור נתונים',
              viewAllTarget: 'יעד הצגת הכל',
              lifecycle: 'שלב המקטע',
            },
            metadataValues: {
              none: 'לא מוגדר',
              dataSourceWithLimit: '{{source}} · {{count}}',
              dataSourceWithSection: '{{source}} · {{section}}',
              dataSources: {
                none: 'ללא מקור נתונים',
                storeIdentity: 'זהות החנות',
                homeMerchandising: 'מוצרי דף הבית',
                publicCategories: 'קטגוריות ציבוריות',
                merchandisingSection: 'מקטע מוצרים',
                promotionalAds: 'מודעות החנות',
                liveOfferCampaigns: 'מבצעים חיים',
                storeReviewSummary: 'סיכום ביקורות החנות',
              },
              viewAll: {
                collection: 'עמוד אוסף',
                sales: 'עמוד מבצעים',
              },
              lifecycle: {
                active: 'פעיל',
                draftAdded: 'נוסף בטיוטה',
                draftDeleted: 'נמחק בטיוטה',
                restored: 'שוחזר',
              },
            },
            revisions: 'גרסאות',
          },
          deferred: {
            addSection: 'הוספת מקטע תתווסף בהמשך',
            liveCanvas: 'עריכה חיה בקנבס תתווסף בהמשך',
            dragDrop: 'גרירה ושחרור יתווספו בהמשך',
            inlineEditing: 'עריכה בתוך התצוגה תתווסף בהמשך',
            undoRedo: '',
            zoom: 'בקרות זום יתווספו בהמשך',
          },
          device: {
            desktop: 'מחשב',
            tablet: 'טאבלט',
            mobile: 'טלפון',
          },
          zoom: {
            fit: 'התאם',
            value: '{{value}}%',
          },
          status: {
            selectedSection: 'עריכת {{section}}',
            noSelection: 'לא נבחר מקטע',
            validationOk: 'אין בעיות חוסמות',
            loading: 'העורך נטען',
            failedLoad: 'טעינת העורך נכשלה',
            empty: 'אין מקטעים ניתנים לעריכה',
            dirty: 'יש שינויים שלא נשמרו',
            workspaceDirty: 'החילו או בטלו את שינויי סביבת העבודה',
            saving: 'שומר טיוטה',
            saved: 'הטיוטה נשמרה',
            saveFailed: 'שמירת הטיוטה נכשלה',
            validationBlocked: 'תקנו בעיות לפני המשך',
            staleConflict: 'חזית החנות השתנתה במקום אחר',
            previewing: 'יוצר תצוגה מקדימה',
            previewFailed: 'יצירת התצוגה המקדימה נכשלה',
            publishing: 'מפרסם',
            validatingPublish: 'בודק מוכנות לפרסום',
            savingPublishDraft: 'שומר טיוטה לפני פרסום',
            publishBlockedReadiness: 'הפרסום חסום בגלל מוכנות',
            publishBlockedStale: 'נדרש רענון לפני פרסום',
            rollingBack: 'משחזר גרסה קודמת',
            rollbackFailed: 'שחזור הגרסה נכשל',
            restoringDraft: 'משחזר טיוטה',
            restoreDraftFailed: 'שחזור הטיוטה נכשל',
            publishSuccess: 'פורסם',
            publishFailed: 'הפרסום נכשל',
            permissionDenied: 'אין הרשאה',
          },
          actions: {
            applyWorkspace: 'החל',
            cancelWorkspace: 'בטל',
            discardWorkspace: 'מחק את שינויי סביבת העבודה',
            retryOperation: 'נסה שוב',
            selectSection: 'בחרו {{section}}',
            disabledControl: '{{control}} לא זמין בגרסה זו',
          },
        },
      },
      fieldGroups: {
        content: 'תוכן',
        dataSource: 'מקור נתונים',
        layout: 'פריסה',
        appearance: 'מראה',
        visibility: 'נראות',
      },
      settings: {
        title: 'הגדרות מדור',
        description: 'עדכנו הגדרות עבור {{section}}.',
        actions: {
          apply: 'החל',
          cancel: 'ביטול',
        },
        fields: {
          status: 'סטטוס המדור',
          deviceVisibility: 'נראות לפי מכשיר',
          categoryLimit: 'קטגוריות מוצגות',
          categoryOrderMode: 'סדר קטגוריות',
          categoryLayoutMode: 'פריסת קטגוריות',
          categoryImageShape: 'צורת תמונת קטגוריה',
          categoryDensity: 'מרווח קטגוריות',
          adsLimit: 'מודעות מוצגות',
          adsOrderMode: 'סדר מודעות',
          adsLayoutPreset: 'פריסת מודעות',
          adsOrientation: 'כיוון מודעה',
          adsImageFit: 'התאמת תמונת מודעה',
          adsDensity: 'מרווח מודעות',
          adsShowTitle: 'הצגת כותרת מודעה',
          adsShowDestinationCue: 'הצגת רמז יעד',
          categoryHeading: 'כותרת המקטע',
          categoryShowProductCount: 'הצגת מספר מוצרים',
          categoryShowDescription: 'הצגת תיאורים',
          liveOfferLimit: 'מבצעים מוצגים',
          productSourceMode: 'מקור מוצרים',
          productPicker: 'מוצרים',
          productLimit: 'מוצרים מוצגים',
          productLayoutMode: 'פריסת מוצרים',
          productImageShape: 'צורת תמונת מוצר',
          productDensity: 'מרווח מוצרים',
          productImageFit: 'התאמת תמונת מוצר',
          productShowPrice: 'הצגת מחירים',
          productShowSaleBadge: 'הצגת תגי מבצע',
          productShowAvailabilityBadge: 'הצגת תגי זמינות',
          categoryPicker: 'קטגוריות',
          promotionalAdPicker: 'מודעות החנות',
          trustBadgeImage: 'תמונת תג אמון',
          heroSlides: 'שקופיות הירו',
          contentSection: 'מקטע תוכן',
          collectionPicker: 'אוסף',
          newsletterCollection: 'איסוף נרשמי ניוזלטר',
          mediaPickerUnsupported: 'בורר מדיה אינו זמין למדור הזה.',
        },
        pickers: {
          searchPlaceholder: 'חיפוש בתוכן ציבורי',
          mediaSearchPlaceholder: 'חיפוש בתמונות ציבוריות',
          loading: 'טוען אפשרויות...',
          loadingMedia: 'טוען תמונות...',
          retry: 'נסה שוב',
          emptyProducts: 'אין מוצרים שפורסמו שתואמים לחיפוש.',
          emptySelectedProducts: 'בחרו לפחות מוצר אחד לפני החלת המדור הידני.',
          customCollectionSearchPlaceholder: 'חיפוש באוספים מותאמים',
          createCustomCollection: 'יצירת אוסף',
          loadingCustomCollections: 'טוען אוספים מותאמים...',
          customCollectionsUnavailable: 'לא ניתן לטעון אוספים מותאמים. נסו שוב.',
          emptyCustomCollections: 'אין עדיין אוספים מותאמים.',
          emptyCustomCollectionProducts: 'הוסיפו לפחות מוצר מפורסם אחד לאוסף הזה.',
          customCollectionProductCount: '{{count}} מוצרים',
          editCustomCollection: 'עריכת אוסף',
          customCollectionNameAr: 'שם האוסף בערבית',
          customCollectionNameHe: 'שם האוסף בעברית',
          customCollectionNameEn: 'שם האוסף באנגלית',
          customCollectionDescriptionAr: 'תיאור האוסף בערבית',
          customCollectionDescriptionHe: 'תיאור האוסף בעברית',
          customCollectionDescriptionEn: 'תיאור האוסף באנגלית',
          customCollectionSaveFailed: 'לא ניתן לשמור את האוסף.',
          saveCustomCollection: 'שמירת אוסף',
          emptyCategories: 'אין קטגוריות ציבוריות שתואמות לחיפוש.',
          emptyCollections: 'אין אוספים זמינים.',
          emptyMedia: 'אין תמונות ציבוריות שתואמות לחיפוש.',
          emptyPromotionalAds: 'אין מודעות פעילות כשירות שתואמות לחיפוש.',
          emptyMediaSelection: 'לא נבחרה תמונה עדיין.',
          selectedMedia: 'תמונה נבחרת',
          safeMediaReference: 'הפניה בטוחה לתמונה',
          mediaError: 'לא ניתן לטעון תמונות ציבוריות.',
          mediaDefaultLabel: 'תמונה ללא שם',
          uploadMedia: 'העלאת תמונה',
          replaceMedia: 'החלפת תמונה',
          removeMedia: 'הסרת תמונה',
          refreshMedia: 'רענון תמונות',
          mediaUploadHint: 'JPEG, PNG או WebP. עד 5MB ו-4096 פיקסלים.',
          mediaUploading: 'מעלה תמונה...',
          mediaRemoving: 'מסיר תמונה...',
          mediaUnavailable: 'התמונה לא זמינה',
          mediaUnavailableDescription: 'בחרו תמונה אחרת לפני החלת המדור הזה.',
          mediaInUse: 'התמונה משמשת בחנות השמורה. נקו או החליפו אותה ואז שמרו לפני ההסרה.',
          mediaRemoveConfirm: 'להסיר את התמונה מספריית המדיה?',
          mediaRemoveConfirmDescription: 'זה לא מנקה מדורי חנות שמורים שכבר משתמשים בה.',
          mediaSelect: 'בחירת תמונה',
          mediaSelected: 'נבחרה',
          mediaUploadFailed: 'לא ניתן להעלות את התמונה.',
          mediaRemoveFailed: 'לא ניתן להסיר את התמונה.',
          mediaInvalidType: 'יש להשתמש רק ב-JPEG, PNG או WebP.',
          mediaTooLarge: 'התמונה גדולה מ-5MB.',
          mediaDimensionsInvalid: 'ממדי התמונה חייבים להיות בין 1 ל-4096 פיקסלים.',
          mediaRequired: 'בחרו תמונה להעלאה.',
          selectedCount: '{{count}} מתוך {{max}} נבחרו',
          unavailableSelectedProduct: 'מוצר לא זמין',
          promotionalAdsSearchPlaceholder: 'חיפוש מודעות פעילות',
          selectedPromotionalAdsCount: '{{count}} מתוך {{max}} מודעות נבחרו',
          emptySelectedPromotionalAds: 'לא נבחרו מודעות עדיין.',
          loadingPromotionalAds: 'טוען מודעות פעילות...',
          promotionalAdsUnavailable: 'לא ניתן לטעון מודעות פעילות. נסו שוב.',
          removeSelection: 'הסר בחירה',
          clearSelection: 'נקה בחירה',
          moveSelectionUp: 'העבר בחירה למעלה',
          moveSelectionDown: 'העבר בחירה למטה',
          categoryFilterAll: 'כל הקטגוריות',
          categoryFilterButton: 'סינון לפי קטגוריה',
          categoryProductCount: '{{count}} מוצרים',
          availability: {
            inStock: 'במלאי',
            outOfStock: 'אזל מהמלאי',
          },
          source: {
            collection: 'אוסף',
            manualProducts: 'מוצרים ידניים',
            customCollection: 'אוסף מותאם',
            autoCategories: 'קטגוריות אוטומטיות',
            manualCategories: 'קטגוריות ידניות',
            autoPromotionalAds: 'מודעות פעילות אוטומטיות',
            autoPromotionalAdsHelp:
              'משתמש במודעות פעילות ממבצעים לפי סדר התצוגה העסקי. יצירת מודעות, מדיה, יעדים, הפעלה וסידור נשארים בניהול המבצעים.',
            manualPromotionalAds: 'מודעות נבחרות',
          },
        },
        boundaries: {
          adsPresentationOnlyTitle: 'מודעות החנות נשארות בניהול המבצעים',
          adsPresentationOnly:
            'הבילדר שולט באופן הצגת המודעות במדור הזה. צרו מודעות, הגדירו יעדים, העלו מדיה למודעות, הפעילו מודעות ושנו את הסדר העסקי בניהול המבצעים.',
          manageAdsLink: 'ניהול מודעות',
        },
        visibility: {
          all: 'כל המכשירים',
          desktop: 'מחשב בלבד',
          tablet: 'טאבלט בלבד',
          mobile: 'מובייל בלבד',
          none: 'לא נבחר מכשיר',
          devices: {
            desktop: 'מחשב',
            tablet: 'טאבלט',
            mobile: 'מובייל',
          },
          deviceActions: {
            desktop: 'הצג במחשב',
            tablet: 'הצג בטאבלט',
            mobile: 'הצג במובייל',
          },
        },
        help: {
          deviceVisibility: 'בחרו באילו גדלי מסך המדור יוצג.',
          trustBadgeImage: 'בחרו תמונה ציבורית מאושרת למדור הזה.',
          categoryLimit: 'בחרו כמה קטגוריות יופיעו ברצועה הזו.',
          categoryOrderMode:
            'קטגוריות אוטומטיות עוקבות אחרי סדר מנהל הקטגוריות; קטגוריות נבחרות עוקבות אחרי הרשימה הזו.',
          categoryLayoutMode: 'בחרו אם הקטגוריות יוצגו כרצועה נגללת או כרשת רספונסיבית.',
          categoryImageShape: 'בחרו את מסגרת התמונה בכרטיסי הקטגוריות.',
          categoryDensity: 'בחרו את רמת המרווח ברצועת הקטגוריות.',
          adsLimit: 'בחרו כמה מודעות חנות יוצגו במדור הזה.',
          adsOrderMode:
            'מודעות אוטומטיות עוקבות אחרי סדר מנהל המבצעים; מודעות נבחרות עוקבות אחרי רשימת המדור.',
          adsLayoutPreset: 'בחרו איך מודעות החנות מסודרות.',
          adsOrientation:
            'מודעות אופקיות נמתחות לרוחב החנות; מודעות אנכיות מוצגות במסגרת פורטרט ממורכזת.',
          adsImageFit: 'בחרו איך תמונות מודעות יתאימו למסגרת.',
          adsDensity: 'בחרו את רמת המרווח במדור מודעות החנות.',
          adsShowTitle: 'הציגו או הסתירו את כותרת המודעה הציבורית.',
          adsShowDestinationCue: 'הציגו או הסתירו רמז יעד כללי.',
          categoryHeading:
            'אופציונלי. מוצג מעל הקטגוריות במקום הכותרת המובנית. השאירו את שלושת השדות ריקים כדי לחזור לכותרת המובנית.',
          categoryShowProductCount: 'הציגו או הסתירו מספרי מוצרים ציבוריים לכל קטגוריה.',
          categoryShowDescription: 'הציגו את התיאורים הציבוריים הבטוחים שהוספתם בניהול הקטגוריות.',
          liveOfferLimit: 'בחרו כמה מבצעים פעילים יופיעו ברצועה הזו.',
          productLimit: 'בחרו כמה מוצרים יופיעו ברצועה הזו.',
          productLayoutMode: 'בחרו אם מוצרים יוצגו כרצועה נגללת או כרשת רספונסיבית.',
          productImageShape: 'בחרו את מסגרת התמונה בכרטיסי המוצרים.',
          productDensity: 'בחרו את רמת המרווח ברצועת המוצרים.',
          productImageFit: 'בחרו איך תמונות מוצרים יתאימו למסגרת.',
          productShowPrice: 'הציגו או הסתירו את מחיר המוצר הציבורי.',
          productShowSaleBadge: 'הציגו או הסתירו תגי מבצע ציבוריים כשהמוצר במבצע.',
          productShowAvailabilityBadge: 'הציגו או הסתירו תגי זמינות מלאי ציבוריים.',
          heroSlides: 'הוסיפו עד שלוש שקופיות מתורגמות עם יעדים בטוחים ותמונות ציבוריות מאושרות.',
          contentSection:
            'כתבו תוכן סוחר מתורגם עם אסימונים מאושרים בלבד. HTML, קישורים מותאמים, סקריפטים, סגנונות ונתוני לקוחות נדחים.',
        },
        hero: {
          emptyTitle: 'מופעל גיבוי זהות החנות',
          emptyBody:
            'הוסיפו שקופית כשתרצו להחליף את הירו ברירת המחדל. עד אז הקונים יראו את שם החנות והתיאור שלה.',
          addSlide: 'הוסף שקופית',
          removeSlide: 'הסר שקופית',
          slideLabel: 'שקופית {{index}}',
          enabled: 'מוצגת',
          headline: 'כותרת ראשית',
          eyebrow: 'טקסט עליון',
          description: 'תיאור',
          primaryAction: 'כפתור ראשי',
          secondaryAction: 'כפתור משני',
          addSecondaryAction: 'הוסף כפתור משני',
          removeSecondaryAction: 'הסר כפתור משני',
          buttonLabel: 'תווית כפתור',
          desktopMedia: 'תמונת מחשב',
          mobileMedia: 'תמונת מובייל',
          destination: 'יעד',
          categoryId: 'מזהה קטגוריה',
          overlay: 'שכבת כיסוי',
          contentPosition: 'מיקום תוכן',
          textAlignment: 'יישור טקסט',
          layoutPreset: 'תבנית פריסה',
          scheduleTitle: 'חלון תזמון',
          scheduleHelp: 'חלון אופציונלי לפי שעון ישראל. הוא נשמר כ-UTC ומוצג לקונים רק כשהוא פעיל.',
          startsAt: 'מתחיל ב',
          endsAt: 'מסתיים לפני',
          clearSchedule: 'נקה תזמון',
          scheduleInvalidRange: 'שעת הסיום חייבת להיות אחרי שעת ההתחלה.',
          scheduleStates: {
            always: 'פעיל תמיד',
            active: 'פעיל עכשיו',
            upcoming: 'מתוזמן להמשך',
            expired: 'פג תוקף',
          },
          locales: {
            ar: 'ערבית',
            he: 'עברית',
            en: 'אנגלית',
          },
          targets: {
            storeHome: 'עמוד החנות',
            storeCategories: 'קטגוריות',
            storeSales: 'מבצעים',
            bestSellers: 'נמכרים ביותר',
            trendingNow: 'חם עכשיו',
            newArrivals: 'חדש בחנות',
            storeCategory: 'קטגוריה מסוימת',
            cart: 'עגלה',
            customerAccount: 'חשבון לקוח',
            customerOrders: 'הזמנות לקוח',
            whatsapp: 'WhatsApp',
            phone: 'טלפון',
          },
          overlays: {
            none: 'ללא',
            soft: 'עדינה',
            medium: 'בינונית',
            strong: 'חזקה',
          },
          positions: {
            start: 'התחלה',
            center: 'מרכז',
            end: 'סוף',
          },
          alignments: {
            start: 'התחלה',
            center: 'מרכז',
            end: 'סוף',
          },
          layoutPresets: {
            immersive: 'רחבה',
            balanced: 'מאוזנת',
            compact: 'קומפקטית',
          },
        },
        content: {
          emptyBody: 'הטקסט האופציונלי הזה ריק לקונים עד שתוסיפו עותק מתורגם.',
          addItem: 'הוסף פריט',
          removeItem: 'הסר פריט',
          moveItemUp: 'העבר פריט למעלה',
          moveItemDown: 'העבר פריט למטה',
          itemLabel: 'פריט {{index}}',
          heading: 'כותרת',
          body: 'טקסט',
          paragraph: 'פסקה',
          title: 'כותרת פריט',
          question: 'שאלה',
          answer: 'תשובה',
          quote: 'ציטוט',
          name: 'שם תצוגה',
          context: 'הקשר',
          buttonLabel: 'תווית כפתור',
          icon: 'אייקון',
          layout: 'פריסה',
          tone: 'סגנון',
          cta: 'קריאה לפעולה',
          ctaEnabled: 'הצג כפתור',
          collectionEnabled: 'איסוף נרשמים',
          collectionContactMethods: 'פרטי קשר מותרים',
          collectionEmail: 'אימייל',
          collectionPhone: 'טלפון ישראלי',
          collectionConsentVersion: 'גרסת הסכמה {{version}}',
          newsletterNote:
            'האיסוף כבוי עד שמפעילים אותו כאן, שומרים ומפרסמים. הקונים חייבים לאשר הסכמה לפני שליחה.',
          testimonialNote:
            'השתמשו רק בטקסט תצוגה שהסוחר כתב. נתוני לקוחות, הזמנות, ביקורות, טלפונים או אימיילים אינם מחוברים כאן.',
          unsafeNote:
            'רק עיצוב בטוח. HTML, Markdown, קישורים גולמיים, סקריפטים, סגנונות וסימני בקרה מוסתרים נדחים.',
          editorialBannerNote:
            'בחרו תמונה למחשב ותמונה לנייד מספריית המדיה הציבורית. אפשר להשאיר כל אחת מהן ריקה.',
          media: 'מדיה',
          mediaDesktop: 'תמונה למחשב',
          mediaMobile: 'תמונה לנייד',
          richTextControls: 'עיצוב',
          richTextPlain: 'טקסט רגיל',
          richTextBold: 'מודגש',
          richTextItalic: 'נטוי',
          richTextBulleted: 'רשימת תבליטים',
          richTextNumbered: 'רשימה ממוספרת',
          richTextApplyLink: 'החל קישור',
          richTextRemoveLink: 'הסר קישור',
          icons: {
            'badge-check': 'תג אישור',
            'heart-handshake': 'לב ולחיצת יד',
            leaf: 'עלה',
            'package-check': 'חבילה מאושרת',
            'shield-check': 'מגן אישור',
            sparkles: 'נצנוצים',
            truck: 'משאית',
          },
          layouts: {
            cards: 'כרטיסים',
            list: 'רשימה',
            accordion: 'אקורדיון',
            story: 'סיפור',
            quotes: 'ציטוטים',
            banner: 'באנר',
            split: 'תמונה לצד הטקסט',
            overlay: 'טקסט על התמונה',
          },
          tones: {
            neutral: 'ניטרלי',
            warm: 'חם',
            accent: 'מודגש',
          },
        },
        categoryOrderMode: {
          categoryDisplayOrder: 'סדר מנהל הקטגוריות',
          selectedListOrder: 'סדר הרשימה הנבחרת',
        },
        categoryLayoutMode: {
          scrollRail: 'רצועה נגללת',
          responsiveGrid: 'רשת רספונסיבית',
        },
        categoryImageShape: {
          circle: 'עיגול',
          roundedSquare: 'ריבוע רך',
        },
        categoryDensity: {
          comfortable: 'מרווח',
          compact: 'קומפקטי',
        },
        productLayoutMode: {
          scrollRail: 'רצועה נגללת',
          responsiveGrid: 'רשת רספונסיבית',
        },
        productImageShape: {
          square: 'ריבוע',
          roundedSquare: 'ריבוע רך',
        },
        productDensity: {
          comfortable: 'מרווח',
          compact: 'קומפקטי',
        },
        productImageFit: {
          cover: 'כיסוי',
          contain: 'התאמה מלאה',
        },
        adsOrderMode: {
          businessDisplayOrder: 'סדר מנהל המבצעים',
          selectedListOrder: 'סדר הרשימה הנבחרת',
        },
        adsLayoutPreset: {
          carousel: 'קרוסלה',
          stackedCards: 'כרטיסים מוערמים',
        },
        adsOrientation: {
          horizontal: 'אופקי',
          vertical: 'אנכי',
        },
        adsImageFit: {
          cover: 'כיסוי',
          contain: 'הכלה',
        },
        adsDensity: {
          comfortable: 'מרווח',
          compact: 'קומפקטי',
        },
        readOnly: {
          dataSource: 'מקור נתונים',
          placement: 'מיקום',
        },
        messages: {
          applied: 'הגדרות המדור הוחלו.',
          cancelled: 'שינויי ההגדרות בוטלו.',
        },
        aria: {
          sectionSettingsSurface: 'אזור הגדרות המדור',
          applySettingChanges: 'החלת שינויי הגדרות המדור',
          cancelSettingChanges: 'ביטול שינויי הגדרות המדור',
        },
        errors: {
          sectionNotEditable: 'אי אפשר לערוך את המדור הזה מכאן.',
          deletedSectionReadOnly: 'המדור נמחק מהטיוטה. שחזרו אותו לפני עריכת ההגדרות.',
          duplicateInvalidReadOnly:
            'המדור משוכפל בצורה לא תקינה. תקנו את השכפול לפני עריכת ההגדרות.',
          unsupportedField: 'אי אפשר לערוך את השדה הזה מכאן.',
          staleBuilder: 'חזית החנות השתנתה במקום אחר. רעננו לפני עריכת ההגדרות.',
          busyBuilder: 'המתינו לסיום הפעולה הנוכחית לפני עריכת ההגדרות.',
          invalidPatchSafe: 'השינוי לא הוחל. ההגדרות הקודמות נשמרו.',
          lastVisibleDevice:
            'השאירו לפחות מכשיר אחד גלוי. השתמשו בסטטוס המדור כדי להסתיר אותו בכל המכשירים.',
          invalidInteger: 'הזינו מספר שלם.',
          outOfRange: 'בחרו מספר בטווח המותר.',
          invalidReference: 'הפניה לא תקינה: הבחירה הזו כבר לא זמינה.',
          customCollectionNameRequired: 'הזינו לפחות שם אוסף בערבית.',
          emptyCustomCollection: 'הוסיפו לפחות מוצר מפורסם אחד לפני בחירת האוסף הזה.',
          emptyProductSelection: 'בחרו לפחות מוצר אחד לפני החלת המדור הידני.',
          invalidHeroConfig: 'השלימו כל שקופית הירו מוצגת בערבית, עברית ואנגלית לפני ההחלה.',
          invalidContentConfig:
            'השלימו תוכן נדרש בערבית, עברית ואנגלית והסירו טקסט לא בטוח לפני ההחלה.',
          crossStoreReference: 'הבחירה הזו אינה זמינה לחנות הזו.',
          unpublishedReference: 'הבחירה הזו אינה מפורסמת.',
          deletedReference: 'הבחירה הזו הוסרה.',
          disabledReference: 'הבחירה הזו מושבתת.',
          emptyCategoryReference: 'לקטגוריה הזו אין מוצרים ציבוריים.',
          emptyCollectionReference: 'לאוסף הזה אין מוצרים ציבוריים.',
          unsafeAdsDestination: 'יעד המודעה הזו אינו זמין.',
          missingAdsMedia: 'תמונת המודעה הזו אינה זמינה.',
          duplicateReference: 'הבחירה הזו כבר נכללת.',
          tooManyReferences: 'הסר בחירה לפני הוספת בחירה נוספת.',
          unsupportedContentKind: 'סוג התוכן הזה אינו נתמך כאן.',
          categoryHeadingLocales:
            'הזינו כותרת בערבית, בעברית ובאנגלית (עד 120 תווים לשפה), או השאירו את שלושתן ריקות.',
        },
      },
      publicContent: {
        errors: {
          invalidReference: 'הפניה לא תקינה: הבחירה הזו כבר לא זמינה.',
          crossStoreReference: 'הבחירה הזו אינה זמינה לחנות הזו.',
          unpublishedReference: 'הבחירה הזו אינה מפורסמת.',
          deletedReference: 'הבחירה הזו הוסרה.',
          disabledReference: 'הבחירה הזו מושבתת.',
          emptyCategoryReference: 'לקטגוריה הזו אין מוצרים ציבוריים.',
          emptyCollectionReference: 'לאוסף הזה אין מוצרים ציבוריים.',
          unsafeAdsDestination: 'יעד המודעה הזו אינו זמין.',
          missingAdsMedia: 'תמונת המודעה הזו אינה זמינה.',
          duplicateReference: 'הבחירה הזו כבר נכללת.',
          tooManyReferences: 'הסר בחירה לפני הוספת בחירה נוספת.',
          unsupportedContentKind: 'סוג התוכן הזה אינו נתמך כאן.',
        },
      },
      newsletterSubscribers: {
        title: 'אנשי קשר לניוזלטר',
        description: 'אנשי קשר אחרונים שנאספו בהסכמה מטפסי קריאת ניוזלטר שפורסמו.',
        loading: 'טוען אנשי קשר...',
        empty: 'עדיין לא נאספו אנשי קשר.',
        loadError: 'לא ניתן לטעון אנשי קשר.',
        exportEmpty: 'אין אנשי קשר לייצוא.',
        exportReady: 'ייצוא CSV מוכן.',
        suppressFailed: 'לא ניתן להשתיק את איש הקשר הזה.',
        columns: {
          contact: 'איש קשר',
          status: 'סטטוס',
          locale: 'שפה',
          source: 'מדור מקור',
          created: 'נוצר',
        },
        actions: {
          refresh: 'רענון אנשי קשר',
          export: 'ייצוא CSV',
          suppress: 'השתקת איש קשר',
        },
        contactTypes: {
          email: 'אימייל',
          phone: 'טלפון',
        },
        statuses: {
          active: 'פעיל',
          suppressed: 'מושתק',
        },
      },
      status: {
        draft: 'טיוטה',
        published: 'פורסם',
        archived: 'בארכיון',
      },
      readiness: {
        title: 'מוכנות לפרסום',
        ready: 'מוכן לתצוגה מקדימה ולפרסום',
        blocked: 'המוכנות חסומה',
        checking: 'בודק מוכנות...',
        warningCount: '{{count}} אזהרות',
        blockerCount: '{{count}} חסימות',
        publishBlocked: 'הפרסום חסום עד לתיקון בעיות המוכנות.',
        previewBlocked: 'התצוגה המקדימה חסומה עד לתיקון בעיות המוכנות.',
        focusSection: 'עבור למקטע',
        focusPage: 'עבור להגדרות העמוד',
        pageIssue: 'בעיה בעמוד',
        severity: {
          blocker: 'חוסם',
          warning: 'אזהרה',
        },
        errors: {
          freshnessUnknown: 'לא ניתן לאשר מוכנות. בדוק שוב לפני המשך.',
          publishBlocked: 'בדיקת מוכנות הפרסום נכשלה. תקן את החסימות ונסה שוב.',
          previewBlocked: 'בדיקת מוכנות התצוגה המקדימה נכשלה. תקן את החסימות ונסה שוב.',
        },
        issues: {
          invalidConfiguration: 'הגדרות חזית החנות אינן תקינות.',
          invalidThemeSettings: 'הגדרות העיצוב מכילות בחירות שאינן נתמכות.',
          invalidNavigationTarget: 'פריט ניווט מפנה ליעד שאינו נתמך.',
          unsafeNavigationUrl: 'קישור פרופיל חברתי אינו בטוח.',
          missingNavigationContact: 'קישור יצירת קשר חסר ערוץ ציבורי בחנות.',
          missingStoreLogo: 'העלה לוגו לחנות לפני פרסום חזית החנות.',
          malformedConfig: 'לא ניתן לקרוא את הגדרות חזית החנות.',
          unsupportedEngineVersion: 'גרסת מנוע חזית החנות אינה נתמכת.',
          unsupportedSchemaVersion: 'גרסת אחד המקטעים אינה נתמכת.',
          unsupportedSection: 'קיים מקטע שאינו נתמך.',
          invalidPlacement: 'מקטע נמצא במיקום לא תקין.',
          duplicateSectionId: 'לשני מקטעים יש אותו מזהה.',
          duplicateSingleton: 'מקטע שיכול להופיע פעם אחת בלבד שוכפל.',
          disabledSection: 'מקטע מושבת חוסם תצוגה מקדימה ופרסום.',
          hiddenSection: 'מקטע מוסתר לא יוצג לקונים.',
          draftDeletedSection: 'מקטע שנמחק בטיוטה יוסר בפרסום.',
          restoredSectionInvalid: 'מקטע ששוחזר צריך תוכן ציבורי תקין.',
          invalidLifecycle: 'מצב מחזור החיים של מקטע אינו תקין.',
          invalidOrder: 'סדר המקטעים אינו תקין.',
          invalidProductReference: 'בחירת מוצר כבר אינה זמינה לציבור.',
          invalidCategoryReference: 'בחירת קטגוריה כבר אינה זמינה לציבור.',
          invalidMediaReference: 'בחירת מדיה כבר אינה זמינה לציבור.',
          invalidAdsConfig: 'הגדרות מודעות החנות אינן תקינות.',
          invalidAdsReference: 'בחירת מודעה כבר אינה זמינה לציבור.',
          unsafeAdsDestination: 'יעד מודעה אינו זמין.',
          missingAdsMedia: 'תמונת מודעה אינה זמינה.',
          invalidHeroConfig: 'הגדרות מדור ההירו אינן תקינות.',
          invalidHeroDestination: 'יעד כפתור בהירו כבר אינו זמין.',
          invalidHeroMediaReference: 'תמונת הירו כבר אינה זמינה לציבור.',
          tooManyReferences: 'מקטע מכיל יותר מדי בחירות.',
          unsafePublicConfig: 'יש להסיר שדות ציבוריים לא בטוחים לפני תצוגה מקדימה או פרסום.',
        },
      },
      actions: {
        saveDraft: 'שמור טיוטה',
        savingDraft: 'שומר טיוטה...',
        publish: 'פרסם',
        publishing: 'מפרסם...',
        preview: 'תצוגה מקדימה',
        createPreviewLink: 'צור קישור תצוגה מקדימה',
        publishDisabledReadiness: 'הפרסום מושבת כי יש חסימות מוכנות.',
        previewDisabledReadiness: 'התצוגה המקדימה מושבתת כי יש חסימות מוכנות.',
        rollback: 'חזור לגרסה',
        rollingBack: 'חוזר לגרסה...',
        restoreToDraft: 'שחזר לטיוטה',
      },
      messages: {
        draftSaved: 'הטיוטה נשמרה.',
        published: 'חזית החנות פורסמה.',
        rollbackPublished: 'הגרסה המשוחזרת פורסמה.',
        draftRestored: 'הגרסה שוחזרה לטיוטה. פרסמו אותה כשהיא מוכנה לקונים.',
        previewLinkCreated: 'קישור התצוגה המקדימה נוצר.',
        defaultFallbackActive: 'חזית החנות המוגדרת כברירת מחדל מוצגת עד לפרסום הגדרות.',
        noDraft: 'עדיין אין טיוטה שמורה.',
        noRevisions: 'עדיין אין גרסאות.',
      },
      preview: {
        banner: 'מצב תצוגה מקדימה',
        expired: 'פג התוקף של קישור התצוגה המקדימה.',
        notAvailable: 'התצוגה המקדימה אינה זמינה.',
        noindexLabel: 'מוסתר ממנועי חיפוש',
      },
      revisions: {
        title: 'היסטוריית גרסאות',
        revisionNumber: 'גרסה {{number}}',
        publishedAt: 'פורסם {{date}}',
        publishedBy: 'פורסם על ידי {{name}}',
        rolledBackFrom: 'שוחזר מגרסה {{number}}',
        restoredFrom: 'הועתק מגרסה {{number}}',
        sectionCount: '{{count}} מדורים',
        actions: {
          draft_save: 'שמירת טיוטה',
          publish: 'פרסום',
          rollback: 'חזרה לגרסה',
          restore_to_draft: 'שחזור לטיוטה',
        },
      },
      publishSummary: {
        title: '',
        description: '',
        pendingTitle: '',
        changedSurfacesTitle: '',
        changedSectionsTitle: '',
        changedSectionLine: '',
        noChangedSurfaces: '',
        noChangedSections: '',
        additionalChangedSections: '',
        publicExposureReminder: '',
        confirm: '',
        labels: {
          draft: '',
          localChanges: '',
          workspaceEdits: '',
          readiness: '',
        },
        values: {
          draftExists: '',
          noDraft: '',
          localChanges: '',
          noLocalChanges: '',
          workspaceEdits: '',
          noWorkspaceEdits: '',
        },
        surfaces: {
          seo: '',
          theme: '',
          navigation: '',
          hero: '',
          categories: '',
          ads: '',
          productRails: '',
          contentSections: '',
          sectionOrder: '',
          sectionLifecycle: '',
        },
        sectionTypes: {
          productRails: '',
        },
        changeKinds: {
          added: '',
          removed: '',
          changed: '',
          moved: '',
          statusChanged: '',
        },
      },
      publishOperation: {
        states: {
          idle: 'מוכן לפרסום',
          validating: 'בודק מוכנות',
          savingDraft: 'שומר טיוטה',
          publishing: 'מפרסם',
          published: 'פורסם',
          failedRecoverable: 'הפרסום נכשל',
          blockedReadiness: 'המוכנות חוסמת',
          blockedStale: 'נדרש רענון',
          blockedPermissions: 'אין הרשאה',
        },
        helpers: {
          idle: 'שום דבר לא ציבורי עד האישור.',
          validating: 'בודק את הטיוטה הנוכחית ואת ההפניות הציבוריות.',
          savingDraft: 'שומר שינויים מקומיים לפני הפרסום.',
          publishing: 'מחליף את חזית החנות הציבורית בטיוטה המאושרת.',
          published: 'חזית החנות הציבורית משתמשת עכשיו בגרסה הזו.',
          failedRecoverable: 'הטיוטה נשמרה. שגיאות רשת לא אומרות שחזית החנות הציבורית השתנתה.',
          blockedReadiness: 'תקנו חסימות מוכנות לפני פרסום.',
          blockedStale: 'רעננו מצב לפני פרסום כדי לא להחליף עריכות חדשות יותר.',
          blockedPermissions: 'החשבון הזה לא יכול לפרסם את חזית החנות הזו.',
        },
        actions: {
          retry: 'נסה לפרסם שוב',
          reviewIssues: 'בדוק בעיות',
          refreshState: 'רענן מצב',
          continueEditing: 'המשך עריכה',
        },
      },
      restoreDialog: {
        title: 'שחזור גרסה לטיוטה',
        description: 'בדקו את סיכום הגרסה הבטוח לפני החלפת הטיוטה הנוכחית.',
        confirm: 'שחזר טיוטה',
        restoring: 'משחזר...',
        publicUnaffected: 'זה יוצר טיוטה בלבד. חזית החנות הציבורית לא תשתנה עד לפרסום.',
        labels: {
          status: 'סטטוס',
          action: 'פעולה',
          sections: 'מדורים',
          date: 'תאריך',
        },
      },
      errors: {
        invalidConfiguration: 'הגדרות חזית החנות אינן תקינות.',
        invalidThemeSettings: 'הגדרות העיצוב מכילות בחירות שאינן נתמכות.',
        invalidNavigationTarget: 'פריט ניווט מפנה ליעד שאינו נתמך.',
        unsafeNavigationUrl: 'קישור פרופיל חברתי אינו בטוח.',
        missingNavigationContact: 'קישור יצירת קשר חסר ערוץ ציבורי בחנות.',
        unsupportedEngineVersion: 'גרסת מנוע חזית החנות אינה נתמכת.',
        unsupportedSchemaVersion: 'גרסת המדור אינה נתמכת.',
        invalidPlacement: 'מדור נמצא במיקום לא תקין.',
        duplicateSingleton: 'שוכפל מדור שיכול להופיע פעם אחת בלבד.',
        unsafeRichText: 'הסר טקסט מעוצב לא בטוח לפני השמירה.',
        unsafeMediaReference: 'הסר הפניות מדיה לא בטוחות לפני השמירה.',
        unsafeUrl: 'הסר קישורים לא בטוחים לפני השמירה.',
        crossStoreReference: 'מדור מפנה לתוכן מחנות אחרת.',
        draftNotFound: 'לא ניתן למצוא את הטיוטה.',
        revisionNotFound: 'לא ניתן למצוא את הגרסה.',
        previewExpired: 'פג התוקף של קישור התצוגה המקדימה.',
        publishConflict: 'פרסום אחר שינה את חזית החנות. רענן ונסה שוב.',
        permissionDenied: 'אין לך הרשאה לנהל את חזית החנות הזו.',
        networkFailed: 'החיבור נכשל. בדוק את הרשת ונסה שוב.',
      },
      validation: {
        enabledSection: 'המדור הזה פעיל ויוצג לקונים.',
        hiddenSection: 'המדור הזה מוסתר ולא יוצג לקונים.',
        disabledSection: 'המדור הזה מושבת ולא יוצג לקונים.',
        unsupportedSection: 'המדור הזה אינו נתמך.',
        invalidConfiguration: 'הגדרות המדור אינן תקינות.',
        invalidHeroConfig: 'תוכן מדור ההירו אינו תקין.',
        invalidThemeSettings: 'הגדרות העיצוב מכילות בחירות שאינן נתמכות.',
        invalidNavigationTarget: 'פריט ניווט מפנה ליעד שאינו נתמך.',
        unsafeNavigationUrl: 'קישור פרופיל חברתי אינו בטוח.',
        missingNavigationContact: 'קישור יצירת קשר חסר ערוץ ציבורי בחנות.',
        invalidPlacement: 'אי אפשר להציג את המדור במיקום הזה.',
        duplicateSection: 'אי אפשר לשכפל את המדור הזה.',
        unsupportedEngineVersion: 'גרסת מנוע חזית החנות אינה נתמכת.',
        invalidLifecycleAction: 'פעולת מחזור החיים של המדור אינה מותרת.',
        invalidResponsiveVisibility: 'בחרו נראות תקינה לפחות למכשיר אחד.',
        invalidWorkspaceTemplate: 'תבנית סביבת העבודה הזו אינה נתמכת.',
        invalidLibraryEntry: 'פריט ספריית המדורים הזה אינו נתמך.',
        unsafePublicConfig: 'המדור מכיל שדות שאסור לפרסם.',
        unsafeMediaReference: 'המדור מכיל הפניית מדיה לא בטוחה.',
        unsafeRichText: 'המדור מכיל טקסט מעוצב לא בטוח.',
        unsafeUrl: 'המדור מכיל קישור לא בטוח.',
        crossStoreReference: 'המדור מפנה לחנות אחרת.',
      },
      fallback: {
        sectionUnavailable: 'אי אפשר להציג את המדור כרגע.',
      },
      seo: {
        title: 'חיפוש ושיתוף',
        description: 'הגדר את הכותרת, התיאור והתמונה שיוצגו לקונים ולמנועי חיפוש.',
        fields: {
          title: 'כותרת חיפוש',
          description: 'תיאור חיפוש',
          socialImage: 'תמונת שיתוף',
        },
        locales: {
          ar: 'ערבית',
          he: 'עברית',
          en: 'אנגלית',
        },
        placeholders: {
          title: 'כתבו כותרת חנות קצרה',
          description: 'כתבו תיאור חנות בטוח ותמציתי',
        },
        counters: {
          text: '{{count}} מתוך {{max}}',
        },
        actions: {
          apply: 'החל מטא נתוני חיפוש',
          cancel: 'בטל שינויי חיפוש',
          reset: 'אפס מטא נתוני חיפוש',
        },
        status: {
          clean: 'אין שינויים שלא הוחלו.',
          dirty: 'החילו או בטלו שינויי חיפוש לפני שמירה או פרסום.',
        },
        messages: {
          applied: 'מטא נתוני החיפוש הוחלו על הטיוטה.',
          reset: 'מטא נתוני החיפוש אופסו לברירת המחדל.',
        },
        errors: {
          invalidMetadata: 'מטא נתוני החיפוש לא הוחלו. הטיוטה הקודמת נשארה ללא שינוי.',
          unsafeText: 'השתמשו בטקסט רגיל בלבד, ללא קישורים או תגיות.',
          titleTooLong: 'כותרת החיפוש ארוכה מהמגבלה.',
          descriptionTooLong: 'תיאור החיפוש ארוך מהמגבלה.',
          staleBuilder: 'חזית החנות השתנתה במקום אחר. רענן לפני שינוי מטא נתוני החיפוש.',
        },
      },
      theme: {
        title: 'עיצוב החנות',
        description: 'שלוט בעיצוב הכללי של חזית החנות באמצעות בחירות מאושרות של Dukanti.',
        actions: {
          reset: 'אפס לעיצוב ברירת המחדל',
        },
        presets: {
          title: 'תבניות עיצוב',
          custom: 'שילוב מותאם של אסימוני עיצוב',
          selected: 'נבחר',
          apply: 'החל',
          items: {
            'dukanti-default': {
              name: 'Dukanti ניטרלי',
              description: 'נקודת פתיחה שקטה עם רקע ניטרלי ופינות רכות.',
            },
            'olive-grove': {
              name: 'חורשת זיתים',
              description: 'גווני זית חמים למוצרים מקומיים ומלאכת יד.',
            },
            'saffron-market': {
              name: 'שוק זעפרן',
              description: 'הדגשה ענברית ברורה למבצעים וחזיתות פעילות.',
            },
            'stone-boutique': {
              name: 'בוטיק אבן',
              description: 'משטחים נקיים ומרווח צפוף לחנויות עם הרבה מוצרים.',
            },
            'galilee-mist': {
              name: 'ערפל גלילי',
              description: 'כחול-זית רגוע ומרווח נדיב לחזית עדינה.',
            },
            'heritage-paper': {
              name: 'נייר מורשת',
              description: 'טיפוגרפיה עריכתית ורקע נייר לסיפור חנות חם יותר.',
            },
          },
        },
        fields: {
          palette: 'פלטה',
          primary: 'צבע ראשי',
          accent: 'צבע הדגשה',
          background: 'רקע',
          surface: 'משטח',
          text: 'טקסט',
          typography: 'טיפוגרפיה',
          buttonRadius: 'עיגול כפתורים',
          cardRadius: 'עיגול כרטיסים',
          spacing: 'מרווחי מקטעים',
        },
        palettes: {
          'dukanti-default': 'ברירת המחדל של Dukanti',
          'olive-grove': 'חורשת זיתים',
          'saffron-market': 'שוק זעפרן',
        },
        colorTokens: {
          'neutral-ink': 'דיו ניטרלי',
          'semantic-status': 'צבעי מצב',
          'neutral-canvas': 'רקע ניטרלי',
          'neutral-surface': 'משטח ניטרלי',
          'zaatar-olive': 'זעתר זית',
          'zaatar-deep': 'זעתר עמוק',
          'saffron-amber': 'ענבר זעפרן',
          'zaatar-soft': 'זעתר רך',
          'olive-mist': 'ערפל זיתים',
          paper: 'נייר',
          'stone-100': 'אבן חמה',
          'zaatar-wash': 'שטיפת זעתר',
          'stone-700': 'אבן כהה',
          'stone-600': 'אבן רכה',
        },
        typography: {
          'language-default': 'ברירת המחדל של השפה',
          'heritage-editorial': 'מורשת עריכתית',
          'modern-market': 'שוק מודרני',
          'clean-commerce': 'מסחר נקי',
        },
        radius: {
          crisp: 'חד',
          soft: 'רך',
          rounded: 'מעוגל',
        },
        spacing: {
          compact: 'קומפקטי',
          comfortable: 'נוח',
          spacious: 'מרווח',
        },
        messages: {
          applied: 'עיצוב החנות הוחל על הטיוטה.',
          reset: 'עיצוב החנות אופס לברירת המחדל.',
        },
        errors: {
          invalidThemeSettings: 'העיצוב הזה לא הוחל. הטיוטה הקודמת נשארה ללא שינוי.',
          staleBuilder: 'חזית החנות השתנתה במקום אחר. רענן לפני שינוי העיצוב.',
        },
      },
      chrome: {
        title: 'כותרת וניווט',
        description: 'הגדירו את רצועת ההודעות, כותרת החנות, התחתית וניווט הקונים.',
        fields: {
          announcementBar: 'רצועת ההודעות',
          announcementBarEnabled: 'הצגת רצועת ההודעות',
          announcementBarText: 'טקסט ההודעה',
          announcementBarLink: 'קישור (אופציונלי)',
          headerBrand: 'מותג בכותרת',
          headerLinks: 'קישורי כותרת',
          footerBrand: 'מותג בכותרת התחתונה',
          footerLinks: 'קישורי כותרת תחתונה',
          footerContact: 'יצירת קשר בכותרת תחתונה',
          socialLinks: 'קישורים חברתיים',
          mobileItems: 'ניווט במובייל',
          target: 'יעד',
          collection: 'אוסף',
          categoryId: 'מזהה קטגוריה',
          socialProvider: 'פרופיל חברתי',
          socialUrl: 'קישור פרופיל',
        },
        placeholders: {
          categoryId: '00000000-0000-0000-0000-000000000000',
        },
        announcementBarLink: {
          none: 'ללא קישור',
        },
        hints: {
          announcementBarText: 'עד 140 תווים לכל שפה. השאירו ריק בכל השפות כדי שלא יוצג דבר.',
        },
        actions: {
          reset: 'אפס כותרת וניווט',
          apply: 'החל ניווט',
          add: 'הוסף',
          remove: 'הסר',
          moveUp: 'העבר למעלה',
          moveDown: 'העבר למטה',
        },
        headerBrand: {
          logo: 'לוגו',
          name: 'שם',
          'logo-and-name': 'לוגו ושם',
        },
        footerBrand: {
          'dukanti-and-store': 'Dukanti והחנות',
          'store-only': 'החנות בלבד',
          'dukanti-only': 'Dukanti בלבד',
        },
        messages: {
          applied: 'הכותרת והניווט הוחלו על הטיוטה.',
          reset: 'הכותרת והניווט אופסו לברירת המחדל.',
        },
        errors: {
          invalidNavigation: 'ההגדרות האלה לא הוחלו. הטיוטה הקודמת נשארה ללא שינוי.',
          unsafeSocialUrl: 'השתמש בקישור HTTPS ישיר לפרופיל Instagram או Facebook.',
          missingNavigationContact: 'קישור הקשר הזה צריך טלפון או וואטסאפ ציבורי בחנות.',
          staleBuilder: 'חזית החנות השתנתה במקום אחר. רענן לפני שינוי הכותרת והניווט.',
          invalidAnnouncementText: 'טקסט ההודעה חייב להיות טקסט פשוט עד 140 תווים וללא קישורים.',
        },
      },
    },
    dashboard: {
      title: 'לוח הבקרה',
      subtitle: 'עקוב אחר מצב החנות והמשימות החשובות במקום אחד',
      storeCreatedBanner: 'החנות שלך נוצרה בהצלחה!',
      nextStep: 'הצעד הבא: הוסף את המוצר הראשון שלך',
      addProduct: 'הוסף מוצר',
      viewProducts: 'צפה במוצרים',
      storeUrl: 'כתובת החנות',
      logoUploadWarning:
        'החנות שלך נוצרה בהצלחה, אך העלאת הלוגו נכשלה. תוכל להוסיף אותו מאוחר יותר בהגדרות.',
      metrics: {
        loadingValue: 'טוען',
        errorValue: 'לא זמין',
        loadingHelper: 'סיכום זה נטען כעת',
        errorHelper: 'לא ניתן לטעון סיכום זה',
        products: {
          title: 'מוצרים',
          helper: '{{published}} פורסמו מתוך {{count}} מוצגים',
          ariaLabel: 'פתח מוצרים',
        },
        orders: {
          title: 'הזמנות חדשות',
          helper: 'העמוד הראשון של ההזמנות החדשות הנכנסות',
          ariaLabel: 'פתח הזמנות חדשות',
        },
        stock: {
          title: 'וריאנטים פעילים הדורשים תשומת לב',
          helper: 'וריאנטים פעילים: {{out}} אזלו · {{low}} במלאי נמוך',
          ariaLabel: 'סקירת מלאי של וריאנטים פעילים',
        },
        storefront: {
          title: 'חזית החנות',
          published: 'פעילה',
          draft: 'טיוטה',
          helper: 'מצב החזית הציבורית של החנות',
          ariaLabel: 'פתח חזית חנות',
        },
      },
      recentOrders: {
        title: 'ההזמנות החדשות האחרונות',
        viewAll: 'צפה בכל ההזמנות',
        loading: 'טוען הזמנות',
        empty: 'אין כרגע הזמנות חדשות',
        error: 'לא ניתן לטעון הזמנות חדשות',
      },
      stockAttention: {
        title: 'וריאנטים פעילים הדורשים תשומת לב',
        viewStock: 'סקירת המלאי הפעיל',
        loading: 'טוען מלאי',
        empty: 'אין וריאנטים פעילים שאזלו או עם מלאי נמוך.',
        error: 'לא ניתן לטעון התראות מלאי',
      },
      nextStepCard: {
        title: 'הצעד הבא',
        description: 'הוסף מוצר חדש או בדוק את רשימת המוצרים הקיימת.',
      },
      snapshotNotice: 'המספרים הם סיכום תפעולי מהנתונים הזמינים כרגע.',
    },
    shell: {
      tabTitle: '({{count}}) דוקאנטי - ניהול',
      tabTitleDefault: 'דוקאנטי - ניהול',
    },
    authBoundary: {
      pendingTitle: 'ממתין להרשאת ניהול',
      pendingBody: 'התחברת, אך עדיין אין לחשבון הזה חברות פעילה בחנות.',
      unauthorizedTitle: 'אין הרשאת ניהול',
      unauthorizedBody: 'לחשבון הזה אין חברות בחנות בדוקנתי.',
      missingTitle: 'זה אינו חשבון סוחר',
      missingBody: 'כדי לנהל חנות בדוקאנטי, צור חשבון סוחר והמתן לאישור הצוות לפני יצירת חנות.',
      signOut: 'התנתקות',
    },
    barcode: {
      entry: {
        scanReceiving: 'קליטת מלאי בברקוד',
        searchByBarcode: 'חיפוש לפי ברקוד',
        scanBarcode: 'סריקת ברקוד',
        productsAction: 'חיפוש ברקוד',
        stockAction: 'סריקה לקליטה',
      },
      scan: {
        title: 'קליטת מוצרים בברקוד',
        subtitle: 'סרקו, הדביקו או הקלידו ברקוד כדי למצוא את הווריאנט המדויק.',
        inputLabel: 'ברקוד',
        inputPlaceholder: 'סרקו או הקלידו ברקוד',
        submit: 'חיפוש',
        search: { submit: 'admin.barcode.search.submit' },
        scanAnother: 'סריקת מוצר נוסף',
        ready: 'מוכן לסריקה',
        normalizedHint: 'רווחים בתחילת ובסוף הברקוד מהסורק מתעלמים מהם.',
        cameraOpen: 'סריקה במצלמה',
        cameraTitle: 'סריקת ברקוד במצלמה',
        cameraDescription:
          'כוונו את המצלמה לברקוד והחזיקו את הטלפון יציב לרגע. הסריקה תתבצע אוטומטית.',
        modeGroupLabel: 'סוג ברקוד',
        modeStoreLabels: 'תוויות חנות',
        modeStoreLabelsDescription:
          'לברקודים שהחנות יוצרת או מדפיסה בעצמה. זו האפשרות היציבה ביותר.',
        modeRetailProducts: 'מוצרי מדף',
        modeRetailProductsDescription:
          'לברקודים של יצרן שכבר מודפסים על מוצרים ארוזים, כמו EAN או UPC.',
        modeCompactCodes: 'קודים קצרים',
        modeCompactCodesDescription:
          'לקודים קצרים על מוצרים קטנים. דורש קריאות יציבות יותר כדי לצמצם טעויות.',
        cameraVideoLabel: 'תצוגת מצלמה חיה לסריקת ברקוד',
        cameraIdle: 'המצלמה מוכנה.',
        cameraStatusStarting: 'מפעיל מצלמה...',
        cameraStatusScanning: 'מחפש ברקוד... מקמו אותו בתוך המסגרת והחזיקו יציב.',
        cameraConsensusProgress: '{{count}} מתוך {{required}} קריאות תואמות. החזיקו יציב.',
        cameraDetected: 'ברקוד זוהה.',
        cameraClose: 'סגירת הסורק',
        cameraTryAgain: 'נסה שוב',
        cameraSecureContextRequired:
          'סריקת מצלמה בטלפון דורשת HTTPS. פתחו את קישור הבדיקה המקומי המאובטח או הקלידו את הברקוד.',
        cameraUnsupported: 'סריקת מצלמה אינה זמינה בדפדפן הזה.',
        cameraPermissionDenied: 'הגישה למצלמה נחסמה. אפשרו גישה למצלמה או הקלידו את הברקוד.',
        cameraDecodeFailed: 'לא ניתן להפעיל את סורק המצלמה. הקלידו את הברקוד או נסו שוב.',
      },
      result: {
        // Compatibility aliases for F-045 tests and older call sites.
        known: { title: 'admin.barcode.known.title' },
        unknown: { title: 'admin.barcode.unknown.title' },
        deletedRecoverable: { title: 'admin.barcode.deletedRecoverable.title' },
        knownTitle: 'נמצא וריאנט',
        unknownTitle: 'ברקוד לא מוכר',
        deletedTitle: 'התאמה לברקוד שנמחק',
        invalidTitle: 'ברקוד לא תקין',
        product: 'מוצר',
        variant: 'וריאנט',
        category: 'קטגוריה',
        price: 'מחיר',
        stock: 'מלאי',
        status: {
          active: 'פעיל',
          disabled: 'מושבת',
          outOfStock: 'אזל מהמלאי',
          unpublished: 'לא פורסם',
        },
        editProduct: 'עריכת מוצר',
        updateStock: 'עדכון מלאי',
        createProduct: 'יצירת מוצר עם הברקוד הזה',
        reuseDeleted: 'שימוש חוזר בברקוד הזה',
      },
      stock: {
        mode: {
          addReceived: 'הוספת כמות שהתקבלה',
          setExact: 'קביעת מלאי מדויק',
        },
        quantityLabel: 'כמות שהתקבלה',
        exactLabel: 'מלאי מדויק',
        success: 'המלאי עודכן',
        errors: {
          positiveAdd: 'הזינו כמות גדולה מאפס.',
          nonNegative: 'המלאי לא יכול להיות שלילי.',
          wholeNumber: 'הזינו מספר שלם.',
          maxQuantity: 'הכמות חייבת להיות עד {{max}}.',
        },
      },
      errors: {
        lookupFailed: 'לא ניתן לחפש את הברקוד הזה.',
        permissionDenied: 'אין לך הרשאה להשתמש בברקוד הזה.',
        networkFailed: 'החיבור נכשל. נסו שוב.',
        unknown: 'משהו השתבש בזמן חיפוש הברקוד.',
      },
    },
    offerCampaigns: {
      title: 'קמפיינים של מבצעים',
      subtitle: 'ארגן מוצרים במבצע לקמפיין מוגבל בזמן.',
      addNew: 'קמפיין חדש',
      adsTab: 'מודעות',
      campaignsTab: 'קמפיינים',
      emptyTitle: 'עדיין אין קמפיינים',
      emptyDescription: 'צור קמפיין מהמוצרים שכבר במבצע.',
      visibilityNotice:
        'בחזית החנות מוצגים עד 3 קמפיינים פעילים אחרי הקטגוריות, לפי שעת הסיום הקרובה ביותר.',
      publicLink: 'קישור למבצע',
      copyLink: 'העתק קישור',
      editCampaign: 'עריכת {{title}}',
      dateRange: 'מ-{{start}} עד {{end}}',
      toasts: {
        created: 'הקמפיין נוצר.',
        updated: 'הקמפיין נשמר.',
        deleted: 'הקמפיין נמחק.',
        linkCopied: 'הקישור הועתק.',
      },
      form: {
        pageTitleCreate: 'קמפיין מבצע חדש',
        pageTitleEdit: 'עריכת קמפיין',
        back: 'חזרה לקמפיינים',
        titleLabel: 'כותרת הקמפיין',
        titlePlaceholder: 'לדוגמה: מבצעי סוף שבוע',
        descriptionLabel: 'תיאור קצר',
        descriptionPlaceholder: 'כתוב בקצרה למה המבצע מיוחד',
        startsAtLabel: 'שעת התחלה',
        endsAtLabel: 'שעת סיום',
        activeLabel: 'הקמפיין פעיל',
        sellablesLabel: 'מוצרים במבצע',
        submitCreate: 'יצירת קמפיין',
        submitEdit: 'שמירת קמפיין',
      },
      picker: {
        searchLabel: 'חיפוש מוצר במבצע',
        searchPlaceholder: 'שם מוצר או אפשרות',
        loading: 'טוען מוצרים במבצע...',
        empty: 'אין מוצרים במבצע שמתאימים.',
        selected: 'נבחרו {{count}}',
        defaultVariant: 'אפשרות ברירת מחדל',
        optionWithCategory: '{{category}}: {{variant}}',
        ineligible: 'כבר לא מתאים',
      },
      status: {
        scheduled: 'מתוזמן',
        live: 'פעיל עכשיו',
        ended: 'הסתיים',
        inactive: 'לא פעיל',
      },
      delete: {
        title: 'למחוק את הקמפיין?',
        description: 'הקמפיין לא יוצג ללקוחות אחרי המחיקה.',
        confirm: 'מחיקת קמפיין',
      },
      errors: {
        titleRequired: 'הזן כותרת לקמפיין.',
        titleTooLong: 'הכותרת ארוכה מדי.',
        descriptionTooLong: 'התיאור ארוך מדי.',
        titleInvalid: 'אי אפשר להשתמש בסימני כיוון מוסתרים בטקסט.',
        invalidWindow: 'שעת הסיום חייבת להיות אחרי שעת ההתחלה.',
        emptySelection: 'בחר לפחות מוצר אחד במבצע.',
        ineligibleSellable: 'חלק מהמוצרים שנבחרו כבר אינם מתאימים לקמפיין.',
        itemLimitExceeded: 'אפשר לבחור עד 48 מוצרים בקמפיין אחד.',
        duplicateSelection: 'אי אפשר לבחור את אותו מוצר יותר מפעם אחת.',
        permissionDenied: 'אין לך הרשאה לנהל את הקמפיין הזה.',
        notFound: 'הקמפיין לא נמצא.',
      },
    },
    promotionKit: {
      tabs: { kit: 'ערכת קידום' },
      title: 'ערכת קידום',
      subtitle: 'הכן קישור, הודעה, פוסטר QR ותמונת סטורי לחנות שלך.',
      target: {
        label: 'מה תרצה לקדם?',
        search: 'חפש יעד',
        loadMore: 'הצג עוד',
        groups: {
          storeHome: 'עמוד החנות',
          product: 'מוצרים',
          category: 'קטגוריות',
          liveOfferCampaign: 'מבצעים פעילים',
          salesPage: 'עמוד מבצעים',
          reviewHighlight: 'המלצות בולטות',
        },
        unavailable: { targetUnavailable: 'היעד הזה כבר אינו זמין לשיתוף.' },
      },
      locale: { label: 'שפת ההודעה' },
      actions: {
        copyUrl: 'העתק קישור',
        copyMessage: 'העתק הודעה',
        openWhatsapp: 'פתח WhatsApp',
        downloadPoster: 'הורד פוסטר',
        printPoster: 'הדפס פוסטר',
        downloadStory: 'הורד סטורי',
      },
      preview: {
        whatsappTitle: 'הודעת WhatsApp',
        urlTitle: 'קישור ציבורי',
        posterTitle: 'פוסטר QR',
        storyTitle: 'תמונת סטורי',
      },
      analytics: {
        title: 'תוצאות הקישור',
        empty: 'אין עדיין תוצאות לקישור הזה.',
        linkVisits: 'ביקורי מסלול מיוחסים',
        productViews: 'צפיות במוצר',
        contactClicks: 'לחיצות יצירת קשר',
        addToCartClicks: 'לחיצות הוספה לעגלה',
        orderStartClicks: 'התחלות הזמנה',
        countOverflowed: 'הספירה הגיעה למגבלה הטכנית.',
      },
      empty: {
        noPublicTargets: 'פרסם את החנות או הוסף מוצר ציבורי כדי להתחיל.',
        noLiveOffers: 'אין מבצעים פעילים עכשיו.',
        noReviews: 'אין ביקורות גלויות עם טקסט לשיתוף.',
      },
      errors: {
        permissionDenied: 'אין לך הרשאה לנהל את ערכת הקידום של החנות הזו.',
        targetUnavailable: 'היעד הזה אינו זמין לשיתוף כרגע.',
        linkUnavailable: 'לא ניתן להכין את קישור השיתוף.',
        assetFailed: 'לא ניתן להכין את התמונה. נסה שוב.',
        clipboardFailed: 'לא ניתן להעתיק. העתק את הטקסט ידנית.',
      },
      toasts: {
        urlCopied: 'הקישור הועתק',
        messageCopied: 'ההודעה הועתקה',
        posterDownloaded: 'הפוסטר הורד',
        storyDownloaded: 'הסטורי הורד',
      },
    },
    welcome: 'ברוכים הבאים ל-Dukanti',
    home: {
      hero: 'ברוכים הבאים לדוקנטי',
      subhero: 'פתח את החנות המקוונת שלך',
      signUpCta: 'צור חשבון',
      signInCta: 'התחבר',
    },
    nav: {
      subscribers: 'מנויים',
      ariaLabel: 'ניווט ראשי',
      dashboard: 'לוח בקרה',
      settings: 'הגדרות',
      products: 'מוצרים',
      categories: 'קטגוריות',
      promotions: 'שיווק',
      billing: 'חיוב',
      orders: 'הזמנות',
      prepareOrder: 'הכנת הזמנה',
      reviews: 'ביקורות',
      couriers: 'שליחים',
      stock: 'מלאי',
      storefront: 'חזית החנות',
      addProduct: 'הוסף מוצר',
      addProductAria: 'הוסף מוצר חדש',
      ordersShortcut: 'הזמנות חדשות',
      storeWorkspace: 'מרחב החנות',
      storeFallback: 'החנות שלי',
      accountFallback: 'חשבון סוחר',
      storeSettings: 'הגדרות החנות',
      signOut: 'התנתקות',
      signOutDialog: {
        title: 'להתנתק?',
        body: 'יהיה צורך להתחבר שוב לפני ניהול החנות.',
        cancel: 'הישאר מחובר',
        confirm: 'התנתק',
      },
      openSidebar: 'פתח תפריט',
      closeSidebar: 'סגור תפריט',
      toggleSidebar: 'החלף תפריט צד',
      sidebarTitle: 'תפריט צד',
      sidebarDescription: 'מציג את תפריט הניווט הצדדי של הניהול.',
      skipToContent: 'דלג לתוכן הראשי',
      languageSwitcher: 'שפה',
      unsavedChanges: {
        title: 'יש לך שינויים שלא נשמרו',
        body: 'לעזוב בכל זאת? העריכות שלך יאבדו.',
        stay: 'הישאר',
        leave: 'עזוב',
      },
    },
    billing: {
      title: 'חיוב',
      subtitle: 'בחר את תוכנית Dukanti לחנות הזו.',
      permissionDeniedBody:
        'שינויי חיוב מוגבלים לבעל החנות. בקש מבעל החנות לפתוח את הדף הזה או לעדכן את המינוי.',
      currentPlan: {
        title: 'תוכנית נוכחית',
        none: 'אין מינוי פעיל',
        pending: 'ממתין לאישור PayPal',
      },
      interval: { monthly: 'חודשי', annual: 'שנתי' },
      plan: {
        starter: { name: 'Starter' },
        growth: { name: 'Growth' },
        pro: { name: 'Pro' },
        priceMonthly: '{{price}} / חודש',
        priceAnnual: '{{price}} / שנה',
        activeProducts: '{{count}} מוצרים פעילים',
        mediaStorage: '{{size}} אחסון מדיה',
        aiImageEdits: '{{count}} עריכות תמונה ב-AI',
        promotionTools: { basic: 'שיתוף בסיסי של קישור חנות', full: 'ערכת קידום מלאה' },
        analytics: { basic: 'אנליטיקה בסיסית', advanced: 'אנליטיקה מתקדמת' },
        support: { standard: 'תמיכה רגילה', priority: 'תמיכה בעדיפות' },
      },
      actions: {
        subscribe: 'הירשם',
        upgrade: 'שדרג',
        downgrade: 'שנמך',
        intervalChange: 'שנה תקופה',
        cancel: 'בטל מינוי',
        retryPayment: 'נסה תשלום שוב',
        updatePayment: 'עדכן תשלום',
        confirmRevision: 'אשר שינוי',
        continueApproval: 'המשך אישור',
      },
      paypal: {
        loading: 'טוען אישור PayPal...',
        closed: 'חלון האישור נסגר. לא הופעל מינוי; בחר שוב PayPal או כרטיס כשתהיה מוכן.',
        pendingNotice: 'אישור PayPal מתחיל כאן, אבל Dukanti מפעילה גישה רק אחרי אישור מהשרת.',
        selectedLabel: 'תוכנית נבחרת',
        selectedTitle: 'השלמת אישור עבור {{plan}}',
        selectedSummary: 'תוכנית {{plan}} במחיר {{price}}',
        paymentMethods: 'בחר איך לאשר את המינוי הזה',
      },
      pilot: {
        subtitle: 'Dukanti מפעילה את החנות הזו בפיילוט השקה חינמי. אין צורך באמצעי תשלום כרגע.',
        activeTitle: 'גישת הפיילוט פעילה',
        activeBody:
          'לחנות הזו יש גישת השקה ברמת Pro עד {{date}}. תוכניות התשלום מושהות בזמן הפיילוט.',
        paidActiveTitle: 'גישת הפלטפורמה פעילה',
        paidActiveBody:
          'לחנות הזו עדיין יש גישת מינוי מאומתת. שינויי תשלום מושהים בזמן פיילוט ההשקה.',
        expiredTitle: 'גישת הפיילוט הסתיימה',
        expiredBody: 'פעולות החנות והחנות הציבורית מושהות עד ש-Dukanti תאריך גישה או תפעיל חיוב.',
        windowTitle: 'חלון פיילוט של 30 יום',
        windowBody: 'גישת הפיילוט הנוכחית מסתיימת ב-{{date}}.',
        storefrontTitle: 'מנוע החנות',
        storefrontBody:
          'אפשר להמשיך לבנות, להציג תצוגה מקדימה ולפרסם את החנות בזמן שגישת הפיילוט פעילה.',
        storefrontCta: 'פתח את בונה החנות',
        overageTitle: 'השימוש דורש תשומת לב',
      },
      usage: {
        activeProducts: 'מוצרים פעילים',
        mediaStorage: 'אחסון מדיה',
        aiEdits: 'עריכות תמונה ב-AI',
        noLimit: 'אין כרגע קיבולת בתשלום זמינה.',
      },
      diagnostics: {
        title: 'אבחון חיוב',
        environment: 'סביבת PayPal',
        lastSync: 'סנכרון PayPal אחרון',
        empty: 'לא זמין',
        notStarted: 'אין עדיין מינוי',
      },
      toast: {
        activated: 'המינוי הופעל.',
        reconsentReady: 'אישור PayPal מוכן. השלם את האישור כדי לשנות תוכנית.',
        cancelled: 'הביטול נשלח. הגישה נשארת עד סוף חלון התשלום.',
        retryStarted: 'ניסיון התשלום התחיל.',
      },
      status: {
        missing: 'נדרש מינוי',
        configurationError: 'החיוב אינו זמין',
        approvalPending: 'ממתין לאישור',
        active: 'פעיל',
        grace: 'תשלום באיחור',
        cancelledPendingPeriodEnd: 'בוטל, גישה עד סוף התקופה',
        cancelled: 'בוטל',
        limited: 'מוגבל',
        suspended: 'מושהה',
        expired: 'פג תוקף',
      },
      warning: {
        pastDue: 'התשלום נכשל. הגישה נמשכת עד {{deadline}}.',
        limited: 'פעולות בתשלום חסומות עד להסדרת החיוב.',
        overProductLimit: 'החנות עברה את מגבלת המוצרים הפעילים.',
        overStorageLimit: 'החנות עברה את מגבלת אחסון המדיה.',
        overAiImageEdits: 'החנות ניצלה את כל עריכות התמונה לתקופה.',
      },
      dialog: {
        cancel: {
          title: 'לבטל מינוי?',
          description: 'הגישה בתשלום נשארת זמינה עד {{date}}. נתוני החנות הקיימים לא נמחקים.',
        },
        changePlan: {
          title: 'שינוי תוכנית',
          planSummary: '{{plan}} - {{price}}',
          overLimitDescription:
            'חלק מהשימוש הנוכחי גבוה מהמגבלה בתוכנית היעד ופעולות חדשות בתשלום עשויות להיחסם אחרי השינוי.',
          approvalDescription: 'אישור PayPal מוכן. פתח את PayPal כדי לאשר את שינוי התוכנית.',
          openPayPalApproval: 'פתח אישור PayPal',
        },
      },
      errors: {
        permissionDenied: 'רק בעל החנות יכול לנהל חיוב.',
        paypalUnavailable: 'PayPal אינו זמין כרגע.',
        configurationMissing: 'החיוב לא מוגדר לסביבה הזו.',
        activationPending: 'אישור PayPal בהמתנה. הגישה עדיין לא פעילה.',
        planMismatch: 'תוכנית PayPal לא תואמת לתוכנית Dukanti.',
        planAlreadyActive: 'התוכנית הזו כבר פעילה.',
        reconsentRequired: 'נדרש אישור PayPal כדי להשלים את השינוי.',
        webhookUnverified: 'אימות PayPal נכשל.',
        paymentPaused: 'התשלומים מושהים בזמן ש-Dukanti מפעילה את פיילוט ההשקה.',
        retry: 'פעולת החיוב נכשלה. נסה שוב.',
      },
    },
    entitlements: {
      upgradePrompt: {
        title: 'נדרש שדרוג',
        description: 'שדרג את תוכנית החנות כדי להשתמש בתכונה הזו.',
      },
      promotionKitBlocked: 'שדרג ל-Growth או Pro כדי להשתמש בכלי הקידום האלה.',
      productLimitBlocked: 'הגעת למגבלת המוצרים הפעילים.',
      storageLimitBlocked: 'הגעת למגבלת אחסון המדיה.',
      aiQuotaBlocked: 'מכסת עריכות התמונה ב-AI נוצלה.',
      reasons: {
        missingSubscription: 'בחר תוכנית Dukanti לפני שימוש בתכונות בתשלום.',
        configurationError: 'החיוב אינו מוגדר לסביבה הזו.',
        activationPending: 'אישור PayPal בהמתנה. הגישה עדיין לא פעילה.',
        paymentRequired: 'נדרשת גישה בתשלום לפעולה הזו.',
        suspended: 'המנוי הזה מושעה. הסדר את החיוב לפני המשך.',
        expired: 'המנוי הזה פג. חדש את החיוב לפני המשך.',
        cancelled: 'המינוי הזה בוטל. בחר תוכנית כדי לחדש גישה בתשלום.',
        productLimitReached: 'הגעת למגבלת המוצרים הפעילים.',
        storageLimitReached: 'הגעת למגבלת אחסון המדיה.',
        aiQuotaExhausted: 'מכסת עריכות התמונה ב-AI נוצלה.',
        planUpgradeRequired: 'שדרג את תוכנית החנות כדי להמשיך.',
        permissionDenied: 'אין לך הרשאה להשתמש בתכונה הזו בתשלום.',
        ownerRequired: 'רק בעל החנות יכול לנהל חיוב.',
        paidBasisMissing: 'ראיית תשלום מ-PayPal עדיין לא זמינה. נסה שוב בעוד רגע.',
        environmentMismatch: 'הגדרות sandbox/live של PayPal אינן תואמות למסד נתוני החיוב הזה.',
      },
    },
    reviews: {
      title: 'ביקורות מוצרים',
      emptyTitle: 'אין עדיין ביקורות',
      emptyDescription: 'ביקורות מאומתות יופיעו כאן אחרי מסירת הזמנות.',
      loadMore: 'טען עוד',
      columns: {
        product: 'מוצר',
        rating: 'דירוג',
        review: 'ביקורת לקוח',
        visibility: 'נראות',
        response: 'תגובת חנות',
        date: 'תאריך',
        actions: 'פעולות',
      },
      filters: {
        product: 'מוצר',
        allProducts: 'כל המוצרים',
        productSearch: 'חיפוש מוצרים עם ביקורות',
        previousProducts: 'מוצרים קודמים',
        moreProducts: 'עוד מוצרים עם ביקורות',
        visibility: 'נראות',
      },
      visibility: {
        all: 'הכול',
        visible: 'גלוי',
        hidden: 'מוסתר',
        reasonRequired: 'בחרו סיבת הסתרה',
        noteTooLong: 'ההערה חייבת להיות עד 500 תווים',
      },
      actions: {
        respond: 'תגובה',
        editResponse: 'עריכת תגובה',
        removeResponse: 'הסרת תגובה',
        hide: 'הסתרה',
        unhide: 'הצגה מחדש',
        disabledForStaff: 'הפעולה זמינה רק לבעלים או מנהל',
      },
      response: {
        title: 'תגובת החנות',
        placeholder: 'כתבו תגובה קצרה ללקוח',
        save: 'שמירת תגובה',
        required: 'כתבו תגובה קצרה',
        tooLong: 'התגובה חייבת להיות עד 1000 תווים',
      },
      hideReasons: {
        abusive: 'תוכן פוגעני',
        privateInfo: 'כולל מידע פרטי',
        offTopic: 'לא קשור לנושא',
        spam: 'ספאם או חזרה',
        other: 'סיבה אחרת',
      },
      moderation: {
        hideTitle: 'הסתרת ביקורת',
        unhideTitle: 'הצגת ביקורת מחדש',
        reasonLabel: 'סיבת הסתרה',
        noteLabel: 'הערה פנימית',
        notePlaceholder: 'אופציונלי, גלוי רק לניהול',
        hiddenMeta: 'מוסתר: {{reason}}',
      },
      errors: {
        permissionDenied: 'אין לך הרשאה לערוך ביקורות',
        loadFailed: 'לא ניתן לטעון ביקורות',
      },
    },
    createStore: {
      title: 'יצירת החנות שלך',
      subtitle: 'הזן את פרטי החנות שלך כדי להתחיל',
      nameLabel: 'שם החנות',
      namePlaceholder: 'לדוגמה: המכולת של אחמד',
      descriptionLabel: 'תיאור החנות',
      descriptionPlaceholder: 'תאר את החנות והמוצרים שלך בקצרה',
      slugLabel: 'כתובת החנות',
      slugPlaceholder: 'my-store',
      slugHint: 'כתובת החנות שלך תהיה: {{slug}}.{{domain}}',
      slugAvailable: 'הכתובת פנויה',
      slugChecking: 'בודק...',
      logoLabel: 'לוגו החנות (אופציונלי)',
      logoHint: 'JPEG, PNG או WEBP, עד 2MB',
      logoRemove: 'הסר לוגו',
      logoUpload: 'העלאת לוגו',
      submit: 'צור חנות',
      submitting: 'יוצר חנות...',
      welcomeBanner: 'ברוך הבא! בדוק את האימייל שלך כדי לאמת את החשבון.',
      errors: {
        nameRequired: 'שם החנות נדרש',
        nameTooLong: 'שם החנות חייב להיות עד 100 תווים',
        descriptionRequired: 'תיאור החנות נדרש',
        descriptionTooLong: 'התיאור חייב להיות עד 500 תווים',
        slugRequired: 'כתובת החנות נדרשת',
        slugTooShort: 'הכתובת חייבת להיות לפחות 3 תווים',
        slugTooLong: 'הכתובת חייבת להיות עד 60 תווים',
        slugInvalidFormat: 'הכתובת חייבת לכלול רק אותיות אנגליות קטנות, מספרים ומקפים',
        slugTaken: 'כתובת זו כבר בשימוש',
        slugReserved: 'כתובת זו שמורה',
        approvalRequired: 'יש לאשר את חשבון הסוחר לפני יצירת חנות.',
        logoTooLarge: 'גודל התמונה חייב להיות עד 2MB',
        logoInvalidType: 'הקובץ חייב להיות JPEG, PNG או WEBP',
        logoUploadFailed: 'העלאת הלוגו נכשלה. נסה שוב.',
        networkFailed: 'החיבור נכשל. בדוק את הרשת.',
        unknown: 'אירעה שגיאה. נסה שוב.',
      },
    },
    signIn: {
      title: 'כניסה לניהול',
      subtitle: 'הזינו אימייל ונשלח קוד אימות.',
      emailLabel: 'אימייל',
      emailPlaceholder: 'merchant@example.com',
      passwordLabel: 'סיסמה',
      codeLabel: 'קוד אימות',
      codeHint: 'הזינו קוד בן 6 ספרות.',
      requestCode: 'שליחת קוד',
      requestingCode: 'שולחים...',
      sentMessage: 'אם לאימייל יש הרשאת ניהול, יישלח אליו קוד אימות.',
      verifyCode: 'אימות קוד',
      verifyingCode: 'מאמתים...',
      changeEmail: 'שינוי אימייל',
      resendCode: 'שליחת קוד חדש',
      invitationOnly: 'הכניסה מיועדת לסוחרים מוזמנים בלבד.',
      showPassword: 'הצג סיסמה',
      hidePassword: 'הסתר סיסמה',
      submit: 'שלח קוד',
      submitting: 'שולח...',
      noAccount: 'גישה לניהול ניתנת בהזמנה בלבד.',
      signUpLink: 'חזרה להתחברות',
      errors: {
        emailRequired: 'נדרש אימייל',
        emailInvalid: 'אימייל לא תקין',
        codeRequired: 'קוד אימות נדרש',
        codeInvalid: 'הכנס קוד בן 6 ספרות',
        invalidCode: 'הקוד שגוי או פג תוקף',
        rateLimited: 'יותר מדי ניסיונות. נסה שוב בעוד רגע.',
        passwordRequired: 'נדרשת סיסמה',
        invalidCredentials: 'אימייל או סיסמה שגויים',
        networkFailed: 'החיבור נכשל. בדוק את הרשת.',
        serviceUnavailable: 'שירות ההתחברות לא מגיב. נסה שוב בעוד רגע.',
        unknown: 'אירעה שגיאה. נסה שוב.',
      },
    },
    publishStore: {
      ctaLabel: 'פרסם חנות',
      ctaLabelSubmitting: 'מפרסם…',
      unpublishCtaLabel: 'בטל פרסום',
      unpublishCtaLabelSubmitting: 'מבטל פרסום…',
      badge: {
        draft: 'טיוטה',
        published: 'מפורסם',
      },
      draftCard: {
        title: 'מוכן להשיק את החנות?',
        description: 'פרסם את החנות כדי שלקוחות יוכלו למצוא אותה ולראות את המוצרים.',
      },
      modal: {
        title: 'לפרסם את החנות שלך?',
        description: 'החנות שלך תהיה זמינה ללקוחות בכתובת:',
        confirm: 'אשר פרסום',
      },
      unpublishModal: {
        title: 'להוריד את החנות מהאוויר?',
        description: 'לקוחות יראו דף "החנות אינה זמינה". תוכל לפרסם מחדש בכל עת.',
        confirm: 'בטל פרסום',
      },
      publishedCard: {
        title: 'החנות שלך באוויר',
        urlLabel: 'הקישור הציבורי שלך',
        copy: 'העתק קישור',
        copyAriaLabel: 'העתק את קישור החנות ללוח',
        viewStore: 'צפה בחנות',
      },
      toasts: {
        published: 'החנות שלך באוויר',
        unpublished: 'החנות הורדה מהאוויר',
        urlCopied: 'הקישור הועתק',
      },
      errors: {
        noStockedProducts: 'יש להוסיף לפחות מוצר אחד במלאי לפני פרסום החנות.',
        noStockedProductsCta: 'הוספת מוצר',
        missingContactMethod: 'הוסף אמצעי התקשרות לפני פרסום החנות.',
        missingContactMethodCta: 'עבור להגדרות',
        missingLogo: 'העלה לוגו לחנות לפני פרסום החנות.',
        missingLogoCta: 'העלה לוגו בהגדרות',
        subscriptionRequired: 'בחר והפעל תוכנית Dukanti לפני פרסום החנות.',
        activeProductLimitReached:
          'התוכנית הנוכחית שלך לא יכולה לפרסם כל כך הרבה מוצרים. בטל פרסום של מוצרים עודפים או שדרג תוכנית.',
        // DEPRECATED: use common.errors.permissionDenied
        permissionDenied: 'אין לך הרשאה לפעולה זו.',
        // DEPRECATED: use common.errors.storeNotFound
        storeNotFound: 'החנות הזו אינה קיימת עוד. רענן את הדף.',
        // DEPRECATED: use common.errors.networkFailed
        networkFailed: 'החיבור נכשל. בדוק את הרשת ונסה שוב.',
        copyFailed: 'לא ניתן להעתיק את הקישור. בחר את הקישור והעתק ידנית.',
        // DEPRECATED: use common.errors.unknown
        unknown: 'משהו השתבש. נסה שוב.',
      },
    },
    storeSettings: {
      fulfillment: {
        saveFailed: 'השמירה נכשלה. הטיוטה נשמרה.',
        saved: 'אפשרויות המשלוח והאיסוף נשמרו',
        reload: 'טעינת ההגדרות מחדש',
        conflict: 'נשמרו שינויים אחרים. הטיוטה נשמרה; טענו את ההגדרות לבדיקה.',
        noMethodsWarning: 'לקוחות לא יוכלו לאשר הזמנות עד להפעלת אפשרות.',
        pickupLimit: 'ניתן להוסיף מקום איסוף אחד כרגע.',
        removeDescription: 'הפעולה לא תשנה פרטים בהזמנות שכבר אושרו.',
        removePickup: 'הסרת מקום איסוף',
        addPickup: 'הוספת מקום איסוף',
        pickupDetailsInvalid: 'יש להזין כתובת או הוראות באורך 1 עד 1000 תווים.',
        pickupNameInvalid: 'יש להזין שם באורך 1 עד 160 תווים.',
        pickupDetails: 'כתובת או הוראות איסוף',
        pickupName: 'שם מקום האיסוף',
        feeInvalid: 'יש להזין סכום בין 0 ל־1000 ש״ח עם עד שתי ספרות עשרוניות.',
        fixedFeeHelp: 'מחיר אחיד לכל היעדים. שדה ריק מבטל משלוח, ו־0 מאפשר משלוח חינם.',
        title: 'משלוח ואיסוף',
      },
      socialProfiles: {
        reload: 'טעינה מחדש של ההגדרות',
        forbidden: 'ההגדרות האלה זמינות רק לבעלי החנות ולמנהלים.',
        title: 'פרופילים חברתיים',
        help: 'ההגדרות האלה חלות מייד בחנות. טקסט התבנית והרשמה דורשים פרסום.',
        provider: 'פלטפורמה',
        url: 'כתובת הפרופיל',
        add: 'הוספת פרופיל',
        remove: 'הסרת פרופיל',
        saved: 'הפרופילים נשמרו.',
        invalid: 'הזינו כתובת פרופיל Instagram או Facebook תקינה.',
        stale: 'ההגדרות השתנו בהפעלה אחרת. טענו מחדש ונסו שוב.',
        loadError: 'לא ניתן לטעון פרופילים חברתיים.',
        saveError: 'לא ניתן לשמור פרופילים חברתיים. נסו שוב.',
        empty: 'לא נוספו פרופילים חברתיים.',
        max: 'אפשר להוסיף עד ארבעה פרופילים.',
        instagram: 'Instagram',
        facebook: 'Facebook',
      },
      newsletterCollection: {
        title: 'איסוף הרשמות לניוזלטר',
        description:
          'איסוף הרשמות בדוא״ל בהסכמת הלקוחות דרך תבנית מפורסמת שתומכת בניוזלטר. פעולה זו אינה שולחת הודעות.',
        label: 'לאפשר הרשמה לניוזלטר',
        enabledHint: 'מוצג כשהתבנית המפורסמת תומכת בניוזלטר.',
        disabledHint: 'איסוף ההרשמות כבוי. ההרשמות הקיימות נשמרות.',
        saving: 'שומר…',
        savedToast: 'הגדרת הניוזלטר נשמרה.',
        manageSubscribers: 'ניהול מנויים',
        permissionHint: 'רק בעלי החנות ומנהלים יכולים לשנות את איסוף ההרשמות.',
        error: 'לא הצלחנו לשמור את ההגדרה. נסו שוב.',
        subscriberTitle: 'מנויי הניוזלטר',
        export: 'ייצוא CSV',
        suppress: 'הפסקת המנוי',
        empty: 'אין הרשמות עדיין.',
        loadError: 'לא הצלחנו לטעון את ההרשמות.',
        suppressionError: 'לא הצלחנו להפסיק את המנוי.',
      },
      title: 'הגדרות חנות',
      subtitle: 'עדכן את פרטי החנות ואמצעי ההתקשרות שהלקוחות שלך רואים',
      fixBanner: 'הוסף וואטסאפ או טלפון כדי לפרסם את החנות.',
      whatsappLabel: 'מספר וואטסאפ',
      phoneLabel: 'מספר טלפון',
      countryLabel: 'מדינה',
      callingCodeLabel: 'קידומת חיוג',
      localPhoneLabel: 'מספר מקומי',
      whatsappLocalLabel: 'מספר וואטסאפ מקומי',
      phoneLocalLabel: 'מספר טלפון מקומי',
      phonePlaceholder: '+972501234567',
      phoneHint: 'הזן קידומת מדינה (לדוגמה: +972 עבור מספרים ישראליים)',
      localPhonePlaceholderIL: '0501234567',
      internationalPhonePlaceholder: '+972501234567',
      phoneHintCountryFirst: 'בחר מדינה והקלד את המספר כמו שהוא משמש מקומית.',
      submit: 'שמור',
      submitting: 'שומר…',
      details: {
        title: 'פרטי החנות',
        description: 'עדכן את השם, התיאור והלוגו שהלקוחות רואים.',
        nameLabel: 'שם החנות',
        namePlaceholder: 'לדוגמה: המכולת של אחמד',
        descriptionLabel: 'תיאור החנות',
        descriptionPlaceholder: 'תאר בקצרה את החנות והמוצרים שלך',
        descriptionCount: '{{count}}/{{max}}',
        localityLabel: 'יישוב החנות',
        localityPlaceholder: 'בחר יישוב',
        localityLoading: 'טוען יישובים…',
        localityHint: 'היישוב שבו נמצאת החנות שלך.',
        slugLabel: 'כתובת החנות',
        slugLockedWarning:
          'אי אפשר לשנות את כתובת החנות אחרי היצירה כדי לא לשבור קישורים שכבר שותפו.',
        logoLabel: 'לוגו החנות',
        logoHint: 'JPEG, PNG או WEBP, עד 2MB',
        logoUpload: 'העלאת לוגו',
        logoReplace: 'החלפת לוגו',
        logoRemove: 'הסרת לוגו',
        logoUndoRemove: 'בטל הסרה',
        submit: 'שמירת פרטים',
        submitting: 'שומר פרטים…',
      },
      manualApproval: {
        title: 'אישור הזמנות ידני',
        description: 'דרוש בדיקת סוחר לפני שילוח או שיוך שליח להזמנות חדשות.',
        checkboxLabel: 'בדיקת הזמנות חדשות לפני טיפול',
        enabledHint: 'הזמנות חדשות ימתינו לאישור. הזמנות קיימות לא משתנות.',
        disabledHint: 'הזמנות חדשות יכולות לעבור ישירות לטיפול.',
        saving: 'שומר הגדרה…',
        savedToast: 'הגדרת האישור הידני נשמרה',
      },
      toasts: {
        saved: 'נשמר',
        detailsSaved: 'פרטי החנות נשמרו',
      },
      errors: {
        nameRequired: 'שם החנות נדרש',
        nameTooLong: 'שם החנות חייב להיות עד 100 תווים',
        descriptionRequired: 'תיאור החנות נדרש',
        descriptionTooLong: 'התיאור חייב להיות עד 500 תווים',
        localityRequired: 'יישוב החנות נדרש',
        logoTooLarge: 'התמונה חייבת להיות עד 2MB',
        logoInvalidType: 'הקובץ חייב להיות JPEG, PNG או WEBP',
        logoUploadFailed: 'העלאת הלוגו נכשלה. נסה שוב.',
        whatsappInvalid: 'הזן מספר תקין בפורמט בינלאומי (למשל: +972501234567)',
        phoneInvalid: 'הזן מספר תקין בפורמט בינלאומי (למשל: +972501234567)',
        whatsappInvalidForCountry: 'מספר הוואטסאפ לא תקין למדינה שנבחרה',
        phoneInvalidForCountry: 'מספר הטלפון לא תקין למדינה שנבחרה',
        whatsappInternationalInvalid: 'הזן מספר וואטסאפ בינלאומי תקין כמו +972501234567',
        phoneInternationalInvalid: 'הזן מספר טלפון בינלאומי תקין כמו +972501234567',
        whatsappLocalTooLong: 'מספר הוואטסאפ המקומי ארוך מדי',
        phoneLocalTooLong: 'מספר הטלפון המקומי ארוך מדי',
        whatsappInternationalTooLong: 'מספר הוואטסאפ הבינלאומי ארוך מדי',
        phoneInternationalTooLong: 'מספר הטלפון הבינלאומי ארוך מדי',
        atLeastOneRequired: 'יש לספק לפחות אמצעי התקשרות אחד',
        networkFailed: 'החיבור נכשל. בדוק את הרשת ונסה שוב.',
        unknown: 'משהו השתבש. נסה שוב.',
      },
    },
    // F-003 Phase 4a scaffolding: English placeholder strings in all three
    // locale files so TS type-checking + runtime lookup work. stitch-react
    // fills in real Hebrew strings during Phase 4c (see F4d-4).
    products: {
      title: 'מוצרים',
      subtitle: 'עקבו אחרי מצב הפרסום והזמינות של המוצרים בחלון הזה.',
      addNew: 'הוספת מוצר',
      limitNote: 'מציג את 50 המוצרים הראשונים',
      summary: {
        all: 'כל המוצרים',
        published: 'פורסמו',
        draft: 'טיוטות',
        unavailable: 'לא זמינים',
      },
      filters: {
        label: 'סינון מוצרים',
        all: 'הכול',
        published: 'פורסמו',
        draft: 'טיוטות',
        unavailable: 'לא זמינים',
      },
      table: {
        columns: {
          product: 'מוצר',
          category: 'קטגוריה',
          price: 'מחיר',
          inventory: 'מלאי',
          publication: 'פרסום',
          availability: 'זמינות',
          actions: 'פעולות',
        },
        inventory: {
          available: '{{available}} מתוך {{inventory}} זמינים',
        },
        variantSummary: {
          count: '{{count}} וריאנטים',
          active: '{{count}} פעילים',
          fromPrice: 'מחיר החל מ',
          sale: 'מבצע לוריאנט',
          disabled: 'וריאנטים לא פעילים',
          outOfStock: 'וריאנטים שאזלו',
        },
        availability: {
          available: 'זמין',
          outOfStock: 'אזל מהמלאי',
        },
      },
      noResults: {
        title: 'אין מוצרים במסנן הזה',
        subtitle: 'שנו את המסנן כדי לראות מוצרים אחרים מתוך 50 הראשונים.',
      },
      empty: {
        title: 'הוסיפו את המוצר הראשון שלכם',
        subtitle: 'החנות שלכם מוכנה. הוסיפו מוצר כדי להתחיל למכור מדבּוריה.',
        cta: 'הוספת מוצר',
      },
      badge: {
        draft: 'טיוטה',
        published: 'מפורסם',
        outOfStock: 'אזל מהמלאי',
        onSale: 'במבצע',
        discountPercent: '{{percent}}% הנחה',
      },
      card: {
        inventoryLabel: '{{count}} במלאי',
        editAction: 'עריכה',
        deleteAction: 'מחיקה',
        actionsMenu: 'פעולות המוצר',
      },
      form: {
        title: {
          new: 'הוספת מוצר חדש',
          edit: 'עריכת מוצר',
        },
        nameLabel: 'שם המוצר',
        namePlaceholder: 'לדוגמה: שמן זית כתית מעולה',
        categoryLabel: 'קטגוריה',
        categoryPlaceholder: 'בחרו קטגוריה',
        categoryHint: 'כל מוצר שייך לקטגוריה פעילה אחת.',
        categoryLoading: 'טוען קטגוריות...',
        noCategoriesTitle: 'צרו קודם קטגוריה',
        noCategoriesDescription: 'מוצרים צריכים קטגוריה פעילה לפני שמירה.',
        noCategoriesCta: 'ניהול קטגוריות',
        descriptionLabel: 'תיאור',
        descriptionPlaceholder: 'הוסיפו תיאור קצר למוצר...',
        priceLabel: 'מחיר',
        priceHint: 'ש"ח — עד שתי ספרות אחרי הנקודה',
        saleSectionTitle: 'מבצע',
        saleEnabledLabel: 'הפעל מחיר מבצע למוצר הזה',
        salePriceLabel: 'מחיר מבצע',
        salePriceHint: 'חייב להיות נמוך מהמחיר הרגיל',
        currencyLabel: 'מטבע',
        inventoryLabel: 'כמות במלאי',
        inventoryHint: 'הקלידו 0 אם המוצר אינו זמין',
        barcodeLabel: 'ברקוד המוצר',
        barcodePlaceholder: 'לדוגמה: ABC-12345',
        barcodeHint: 'אופציונלי. אותיות, מספרים וסימני ברקוד בטוחים בלבד.',
        barcodeCameraAriaLabel: 'סריקת ברקוד המוצר במצלמה',
        imagesLabel: 'תמונות המוצר',
        imagesHint: 'JPEG, PNG או WEBP — עד 5 תמונות, עד 4 מ"ב לכל תמונה',
        imageAdd: 'הוספת תמונה',
        imageRemove: 'הסרת תמונה',
        imageMoveUp: 'העברה למעלה',
        imageMoveDown: 'העברה למטה',
        imageDragHandle: 'גררו כדי לסדר מחדש',
        imageRetry: 'נסה שוב',
        imageUploading: 'מעלה תמונה...',
        imageSlotAlt: 'תמונת מוצר מספר {{index}}',
        imagePosition: 'מיקום {{current}}',
        modeSectionTitle: 'מצב מכירה',
        mode: {
          simple: {
            label: 'מוצר פשוט',
            hint: 'מחיר אחד וכמות מלאי אחת.',
          },
          options: {
            label: 'מוצר עם אפשרויות',
            hint: 'מידות, צבעים, מארזים או כל שילוב.',
          },
        },
        variantsTitle: 'אפשרויות ווריאנטים',
        variantsHint: 'הוסיפו ערכי אפשרויות כדי ליצור אוטומטית שורות וריאנטים למכירה.',
        templates: {
          title: 'התחלה מתבנית',
          active: 'התבנית שנבחרה: {{template}}',
          selected: 'נבחר',
          sizes: {
            label: 'מידות',
            hint: 'קטן, בינוני, גדול.',
            optionName: 'מידה',
            valueSmall: 'קטן',
            valueMedium: 'בינוני',
            valueLarge: 'גדול',
          },
          colors: {
            label: 'צבעים',
            hint: 'בחירות צבע נפוצות.',
            optionName: 'צבע',
            valueBlack: 'שחור',
            valueWhite: 'לבן',
            valueGreen: 'ירוק',
          },
          sizeColor: {
            label: 'מידה וצבע',
            hint: 'יצירת כל שילובי המידה והצבע.',
          },
          packageQuantity: {
            label: 'כמות באריזה',
            hint: 'יחידה אחת או מארזים.',
            optionName: 'אריזה',
            valueSingle: 'יחידה אחת',
            valuePack6: 'מארז 6',
            valuePack12: 'מארז 12',
          },
          supplement: {
            label: 'תוסף',
            hint: 'חוזק ומספר כמוסות.',
            strengthOptionName: 'חוזק',
            packageOptionName: 'כמוסות',
            value500mg: '500mg',
            value1000mg: '1000mg',
            value30Capsules: '30 כמוסות',
            value60Capsules: '60 כמוסות',
          },
          volumeWeight: {
            label: 'נפח או משקל',
            hint: 'גדלי בקבוקים, שתייה או מזון.',
            optionName: 'כמות',
            value250ml: '250ml',
            value500ml: '500ml',
            value1kg: '1kg',
          },
          custom: {
            label: 'מותאם אישית',
            hint: 'בנו ערכי אפשרויות משלכם.',
            optionName: 'אפשרות',
            valueOne: 'ערך',
          },
        },
        addOption: 'הוספת אפשרות',
        removeOption: 'הסרת אפשרות',
        optionGroupLabel: 'קבוצת אפשרות {{number}}',
        optionNameLabel: 'שם האפשרות',
        optionNamePlaceholder: 'מידה, צבע, מארז...',
        optionValuePlaceholder: 'ערך האפשרות',
        addOptionValue: 'הוספת ערך',
        removeOptionValue: 'הסרת ערך',
        variantColumn: 'וריאנט',
        variantPriceColumn: 'מחיר',
        variantSaleColumn: 'מבצע',
        variantInventoryColumn: 'מלאי',
        variantBarcodeColumn: 'ברקוד',
        variantActiveColumn: 'פעיל',
        variantImageColumn: 'תמונה',
        variantDefaultColumn: 'ברירת מחדל',
        variantImageNone: 'תמונת ברירת מחדל',
        variantImageUnavailable: 'העלה תמונות מוצר לפני שיוך תמונה.',
        variantSaleToggle: 'מבצע',
        variantEmpty: 'הוסיפו לפחות ערך אפשרות אחד עם שם כדי ליצור וריאנטים.',
        variantUnnamed: 'וריאנט {{number}}',
        variantPriceAriaLabel: 'מחיר עבור {{variant}}',
        variantSaleToggleAriaLabel: 'הפעלת מבצע עבור {{variant}}',
        variantSalePriceAriaLabel: 'מחיר מבצע עבור {{variant}}',
        variantInventoryAriaLabel: 'מלאי עבור {{variant}}',
        variantBarcodeAriaLabel: 'ברקוד עבור {{variant}}',
        variantBarcodeCameraAriaLabel: 'סריקת ברקוד עבור {{variant}} במצלמה',
        variantActiveAriaLabel: 'הפעלת {{variant}}',
        variantImageAriaLabel: 'תמונה עבור {{variant}}',
        variantDefaultAriaLabel: 'הגדרת {{variant}} כברירת מחדל',
        submitCreate: 'שמירת מוצר',
        submitEdit: 'שמירת שינויים',
        submitting: 'שומר...',
        cancel: 'ביטול',
        back: 'חזרה למוצרים',
      },
      delete: {
        title: 'למחוק את המוצר?',
        description: 'האם למחוק את <name>{{name}}</name>? לא ניתן לשחזר פעולה זו.',
        confirm: 'מחק',
        confirming: 'מוחק...',
        cancel: 'ביטול',
      },
      barcodeConfirm: {
        replaceConfirm: { title: 'admin.products.barcode.replaceConfirm.title' },
        clearConfirm: { title: 'admin.products.barcode.clearConfirm.title' },
        replaceTitle: 'להחליף ברקוד?',
        replaceDescription: 'הברקוד הישן כבר לא יפתח את הווריאנט הזה אחרי השמירה.',
        clearTitle: 'למחוק ברקוד?',
        clearDescription: 'הצוות כבר לא ימצא את הווריאנט הזה לפי ברקוד אחרי השמירה.',
        deletedTitle: 'להשתמש שוב בברקוד שנמחק?',
        deletedDescription:
          'הברקוד הזה היה שייך למוצר או לווריאנט שנמחק. אשרו שימוש חוזר כדי לשמור אותו כאן.',
        oldBarcode: 'ברקוד קודם',
        newBarcode: 'ברקוד חדש',
        confirm: 'אישור',
        cancel: 'ביטול',
      },
      detail: {
        notFoundTitle: 'המוצר לא נמצא',
        notFoundDescription: 'ייתכן שהוא נמחק או שהקישור שגוי',
        notFoundCta: 'חזרה למוצרים',
        backToList: 'מוצרים',
        editAction: 'עריכה',
        deleteAction: 'מחיקה',
        statusLabel: 'סטטוס',
        priceLabel: 'מחיר',
        categoryLabel: 'קטגוריה',
        categoryMissing: 'לא שויכה קטגוריה',
        inventoryInStock: '{{count}} במלאי',
        inventoryLow: 'נותרו: {{count}}',
        inventoryOutOfStock: 'אזל מהמלאי',
        descriptionLabel: 'תיאור',
        galleryLabel: 'גלריית תמונות המוצר',
        thumbnailLabel: 'תמונה {{index}}',
        noImagesLabel: 'אין תמונות למוצר זה',
        loadingLabel: 'טוען מוצר...',
      },
      errors: {
        nameRequired: 'נדרש שם למוצר',
        nameTooLong: 'שם המוצר חייב להיות עד 200 תווים',
        nameInvalid: 'שם המוצר מכיל תווים לא חוקיים',
        descriptionInvalid: 'התיאור מכיל תווים לא חוקיים',
        priceRequired: 'נדרש מחיר',
        priceInvalid: 'המחיר חייב להיות מספר חיובי עם עד שתי ספרות אחרי הנקודה',
        salePriceInvalid: 'מחיר המבצע חייב להיות מספר חיובי ונמוך מהמחיר הרגיל',
        inventoryInvalid: 'הכמות במלאי חייבת להיות מספר שלם לא שלילי',
        categoryRequired: 'בחרו קטגוריה למוצר הזה',
        imageTooLarge: 'התמונה גדולה מדי (עד 2 מ"ב). יש לבחור קובץ קטן יותר.',
        imageInvalidType: 'הקובץ חייב להיות JPEG, PNG או WEBP',
        tooManyImages: 'ניתן להוסיף עד 5 תמונות למוצר',
        storageQuotaExceeded:
          'חריגה ממכסת האחסון של החנות (מקסימום 50 מגה-בייט). מחק תמונות כדי לפנות מקום.',
        imageUploadFailed: 'העלאת התמונה נכשלה. יש לנסות שוב.',
        barcodeInvalid: 'הברקוד מכיל תווים שאינם נתמכים.',
        barcodeTooLong: 'הברקוד חייב להיות עד 80 תווים.',
        barcodeDuplicate: 'הברקוד הזה כבר משויך לווריאנט אחר.',
        barcodeDeletedConflict: 'אשרו שימוש חוזר בברקוד שהיה שייך לווריאנט שנמחק.',
        barcodeChangedElsewhere: 'הברקוד השתנה במקום אחר. רעננו ונסו שוב.',
        barcodeReplaceConfirmationRequired: 'אשרו החלפת ברקוד לפני השמירה.',
        barcodeClearConfirmationRequired: 'אשרו מחיקת ברקוד לפני השמירה.',
        activeOrderedOrders: 'יש לטפל בהזמנות החדשות של המוצר לפני שינויו.',
        // DEPRECATED: use common.errors.networkFailed
        networkFailed: 'לא הצלחנו לטעון את המוצרים. נא לנסות שוב.',
        notFound: 'המוצר לא נמצא',
        // DEPRECATED: use common.errors.permissionDenied
        permissionDenied: 'אין לך הרשאה לבצע פעולה זו',
        // DEPRECATED: use common.errors.unknown
        unknown: 'משהו השתבש. יש לנסות שוב.',
      },
      variants: {
        errors: {
          optionNameRequired: 'נדרש שם אפשרות',
          optionValueRequired: 'נדרש ערך אפשרות',
          duplicateOptionValue: 'ערך האפשרות כפול',
          duplicateCombination: 'שילוב האפשרויות כפול',
          tooManyOptions: 'אפשר להוסיף עד 3 אפשרויות',
          tooManyValues: 'יש יותר מדי ערכי אפשרויות',
          tooManyVariants: 'אפשר ליצור עד 100 וריאנטים',
          noActiveVariant: 'המוצר צריך לפחות וריאנט פעיל אחד',
          imageMismatch: 'תמונת הווריאנט חייבת להשתייך למוצר הזה',
          cannotDeleteOptionValue: 'אי אפשר למחוק ערך שמשמש וריאנטים קיימים',
        },
      },
      toasts: {
        created: 'המוצר נוצר',
        updated: 'המוצר עודכן',
        deleted: 'המוצר נמחק',
        imagesPartialFailure: 'המוצר נשמר, אך חלק מהתמונות לא הועלו',
      },
      // F-028 Per-Product Publish Toggle — values
      publish: {
        buttons: {
          publish: 'פרסם',
          unpublish: 'הסתר',
          publishing: 'מפרסם…',
          unpublishing: 'מסתיר…',
        },
        publishModal: {
          title: 'לפרסם את המוצר הזה?',
          description: 'המוצר יופיע בחנות שלך באופן מיידי.',
          urlLabel: 'לקוחות יראו אותו בכתובת:',
          confirm: 'פרסם מוצר',
        },
        unpublishModal: {
          title: 'להסתיר את המוצר הזה?',
          description: 'לקוחות לא יראו יותר את המוצר הזה בחנות שלך. תוכל לפרסם אותו שוב בכל עת.',
          urlLabel: 'הקישור הזה יפסיק לעבוד:',
          confirm: 'הסתר מוצר',
          stay: 'השאר גלוי',
        },
        disabled: {
          storeNotPublished: 'פרסם תחילה את החנות שלך.',
          storeNotPublishedCta: 'עבור ללוח הבקרה',
          insufficientInventory: 'הוסף מלאי כדי לפרסם.',
          insufficientInventoryCta: 'ערוך מוצר',
          categoryRequired: 'בחרו קטגוריה לפני הפרסום.',
          categoryRequiredCta: 'עריכת מוצר',
          categoryRequiredCreateCta: 'יצירת קטגוריה',
        },
        errors: {
          storeNotPublished: 'פרסם תחילה את החנות שלך.',
          insufficientInventory: 'אין מלאי למוצר הזה. הוסף מלאי לפני הפרסום.',
          categoryRequired: 'בחרו קטגוריה פעילה לפני פרסום המוצר הזה.',
          permissionDenied: 'אין לך הרשאה לפרסם את המוצר הזה.',
          notFound: 'המוצר הזה אינו קיים עוד.',
          networkFailed: 'שגיאת רשת. אנא נסה שוב.',
          unknown: 'משהו השתבש. אנא נסה שוב.',
        },
        toasts: {
          published: 'המוצר פורסם.',
          unpublished: 'המוצר הוסתר.',
        },
        card: {
          menuPublish: 'פרסם',
          menuUnpublish: 'הסתר',
        },
      },
    },
    categories: {
      title: 'קטגוריות',
      subtitle: 'ארגנו את הקטלוג לקטגוריות שהלקוחות יראו על מוצרים.',
      addNew: 'הוספת קטגוריה',
      loading: 'טוען קטגוריות...',
      empty: {
        title: 'צרו את הקטגוריה הראשונה',
        subtitle: 'קטגוריות שומרות על פרסום מוצרים מסודר ומכינות את קטלוג החנות.',
        cta: 'הוספת קטגוריה',
      },
      list: {
        order: 'מיקום {{order}}',
      },
      actions: {
        edit: 'עריכת {{name}}',
        delete: 'מחיקת {{name}}',
        moveUp: 'העברת {{name}} למעלה',
        moveDown: 'העברת {{name}} למטה',
      },
      form: {
        title: {
          create: 'הוספת קטגוריה',
          edit: 'עריכת קטגוריה',
        },
        description: {
          create: 'תנו שם לקטגוריה ואפשר להוסיף תמונה ותיאור ציבורי.',
          edit: 'עדכנו את שם הקטגוריה, התמונה או התיאור הציבורי.',
        },
        nameLabel: 'שם הקטגוריה',
        namePlaceholder: 'לדוגמה: שמן זית',
        publicDescription: {
          legend: 'תיאורים ציבוריים',
          help: 'כתבו טקסט קצר ואופציונלי שיוצג ללקוחות בחנות כאשר מפעילים אותו.',
          arLabel: 'תיאור בערבית',
          heLabel: 'תיאור בעברית',
          enLabel: 'תיאור באנגלית',
          placeholder: 'לדוגמה: בחירות טריות מהחנות',
        },
        mediaUpload: 'העלאת תמונה',
        mediaReplace: 'החלפת תמונה',
        mediaRemove: 'הסרת תמונה',
        mediaHint: 'JPEG, PNG, WEBP או GIF, עד 2MB',
        mediaPreviewAlt: 'תצוגה מקדימה של תמונת קטגוריה',
        submitCreate: 'צור קטגוריה',
        submitEdit: 'שמירת שינויים',
      },
      delete: {
        title: 'למחוק את הקטגוריה?',
        description: 'מחיקת {{name}} מקטגוריות החנות.',
        confirm: 'מחיקת קטגוריה',
        assignedProductsRecovery: 'שייכו מחדש מוצרים בקטגוריה הזו לפני המחיקה.',
      },
      toasts: {
        created: 'הקטגוריה נוצרה',
        updated: 'הקטגוריה עודכנה',
        deleted: 'הקטגוריה נמחקה',
        reordered: 'סדר הקטגוריות עודכן',
      },
      errors: {
        nameRequired: 'נדרש שם קטגוריה',
        nameTooLong: 'שם הקטגוריה חייב להיות עד 80 תווים',
        nameInvalid: 'שם הקטגוריה מכיל תווים לא חוקיים',
        descriptionTooLong: 'תיאור הקטגוריה חייב להיות עד 240 תווים בכל שפה',
        descriptionInvalid:
          'תיאור הקטגוריה חייב להיות טקסט רגיל ללא קישורים, עיצוב או תווים מוסתרים',
        nameDuplicate: 'כבר קיימת קטגוריה פעילה בשם הזה',
        imageInvalidType: 'הקובץ חייב להיות JPEG, PNG, WEBP או GIF',
        imageTooLarge: 'התמונה גדולה מדי (עד 2MB). בחרו קובץ קטן יותר.',
        imageUploadFailed: 'העלאת תמונת הקטגוריה נכשלה. נסו שוב.',
        storageQuotaExceeded:
          'חריגה ממכסת האחסון של החנות (מקסימום 50 מגה-בייט). מחקו תמונות כדי לפנות מקום.',
        assignedProducts: 'הקטגוריה הזו עדיין משויכת למוצרים.',
        permissionDenied: 'אין לך הרשאה לנהל את הקטגוריה הזו.',
        notFound: 'הקטגוריה הזו אינה קיימת עוד.',
        reorderInvalid: 'סדר הקטגוריות השתנה. רעננו ונסו שוב.',
      },
    },
    promotionalAds: {
      title: 'מודעות דף הבית',
      subtitle: 'הוסיפו תמונות מבצע שמופיעות בראש דף החנות.',
      addNew: 'הוספת מודעה',
      legacyNotice:
        'החנות שלך משתמשת כעת בתבנית עיצוב, ולכן המודעות האלה כבר לא מוצגות בחנות. כדי לשנות באנרים ותמונות, פתחו את <storefrontLink>חזית החנות</storefrontLink> והפעילו <editMode>מצב עריכה</editMode>. המודעות נשמרות כאן לעיון בלבד.',
      readOnlyStaffNotice: 'רק בעלי החנות ומנהלים יכולים לשנות מודעות.',
      accessLoadError: 'לא הצלחנו לטעון את הגדרות המודעות. בדקו את החיבור ונסו שוב.',
      marketingTabsLabel: 'מדורי שיווק',
      empty: {
        title: 'אין מודעות עדיין',
        subtitle: 'התחילו עם תמונת מבצע אחת שתופיע בראש החנות.',
      },
      list: {
        untitled: 'מודעה ללא כותרת',
      },
      form: {
        title: {
          create: 'הוספת מודעה',
          edit: 'עריכת מודעה',
        },
        mediaLabel: 'תמונת המודעה',
        mediaHint: 'WEBP, JPEG, PNG או GIF, עד 4MB. יחס מומלץ קרוב ל-3:1.',
        titleLabel: 'כותרת',
        titlePlaceholder: 'לדוגמה: מבצע סוף שבוע',
        altLabel: 'טקסט חלופי',
        altPlaceholder: 'תארו מה מופיע בתמונה',
        back: 'חזרה למודעות',
        pageTitleCreate: 'יצירת מודעת קידום',
        pageTitleEdit: 'עריכת מודעת קידום',
        destinationLabel: 'קישור חיצוני',
        destinationPlaceholder: 'https://example.com',
        activeLabel: 'הצג את המודעה בחנות',
        submitCreate: 'יצירת מודעה',
        submitEdit: 'שמירת שינויים',
      },
      destination: {
        title: 'יעד',
        description: 'בחרו מה ייפתח כשהקונים ילחצו על המודעה.',
        typeLabel: 'סוג יעד',
        none: 'ללא קישור',
        noneDescription: 'הצגת התמונה ללא ניווט.',
        sales: 'עמוד מבצעים',
        salesDescription: 'פתיחת מוצרי המבצע של החנות.',
        category: 'קטגוריה',
        categoryDescription: 'שליחת קונים לקטגוריה ציבורית.',
        product: 'מוצר',
        productDescription: 'שליחת קונים לעמוד מוצר.',
        external: 'אינסטגרם או פייסבוק',
        externalDescription: 'פתיחת עמוד או פוסט חברתי מהימן.',
        externalLabel: 'כתובת אינסטגרם או פייסבוק',
        externalPlaceholder: 'https://www.instagram.com/store-name',
        categorySearchLabel: 'חיפוש קטגוריות',
        categorySearchPlaceholder: 'שם קטגוריה',
        productSearchLabel: 'חיפוש מוצרים',
        productSearchPlaceholder: 'שם מוצר',
        productCategoryFilterLabel: 'סינון מוצרים לפי קטגוריה',
        productCategoryFilterButton: 'סינון: {{name}}',
        productCategoryFilterAll: 'כל המוצרים',
        productCategoryFilterSearchLabel: 'חיפוש קטגוריות מוצרים',
        productCategoryFilterSearchPlaceholder: 'חיפוש קטגוריות',
        categoryEmpty: 'אין קטגוריות תואמות',
        productEmpty: 'אין מוצרים תואמים',
        categoryUnavailable: 'הקטגוריה הזו אינה זמינה בחנות.',
        productUnavailable: 'המוצר הזה אינו זמין בחנות.',
        selectedCategory: 'קטגוריה נבחרת: {{name}}',
        selectedProduct: 'מוצר נבחר: {{name}}',
        clearSelection: 'ניקוי בחירה',
        summary: {
          noLink: 'ללא קישור',
          sales: 'עמוד מבצעים',
          category: 'קטגוריה: {{value}}',
          product: 'מוצר: {{value}}',
          external: 'חיצוני: {{value}}',
          unavailable: 'יעד לא זמין',
        },
      },
      pickers: {
        loadingCategories: 'טוען קטגוריות...',
        loadingProducts: 'טוען מוצרים...',
        retryCategories: 'נסה שוב לטעון קטגוריות',
        retryProducts: 'נסה שוב לטעון מוצרים',
        productStatus: {
          published: 'פורסם',
          draft: 'טיוטה',
        },
        availability: {
          inStock: 'במלאי',
          outOfStock: 'אזל מהמלאי',
        },
      },
      actions: {
        edit: 'עריכת {{title}}',
        delete: 'מחיקת {{title}}',
        moveUp: 'העברת {{title}} למעלה',
        moveDown: 'העברת {{title}} למטה',
      },
      status: {
        active: 'פעיל',
        inactive: 'לא פעיל',
      },
      delete: {
        title: 'למחוק את המודעה?',
        description: 'המודעה לא תופיע בחנות אחרי המחיקה.',
        confirm: 'מחיקת מודעה',
      },
      toasts: {
        created: 'המודעה נוצרה',
        updated: 'המודעה עודכנה',
        deleted: 'המודעה נמחקה',
        reordered: 'סדר המודעות עודכן',
      },
      errors: {
        mediaRequired: 'יש להעלות תמונה למודעה',
        mediaInvalidType: 'הקובץ חייב להיות WEBP, JPEG, PNG או GIF בלבד',
        mediaTooLarge: 'התמונה גדולה מ-4MB',
        mediaDimensionsInvalid: 'ממדי התמונה לא מתאימים למודעת החנות',
        titleTooLong: 'הכותרת חייבת להיות עד 80 תווים',
        titleInvalid: 'הכותרת מכילה תווי בקרה שאינם נתמכים',
        altTooLong: 'הטקסט החלופי חייב להיות עד 160 תווים',
        altInvalid: 'הטקסט החלופי מכיל תווי בקרה שאינם נתמכים',
        destinationInvalid: 'השתמשו בקישור HTTPS מאובטח',
        destinationTypeRequired: 'בחרו סוג יעד',
        categoryRequired: 'בחרו קטגוריה',
        productRequired: 'בחרו מוצר',
        externalHttpsRequired:
          'הזינו כתובת HTTPS תקינה של אינסטגרם או פייסבוק ללא רווחים או פרטי התחברות',
        destinationTargetUnavailable: 'בחרו יעד שזמין בחנות',
        tooManyAds: 'אפשר לשמור עד 10 מודעות',
        tooManyActiveAds: 'אפשר להפעיל עד 5 מודעות בלבד',
        storageQuotaExceeded: 'חריגה ממכסת האחסון של החנות. מחקו תמונות כדי לפנות מקום.',
        permissionDenied: 'אין לך הרשאה לנהל את המודעה הזו',
        notFound: 'המודעה הזו אינה קיימת עוד',
        reorderInvalid: 'סדר המודעות השתנה. רעננו ונסו שוב.',
      },
    },
    /** Epic #228 P5: the shared Admin DestinationEditor (aliases reuse promotionalAds / websiteTemplates copy). */
    destination: {
      pickCategory: 'בחרו קטגוריה מהרשימה.',
      pickProduct: 'בחרו מוצר מהרשימה.',
      pickCollection: 'בחרו אוסף.',
      finishToSave: 'השלימו את הבחירה כדי לשמור',
      incompleteTitle: 'הקישור לא הושלם',
      incomplete: {
        category: 'בחרו קטגוריה או יעד אחר. אם תצאו עכשיו, הקישור יישאר כפי שהיה.',
        product: 'בחרו מוצר או יעד אחר. אם תצאו עכשיו, הקישור יישאר כפי שהיה.',
        collection: 'בחרו אוסף או יעד אחר. אם תצאו עכשיו, הקישור יישאר כפי שהיה.',
        external:
          'הזינו קישור לאינסטגרם או לפייסבוק או בחרו יעד אחר. אם תצאו עכשיו, הקישור יישאר כפי שהיה.',
      },
      leaveUnchanged: 'יציאה בלי לשנות את הקישור',
      externalRefused:
        'לא ניתן להשתמש בקישור הזה. הדביקו כתובת של עמוד או פוסט באינסטגרם או בפייסבוק.',
      unavailableNext: 'בחרו פריט אחר למטה, או יעד אחר.',
      labelMissing: 'הוסיפו תווית לכפתור כדי שהקונים יוכלו ללחוץ על הקישור.',
      title: 'יעד',
      typeLabel: 'סוג יעד',
      none: 'ללא קישור',
      noneDescription: 'לא נפתח דבר בלחיצה.',
      sales: 'עמוד מבצעים',
      salesDescription: 'פתיחת מוצרי המבצע של החנות.',
      category: 'קטגוריה',
      categoryDescription: 'שליחת קונים לקטגוריה ציבורית.',
      product: 'מוצר',
      productDescription: 'שליחת קונים לעמוד מוצר.',
      external: 'אינסטגרם או פייסבוק',
      externalDescription: 'פתיחת עמוד או פוסט חברתי מהימן.',
      storePage: 'עמוד בחנות',
      storePageDescription: 'פתיחת עמוד אחר בחנות שלכם.',
      collection: 'אוסף',
      collectionDescription: 'שליחת קונים לאוסף מוצרים.',
      contact: 'יצירת קשר',
      contactDescription: 'הקונים יוכלו לשלוח לכם הודעה או להתקשר.',
      more: 'יעדים נוספים',
      fewer: 'פחות יעדים',
      externalLabel: 'כתובת אינסטגרם או פייסבוק',
      externalPlaceholder: 'https://www.instagram.com/store-name',
      externalHint: 'רק קישורים של instagram.com ו-facebook.com עובדים.',
      externalRequired: 'הזינו קישור לאינסטגרם או לפייסבוק',
      externalHttpsRequired: 'הקישור חייב להתחיל ב-https://',
      externalHostUnsupported: 'נתמכים רק קישורי אינסטגרם ופייסבוק',
      externalTooLong: 'הקישור ארוך מדי (עד 256 תווים)',
      externalInvalid: 'הקישור מכיל תווים שאינם מותרים',
      invalid: 'בחרו לאן הקישור מוביל.',
      unavailable: 'הפריט אינו זמין עוד. הקונים לא יופנו לשום מקום.',
      unavailableBadge: 'לא זמין',
      selectedCategory: 'קטגוריה נבחרת: {{name}}',
      selectedProduct: 'מוצר נבחר: {{name}}',
      selectedUnknown: 'הפריט שנבחר',
      chooseCategory: 'בחירת קטגוריה',
      chooseProduct: 'בחירת מוצר',
      chooseCollection: 'בחירת אוסף',
      categorySearchLabel: 'חיפוש קטגוריות',
      categorySearchPlaceholder: 'שם קטגוריה',
      productSearchLabel: 'חיפוש מוצרים',
      productSearchPlaceholder: 'שם מוצר',
      productCategoryFilterButton: 'סינון: {{name}}',
      productCategoryFilterAll: 'כל המוצרים',
      productCategoryFilterSearchLabel: 'חיפוש קטגוריות מוצרים',
      productCategoryFilterSearchPlaceholder: 'חיפוש קטגוריות',
      categoryEmpty: 'אין קטגוריות תואמות',
      productEmpty: 'אין מוצרים תואמים',
      noCategories: 'אין עדיין קטגוריות. הוסיפו קטגוריה בעמוד הקטגוריות, או בחרו יעד אחר.',
      noProducts: 'אין עדיין מוצרים. הוסיפו מוצר בעמוד המוצרים, או בחרו יעד אחר.',
      noCollections: 'אין עדיין אוספים לבחירה.',
      loadingCategories: 'טוען קטגוריות...',
      loadingProducts: 'טוען מוצרים...',
      retryCategories: 'נסה שוב לטעון קטגוריות',
      retryProducts: 'נסה שוב לטעון מוצרים',
      inStock: 'במלאי',
      outOfStock: 'אזל מהמלאי',
      storePageLabel: 'עמוד',
      contactLabel: 'דרך יצירת קשר',
      page: {
        home: 'דף הבית',
        catalog: 'רשימת מוצרים',
        shop: 'כל המוצרים',
        storeInfo: 'מידע על החנות',
      },
      method: {
        whatsapp: 'וואטסאפ',
        phone: 'טלפון',
      },
      summary: {
        noLink: 'ללא קישור',
        sales: 'עמוד מבצעים',
        category: 'קטגוריה: {{value}}',
        product: 'מוצר: {{value}}',
        collection: 'אוסף: {{value}}',
        external: 'חיצוני: {{value}}',
        unavailable: 'יעד לא זמין',
        storePage: {
          home: 'דף הבית',
          catalog: 'רשימת מוצרים',
          shop: 'כל המוצרים',
          storeInfo: 'מידע על החנות',
        },
        contact: {
          whatsapp: 'וואטסאפ',
          phone: 'טלפון',
          email: 'אימייל',
        },
      },
    },
    couriers: {
      title: 'שליחים',
      count: '{{count}} שליחים',
      create: 'הוסף שליח',
      edit: 'עריכת שליח',
      active: 'פעיל',
      inactive: 'לא פעיל',
      empty: {
        title: 'אין שליחים עדיין',
        description: 'הוסף שליחים אמינים כדי לשייך הזמנות בלי להעתיק פרטים ידנית.',
      },
      nameLabel: 'שם השליח',
      phoneLabel: 'מספר טלפון',
      internalNotesLabel: 'הערות פנימיות',
      actions: {
        create: 'הוסף שליח',
        edit: 'עריכת שליח',
        activate: 'הפעל שליח',
        deactivate: 'השבת שליח',
        delete: 'מחיקת שליח',
      },
      columns: {
        name: 'שם',
        phone: 'טלפון',
        status: 'סטטוס',
        createdAt: 'נוצר',
        actions: 'פעולות',
      },
      status: {
        active: 'פעיל',
        inactive: 'לא פעיל',
      },
      form: {
        title: {
          create: 'הוסף שליח',
          edit: 'עריכת שליח',
        },
        description: 'הזן פרטי שליח לשיוך הזמנות ושליחת קישורי משלוח.',
        nameLabel: 'שם השליח',
        phoneLabel: 'מספר טלפון',
        notesLabel: 'הערות פנימיות',
        activeLabel: 'השליח פעיל',
        save: 'שמור שליח',
      },
      delete: {
        title: 'למחוק שליח?',
        description: 'הפעולה תשבית את {{name}} ותשמור את היסטוריית המשלוחים לביקורת.',
      },
      toasts: {
        created: 'השליח נוצר',
        updated: 'השליח עודכן',
        deleted: 'השליח הושבת',
      },
      verification: {
        title: 'אימות שליח',
        pending: 'ממתין לאימות',
        approved: 'מאומת',
        sendOtp: 'שליחת קוד אימות',
        resendOtp: 'שליחת קוד מחדש',
        enterOtp: 'הזן קוד אימות',
        verify: 'אימות',
        sent: 'הקוד נשלח אל {{phone}}',
        cooldown: 'אפשר לשלוח שוב אחרי {{time}}',
        localDebugOtp: 'קוד פיתוח מקומי',
        localDebugOtpHelp: 'בסביבה המקומית לא נשלח SMS אמיתי. השתמשו בקוד הזה לאימות.',
      },
      portal: {
        copyLink: 'העתקת קישור פורטל',
        shareLink: 'שיתוף קישור פורטל',
        sendWhatsApp: 'שליחה ב-WhatsApp',
        revoke: 'ביטול קישור',
        regenerate: 'יצירת קישור חדש',
        generate: 'יצירת קישור',
        generated: 'קישור פורטל השליח נוצר',
        unavailablePending: 'זמין רק לשליחים מאומתים',
        revoked: 'קישור פורטל השליח בוטל',
        regenerated: 'קישור פורטל השליח נוצר מחדש',
        copied: 'קישור פורטל השליח הועתק',
        whatsappMessage:
          'שלום {{courierName}}, זה קישור פורטל המשלוחים שלך עבור {{storeName}}: {{portalUrl}}\n\nשמור את הקישור אצלך ואל תעביר אותו לאף אחד אחר.',
        safetyNote: 'שתף את הקישור הזה רק עם השליח הזה.',
        recovery: {
          title: 'קישור הפורטל מוכן',
          description: 'הדפדפן חסם העתקה אוטומטית של הקישור עבור {{courierName}}. הקישור זמין כאן.',
          linkLabel: 'קישור פורטל',
        },
        errors: {
          linkNotFound: 'אין קישור פעיל לשליח הזה.',
          unverifiedCourier: 'יש לאמת את השליח לפני יצירת קישור.',
          inactiveCourier: 'יש להפעיל את השליח לפני יצירת קישור.',
          networkFailed: 'לא ניתן להכין את קישור פורטל השליח. בדוק את החיבור ונסה שוב.',
          copyFailed: 'לא ניתן להעתיק את קישור פורטל השליח. נסה שוב.',
        },
      },
      errors: {
        nameRequired: 'שם השליח נדרש.',
        phoneInvalid: 'הזן מספר טלפון תקין עם קידומת מדינה.',
        notesTooLong: 'הערות פנימיות חייבות להיות עד 500 תווים.',
        phoneDuplicate: 'מספר הטלפון הזה כבר משויך לשליח אחר.',
        permissionDenied: 'אין לך הרשאה לנהל שליחים.',
        networkFailed: 'לא ניתן לעדכן שליחים. בדוק את החיבור ונסה שוב.',
        otpInvalid: 'הקוד שגוי.',
        otpExpired: 'תוקף הקוד פג. שלח קוד חדש.',
        otpCooldown: 'יש להמתין לפני שליחה נוספת.',
        tooManyAttempts: 'יותר מדי ניסיונות. שלח קוד חדש.',
        alreadyVerified: 'השליח הזה כבר אומת.',
        smsUnavailable: 'לא ניתן לשלוח את ההודעה. נסה שוב.',
      },
    },
    orders: {
      fulfillment: {
        pickupOnly: 'פעולה זו זמינה להזמנות איסוף עצמי בלבד.',
        deliveryOnly: 'פעולה זו זמינה להזמנות משלוח בלבד.',
      },
      title: 'הזמנות',
      searchPlaceholder: 'חפש לפי שם, טלפון או מספר הזמנה',
      sort: {
        totalDesc: 'סכום כולל: מהגבוה לנמוך',
        totalAsc: 'סכום כולל: מהנמוך לגבוה',
        label: 'מיון',
        visibleLabel: 'מיון:',
        createdAtDesc: 'החדש ביותר קודם',
        createdAtAsc: 'הישן ביותר קודם',
        subtotalDesc: 'סכום: גבוה לנמוך',
        subtotalAsc: 'סכום: נמוך לגבוה',
      },
      filter: {
        all: 'הכל',
        ordered: 'הוזמן',
        shipped: 'נשלח',
        delivered: 'נמסר',
        cancelled: 'בוטל',
        rejected: 'נדחה',
        awaitingApproval: 'ממתין לאישור',
        groupLabel: 'סנן לפי סטטוס',
      },
      columns: {
        total: 'סכום כולל',
        customer: 'לקוח',
        date: 'תאריך',
        items: 'פריטים',
        subtotal: 'סכום',
        status: 'סטטוס',
        action: 'פעולה',
      },
      empty: {
        all: {
          title: 'אין הזמנות עדיין',
          subtitle: 'כשלקוחות יבצעו הזמנות, הן יופיעו כאן.',
        },
        ordered: 'אין הזמנות חדשות',
        shipped: 'אין הזמנות שנשלחו',
        delivered: 'אין הזמנות שנמסרו',
        cancelled: 'אין הזמנות מבוטלות',
        rejected: 'אין הזמנות שנדחו',
        awaitingApproval: {
          title: 'אין הזמנות שממתינות לאישור',
          subtitle: 'הזמנות שממתינות לבדיקה יופיעו כאן.',
        },
      },
      loadMore: 'טען עוד',
      loadingMore: 'טוען...',
      itemCount: '{{count}} פריטים',
      viewOrder: 'צפה',
      viewOrderAria: 'פתיחת הזמנה {{id}} עבור {{customer}}',
      urgentLabel: 'דחוף',
      badge: {
        ariaLabel: '{{count}} הזמנות חדשות',
        ariaLabelCapped: '99+ הזמנות חדשות',
      },
      prepare: {
        title: 'הכנת הזמנה',
        subtitle: 'צור הזמנה מהמלאי הנוכחי של החנות בלי לפתוח את החנות ללקוחות.',
        openCta: 'הכנת הזמנה',
        backToOrders: 'חזרה להזמנות',
        steps: {
          items: 'פריטים',
          delivery: 'משלוח',
          review: 'סקירה',
        },
        picker: {
          title: 'בחירת מוצרים',
          searchLabel: 'חיפוש במלאי',
          searchPlaceholder: 'מוצר, אפשרות או ברקוד',
          categoryLabel: 'קטגוריה',
          categoryAll: 'כל הקטגוריות',
          categoryLoading: 'טוען קטגוריות...',
          loading: 'מחפש במלאי...',
          empty: 'לא נמצאו פריטים תואמים.',
          error: 'לא ניתן לטעון מלאי. נסה שוב.',
          capped: 'מוצגים {{count}} המוצרים הראשונים. חיפוש יצמצם את הרשימה.',
          add: 'הוסף',
          selected: 'נבחר',
          draft: 'לא פורסם',
          barcode: 'ברקוד',
          stock: '{{count}} במלאי',
          outOfStock: 'אזל מהמלאי',
          inactive: 'לא פעיל',
          unavailable: 'לא זמין',
        },
        lines: {
          title: 'פריטים שנבחרו',
          empty: 'הוסף לפחות פריט אחד כדי להכין הזמנה.',
          product: 'מוצר',
          quantity: 'כמות',
          unitPrice: 'מחיר יחידה',
          lineTotal: 'סכום שורה',
          remove: 'הסר פריט',
          subtotal: 'סיכום ביניים',
          quantityWhole: 'הזן כמות שלמה גדולה מאפס.',
          quantityStock: 'רק {{count}} במלאי.',
        },
        delivery: {
          title: 'פרטי משלוח',
          customerName: 'שם לקוח',
          customerNameOptional: 'שם לקוח (אופציונלי)',
          customerNamePlaceholder: 'שם הנמען',
          phoneCountry: 'מדינה',
          phoneNumber: 'מספר טלפון',
          phonePlaceholder: '050 123 4567',
          locality: 'עיר או יישוב',
          localityPlaceholder: 'חפש יישוב',
          localityEmpty: 'לא נמצאו יישובים.',
          addressLine1: 'כתובת או תיאור משלוח',
          addressLine1Optional: 'כתובת או תיאור משלוח (אופציונלי)',
          addressLine1Placeholder: 'רחוב, בית, נקודת ציון או הוראות משלוח',
          notes: 'הערות הזמנה',
          notesPlaceholder: 'הערות אופציונליות לחנות או לשליח',
        },
        review: {
          title: 'סקירת הזמנה',
          deliverySummary: 'סיכום משלוח',
          noPaymentNotice: 'לא נגבה תשלום מקוון עבור הזמנה מוכנה זו.',
          create: 'צור הזמנה',
          creating: 'יוצר הזמנה...',
          editItems: 'ערוך פריטים',
          editDelivery: 'ערוך משלוח',
          requirementsTitle: 'יש להשלים את אלה לפני יצירת ההזמנה:',
        },
        success: {
          created: 'ההזמנה המוכנה נוצרה.',
        },
        errors: {
          noLines: 'הוסף לפחות פריט אחד.',
          quantityInvalid: 'הזן כמויות שלמות, גדולות מאפס ובגבול המלאי.',
          insufficientStock: 'לחלק מהפריטים שנבחרו אין מספיק מלאי.',
          deletedProduct: 'חלק מהמוצרים שנבחרו כבר אינם זמינים.',
          inactiveVariant: 'חלק מהווריאנטים שנבחרו אינם פעילים.',
          variantUnavailable: 'חלק מהפריטים שנבחרו כבר אינם זמינים.',
          customerNameRequired: 'הזן את שם הלקוח.',
          phoneRequired: 'הזן את מספר הטלפון של הלקוח.',
          phoneInvalid: 'הזן מספר טלפון תקין עם קידומת מדינה.',
          localityRequired: 'בחר עיר או יישוב.',
          localityInvalid: 'בחר עיר או יישוב פעילים.',
          addressRequired: 'הזן כתובת או תיאור משלוח.',
          addressTooLong: 'הכתובת או תיאור המשלוח ארוכים מדי.',
          unauthorized: 'אין לך הרשאה ליצור הזמנה זו.',
          networkFailed: 'החיבור נכשל. נסה שוב.',
          unknown: 'לא ניתן ליצור את ההזמנה המוכנה.',
        },
      },
      shippingLabel: {
        open: 'הדפסת מדבקת משלוח',
        title: 'מדבקת משלוח',
        backToOrder: 'חזרה להזמנה',
        print: 'הדפסה',
        printAria: 'הדפסת מדבקת המשלוח להזמנה הזו',
        previewHeading: 'תצוגה מקדימה של המדבקה',
        loading: 'המדבקה נטענת...',
        notFoundTitle: 'לא ניתן לפתוח את המדבקה',
        notFoundDescription: 'ייתכן שההזמנה לא קיימת או שאין לך הרשאת גישה אליה.',
        manualApprovalBlockedTitle: 'נדרש אישור קודם',
        manualApprovalBlockedDescription: 'אשר את ההזמנה לפני הדפסת מדבקת משלוח.',
        retry: 'נסה שוב',
        fields: {
          order: 'הזמנה',
          package: 'חבילה',
          packageTotal: 'סכום החבילה',
          batch: 'אצוות משלוח',
          recipient: 'נמען',
          phone: 'טלפון',
          destination: 'יעד',
          address: 'כתובת',
          deliveryInformation: 'פרטי משלוח',
          preciseLocation: 'מיקום מדויק',
          sender: 'שולח',
          senderPhone: 'טלפון השולח',
          notes: 'הערות משלוח',
          printedAt: 'תאריך הדפסה',
        },
        noCourierAssignment: 'לא משויך שליח להזמנה הזו',
        singleOrderNotice: 'המדבקה הזו מיועדת להזמנה הזו בלבד.',
      },
      courierAssignment: {
        title: 'שיוך שליח',
        assign: 'שייך שליח',
        bulkAssign: 'שייך שליח',
        unassign: 'בטל שיוך שליח',
        bulkUnassign: 'בטל שיוך שליח',
        unassigned: 'שיוך השליח בוטל.',
        assignedTo: 'משויך אל {{name}}',
        packageTag: 'חבילה {{tag}}',
        selectedCount: '{{count}} נבחרו',
        noAutoShipNotice: 'שיוך שליח לא מסמן את ההזמנה כנשלחה.',
        manualApprovalRequiredNotice: 'אשר את ההזמנה לפני שיוך שליח.',
        currentlyAssigned: 'כבר משויך אל {{name}}. בחר שליח אחר כדי לשנות זאת.',
        mixedExistingAssignments:
          'לחלק מההזמנות שנבחרו כבר משויך שליח. השיוך יחליף את השליח הנוכחי שלהן.',
        notEligible: 'ההזמנה הזו אינה מתאימה לשיוך.',
        unassignRequiresAssignedSelection: 'בחר רק הזמנות שכבר משויכות לשליח כדי לבטל שיוך.',
        chooseCourier: 'בחר שליח',
        noActiveCouriers: 'אין שליחים פעילים לחנות הזו.',
        noVerifiedCouriers: 'אין שליחים פעילים ומאומתים לחנות הזו.',
        copyLink: 'העתק קישור',
        batchLinkTitle: 'קישור אצוות משלוח',
        batchLinkTitleWithCount: 'קישור אצוות משלוח · {{count}} חבילות',
        batchLinkDescription: 'הקישור הזה כולל את כל ההזמנות שמשויכות לאצוות המשלוח הזו.',
        linkCopied: 'קישור המשלוח הועתק.',
        linkGenerated: 'קישור המשלוח נוצר.',
        sendWhatsapp: 'שלח ב-WhatsApp',
        resendWhatsApp: 'שלח ב-WhatsApp',
        resend: 'שלח קישור שוב',
        regenerate: 'צור קישור חדש',
        regenerateLink: 'צור קישור חדש',
        revoke: 'בטל קישור',
        revokeLink: 'בטל קישור',
        revoked: 'קישור המשלוח בוטל.',
        whatsappMessage:
          'שלום {{courierName}}, {{storeName}} שלחה לך רשימת משלוחים: {{manifestUrl}}',
        errors: {
          invalidStatus: 'אפשר לשייך רק הזמנות שהוזמנו או נשלחו.',
          manualApprovalRequired: 'אשר הזמנות ממתינות לפני שיוך שליח.',
          inactiveCourier: 'השליח הזה אינו פעיל.',
          unverifiedCourier: 'צריך לאמת את השליח לפני שיוך הזמנות.',
          ordersUnavailable: 'חלק מההזמנות שנבחרו אינן זמינות. רענן ונסה שוב.',
          tooManyOrders: 'אפשר לשייך עד 50 הזמנות בבת אחת.',
          linkExpired: 'לא נמצא קישור משלוח פעיל. צור קישור חדש.',
          assignmentConflict: 'חלק מהשיוכים השתנו. רענן ונסה שוב.',
          assignmentNotFound: 'חלק מההזמנות שנבחרו לא משויכות לשליח.',
          assignmentHasProof: 'אי אפשר לבטל שיוך להזמנה עם אישור מסירה.',
        },
      },
      courierProof: {
        awaitingProof: 'ממתין לאישור מסירה',
        awaitingConfirmation: 'ממתין לאישור פנימי',
        confirmed: 'אושר פנימית',
        viewProof: 'צפייה באישור',
        confirm: 'אישור מסירה',
        errors: {
          invalidLink: 'קישור אישור המסירה אינו תקין.',
          notFound: 'האישור הזה אינו זמין עוד.',
          alreadyConfirmed: 'האישור הזה כבר אושר.',
          signedUrlFailed: 'לא ניתן לפתוח את תמונת האישור.',
        },
      },
      manualApproval: {
        pendingBadge: 'ממתין לאישור',
        pendingCallout: 'אשר את ההזמנה לפני שילוח, דחייה, שיוך שליח או הדפסה.',
        pendingPickupCallout: 'יש לאשר את ההזמנה לפני סימונה כנאספה.',
        approve: 'אישור הזמנה',
        approving: 'מאשר…',
        decline: 'דחיית הזמנה',
        declining: 'דוחה…',
        approveModalTitle: 'לאשר את ההזמנה?',
        approvePrompt: 'פעולה זו פותחת את פעולות הטיפול להזמנה.',
        declineModalTitle: 'לדחות את ההזמנה?',
        declinePrompt: 'ההזמנה תידחה, המלאי יוחזר והלקוח יקבל הודעה.',
        approveSuccess: 'ההזמנה אושרה.',
        declineSuccess: 'ההזמנה נדחתה.',
        badges: {
          pending: 'ממתין לאישור',
          approved: 'אושר',
          declined: 'נדחה',
        },
      },
      detail: {
        backToOrders: 'חזרה להזמנות',
        orderId: 'מספר הזמנה',
        orderIdLabel: 'מספר הזמנה:',
        placedOn: 'תאריך הזמנה',
        placedOnLabel: 'תאריך הזמנה:',
        customer: 'פרטי הלקוח',
        callButton: 'התקשר',
        whatsappButton: 'ווטסאפ',
        contactWhatsappMessage: 'שלום, אני רוצה לדבר על הזמנה מספר {{orderId}}',
        shippingAddress: 'כתובת למשלוח',
        deliveryInformation: 'פרטי משלוח',
        copyAddress: 'העתק כתובת',
        addressCopied: 'הועתק',
        preciseLocation: 'מיקום מדויק למשלוח',
        noPreciseLocation: 'לא שותף מיקום מדויק',
        deliveryLocationShareTitle: 'מיקום למשלוח',
        deliveryLocationShareMessage: 'מיקום הלקוח למשלוח:',
        shareLocationWhatsapp: 'שתף ב-WhatsApp',
        openGoogleMaps: 'פתח מפות',
        openWaze: 'פתח Waze',
        copyLocationLink: 'העתק קישור למיקום',
        locationCopied: 'קישור המיקום הועתק',
        copyFailed: 'ההעתקה נכשלה',
        notes: 'הערות הלקוח',
        lineItems: 'פריטים',
        viewProduct: 'צפה במוצר',
        subtotal: 'סיכום ביניים',
        notFound: 'ההזמנה לא נמצאה',
        notFoundDesc: 'ההזמנה הזו לא קיימת או שאין לך הרשאה לצפות בה',
        loading: 'טוען הזמנה...',
        errorRetry: 'נסה שנית',
      },
      actions: {
        collectFailed: 'לא ניתן לאשר את האיסוף. נסו שוב.',
        collectedSuccess: 'ההזמנה סומנה כנאספה',
        collectDescription: 'האם הלקוח אסף את ההזמנה ממקום האיסוף?',
        collectTitle: 'אישור איסוף ההזמנה',
        collecting: 'מסמנים כנאסף',
        markCollected: 'סימון כנאסף',
        ship: 'סמן כנשלח',
        deliver: 'סמן כנמסר',
        reject: 'דחה הזמנה',
        cancel: 'בטל הזמנה',
        shipping: 'שולח...',
        delivering: 'מוסר...',
        rejecting: 'דוחה...',
        cancelling: 'מבטל...',
        shipPrompt: 'לסמן כנשלח? בצע זאת כשמסרת את הסחורה בפועל.',
        deliverPrompt: 'לסמן כנמסר? פעולה זו תסגור את ההזמנה.',
        rejectPrompt: 'לדחות הזמנה זו? הכמויות שהוזמנו יחזרו למלאי וההזמנה תיסגר.',
        cancelPrompt: 'לבטל הזמנה זו? הכמויות שהוזמנו יחזרו למלאי והלקוח יקבל עדכון.',
        shipModalTitle: 'סימון כנשלח',
        deliverModalTitle: 'סימון כנמסר',
        rejectModalTitle: 'דחיית הזמנה',
        cancelModalTitle: 'ביטול הזמנה',
        modalConfirm: 'כן, המשך',
        modalCancel: 'לא, חזרה',
        successToasts: {
          shipped: 'ההזמנה סומנה כנשלחה',
          delivered: 'ההזמנה סומנה כנמסרה',
          rejected: 'ההזמנה נדחתה',
          cancelled: 'ההזמנה בוטלה',
        },
      },
    },
    // F-148 קליטת מלאי מבוקרת (עיצוב §12). תוכן של הסוחר (שמות ספקים, אסמכתאות,
    // הערות, שמות מוצרים) מוצג כפי שהוא ואינו עובר דרך מפתחות אלה.
    receiving: {
      title: 'קבלות קליטה',
      subtitle: 'רשמו משלוחים, בדקו כמויות, ואז הוסיפו למלאי בצעד אחד.',
      entryButton: 'קליטת משלוח',
      notEnabled: 'קליטת מלאי אינה זמינה לחשבון שלך. בקשו מבעל החנות הרשאת ניהול מלאי.',
      backToList: 'חזרה לקבלות',
      paused: {
        banner: 'הקליטה מושהית לחנות זו. קבלות, הורדות ותיקונים נשארים זמינים.',
        draftsReadOnly: 'הטיוטות לקריאה בלבד בזמן שהקליטה מושהית. עדיין אפשר לבטל אותן.',
      },
      tabs: {
        drafts: 'טיוטות',
        receipts: 'קבלות',
      },
      list: {
        empty: 'אין טיוטות פתוחות. התחילו בקליטת משלוח.',
        emptyReceipts: 'עדיין אין קבלות שנרשמו.',
        lines: '{{count}} שורות',
        acceptedUnits: '{{count}} יחידות שהתקבלו',
        updated: 'עודכן {{date}}',
        loadMore: 'טעינת עוד',
        open: 'פתיחה',
        draftLabel: 'טיוטה',
        receiptLabel: 'קבלה',
      },
      new: {
        title: 'משלוח חדש',
        supplier: 'ספק',
        supplierPlaceholder: 'חפשו או הקלידו שם ספק',
        supplierNew: 'יצירת ספק "{{name}}"',
        supplierExistingMatch: 'ספק קיים',
        supplierRequired: 'בחרו ספק או צרו חדש.',
        reference: 'אסמכתת משלוח',
        referenceOptional: 'לא חובה',
        referenceHelp: 'השאירו ריק וניצור אסמכתה אוטומטית.',
        referenceTooLong: 'האסמכתה חייבת להיות עד 80 תווים.',
        referenceControlCharacter: 'האסמכתה מכילה תו בקרה שאינו נתמך.',
        linkedReceipt: 'קבלה מקושרת',
        note: 'הערה',
        create: 'יצירת טיוטה',
        creating: 'יוצר…',
      },
      reference: {
        systemBadge: 'אסמכתה אוטומטית',
        systemHelp: 'נוצרה על ידי דוכנתי כי לא הוזנה אסמכתת משלוח.',
        merchantLabel: 'אסמכתת משלוח',
      },
      draft: {
        title: 'טיוטת קליטה',
        lines: 'שורות',
        noLines: 'אין שורות עדיין. סרקו ברקוד, הוסיפו שורה או ייבאו CSV.',
        addRow: 'הוספת שורה',
        scan: 'סריקה',
        importCsv: 'ייבוא CSV',
        downloadTemplate: 'הורדת תבנית',
        save: 'שמירה',
        review: 'בדיקה',
        discard: 'ביטול הטיוטה',
        discardConfirm: 'לבטל את הטיוטה הזו? שום דבר לא נוסף למלאי.',
        discarded: 'הטיוטה בוטלה.',
        versionConflict: 'הטיוטה השתנתה בחלון אחר. טענו מחדש כדי לראות את הגרסה העדכנית.',
        reload: 'טעינה מחדש',
        errorSummary: 'תקנו את אלה לפני הבדיקה',
        errorSummaryItem: 'שורה {{line}}: {{message}}',
        combinePreview:
          'לאחר האיחוד: צפוי {{expected}}, התקבל {{accepted}}, פגום {{damaged}}, חסר {{missing}}',
        notOpen: 'הטיוטה הזו כבר אינה פתוחה.',
        openReceipt: 'פתיחת הקבלה',
      },
      save: {
        saved: 'נשמר',
        saving: 'שומר…',
        unsaved: 'שינויים שלא נשמרו',
        failed: 'השמירה נכשלה',
        retry: 'ניסיון שמירה חוזר',
        fixFields: 'תקנו את השדות המסומנים כדי לשמור.',
      },
      line: {
        lineNo: 'שורה {{line}}',
        variant: 'וריאנט',
        variantRef: 'מזהה וריאנט',
        barcode: 'ברקוד',
        supplierCode: 'קוד ספק',
        supplierItem: 'פריט ספק',
        unitKind: 'שיטת ספירה',
        unit: 'יחידות',
        pack: 'אריזות',
        packs: 'מספר אריזות',
        unitsPerPack: 'יחידות לאריזה',
        packMath: '{{packs}} אריזות × {{unitsPerPack}} = {{total}} יחידות',
        confirmPack: 'אישור המרת היחידות לאריזה',
        expected: 'צפוי',
        accepted: 'התקבל',
        damaged: 'פגום',
        missing: 'חסר',
        note: 'הערת שורה',
        remove: 'הסרת שורה',
        selectVariant: 'בחירת וריאנט',
        changeVariant: 'החלפת וריאנט',
        inactiveBadge: 'לא פעיל',
        unresolvedScan: 'ברקוד שנסרק וטרם הותאם',
        noVariant: 'לא נבחר וריאנט',
        clearVariant: 'ניקוי בחירה',
        quantities: 'כמויות',
        identifiers: 'מזהים',
      },
      picker: {
        title: 'בחירת וריאנט',
        search: 'חיפוש לפי שם מוצר, אפשרות או ברקוד',
        noResults: 'אין וריאנטים תואמים.',
        loadMore: 'טעינת עוד',
        exactBarcode: 'התאמת ברקוד מדויקת',
        results: 'תוצאות חיפוש',
      },
      conflict: {
        title: 'המזהים מצביעים על וריאנטים שונים',
        description:
          'הברקוד ומזהה הווריאנט בשורה זו מובילים לווריאנטים שונים. בחרו את זה שהגיע בפועל.',
        byBarcode: 'לפי ברקוד',
        byRef: 'לפי מזהה וריאנט',
        use: 'שימוש בווריאנט זה',
      },
      duplicates: {
        title: 'שורות כפולות לאותו וריאנט',
        description: '{{product}} — {{variant}} מופיע בשורות {{lines}}. אחדו אותן לפני הבדיקה.',
        combine: 'איחוד שורות',
      },
      csv: {
        title: 'ייבוא CSV',
        choose: 'בחירת קובץ CSV',
        file: 'קובץ',
        templateHelp: 'השתמשו בתבנית: CSV בקידוד UTF-8, מופרד בפסיקים, עד 500 שורות.',
        import: 'ייבוא שורות',
        importing: 'מייבא…',
        imported: '{{count}} שורות יובאו.',
        duplicateWarning: 'התוכן הזה תואם טיוטה או קבלה קיימת: {{references}}.',
        acknowledge: 'בדקתי, וזהו משלוח אחר.',
        utf8Guidance: 'הקובץ אינו CSV UTF-8. ב-Excel בחרו "CSV UTF-8 (מופרד בפסיקים)" והעלו שוב.',
        fileError: 'שגיאת קובץ',
        readFailed: 'לא ניתן לקרוא את הקובץ. בחרו אותו שוב או נסו קובץ אחר.',
        rowErrors: 'שגיאות שורה (50 הראשונות)',
        row: 'שורה',
        column: 'עמודה',
        problem: 'בעיה',
        errors: {
          empty_file: 'הקובץ ריק.',
          too_large: 'הקובץ גדול מ-2 MiB.',
          unsupported_format: 'נתמכים רק קובצי CSV. אי אפשר לייבא קובצי Excel או PDF.',
          utf16_encoding: 'הקובץ בקידוד UTF-16. שמרו אותו כ-CSV UTF-8 והעלו שוב.',
          encoding_not_utf8:
            'הקובץ אינו CSV UTF-8. ב-Excel בחרו "CSV UTF-8 (מופרד בפסיקים)" והעלו שוב.',
          invalid_character: 'הקובץ מכיל תו פגום (�), כנראה מהמרה קודמת. ייצאו מחדש כ-CSV UTF-8.',
          semicolon_delimiter: 'הקובץ משתמש בנקודה-פסיק. ייצאו אותו מופרד בפסיקים.',
          missing_headers: 'עמודות חובה של התבנית חסרות בשורת הכותרת.',
          unknown_header: 'שורת הכותרת מכילה עמודה שאינה בתבנית.',
          duplicate_header: 'שורת הכותרת חוזרת על עמודה.',
          too_many_rows: 'בקובץ יותר מ-500 שורות.',
          control_character: 'התא מכיל תו בקרה שאינו נתמך.',
          bad_quote: 'בשורה יש מירכאות לא סגורות או במקום לא נכון.',
          too_many_fields: 'בשורה יש יותר שדות מאשר בכותרת.',
          not_integer: 'הזינו מספר שלם ללא סימנים, עשרוניים או מפרידים.',
          out_of_range: 'המספר מחוץ לטווח המותר.',
          invalid_barcode: 'הברקוד אינו תקין.',
          invalid_uuid: 'מזהה הווריאנט אינו מזהה דוכנתי תקין.',
          too_long: 'הטקסט ארוך מדי.',
          pack_incomplete: 'שורות אריזה צריכות גם מספר אריזות וגם יחידות לאריזה.',
          pack_total_mismatch: 'היחידות הצפויות חייבות להיות שוות למספר אריזות × יחידות לאריזה.',
          partial_disposition: 'מלאו התקבל, פגום וחסר יחד, או השאירו את שלושתם ריקים.',
          invalid_unit_kind: 'הערך של unit_kind חייב להיות "unit" או "pack".',
        },
      },
      review: {
        title: 'בדיקה ורישום',
        description: 'רק יחידות שהתקבלו מתווספות למלאי. יחידות פגומות וחסרות נרשמות בקבלה.',
        lines: 'שינויי מלאי',
        inventoryNow: 'כעת',
        adds: '+{{count}}',
        after: 'אחרי',
        totals: 'סיכומים',
        confirm: 'רישום הקבלה',
        confirmTitle: 'לרשום את הקבלה הזו?',
        confirmDescription:
          'המלאי של {{lines}} וריאנטים יגדל ב-{{accepted}} יחידות שהתקבלו. אי אפשר לבטל; תיקונים מאוחרים נעשים דרך תיקונים.',
        posting: 'רושם…',
        checking: 'בודק תוצאה…',
        notReady: 'תקנו את הבעיות החוסמות בטיוטה לפני הרישום.',
        backToDraft: 'חזרה לטיוטה',
        posted: 'הקבלה נרשמה.',
        alreadyPosted: 'הטיוטה הזו כבר נרשמה. פותח את הקבלה.',
        similarRecent: 'קבלה עם אותן שורות נרשמה לספק זה בתאריך {{date}}. ודאו שזהו משלוח אחר.',
        openSimilar: 'פתיחת הקבלה הדומה',
      },
      receipt: {
        title: 'קבלת קליטה',
        postedBy: 'נרשם על ידי',
        postedAt: 'מועד הרישום',
        supplier: 'ספק',
        reference: 'אסמכתה',
        linked: 'מקושר לקבלה',
        netAccepted: 'התקבל נטו',
        corrections: 'תיקונים',
        noCorrections: 'אין תיקונים.',
        download: 'הורדת סיכום פערים CSV',
        noEditNotice: 'אי אפשר לערוך או למחוק קבלות שנרשמו. השתמשו בתיקון כדי להקטין כמות שהתקבלה.',
        lines: 'שורות',
        newLinked: 'קליטת משלוח משלים',
        inventoryChange: '{{before}} ← {{after}}',
        correctedBy:
          '{{units}} יחידות סווגו מחדש כ{{reclassify}} על ידי {{actor}} ב-{{date}}: {{reason}}',
      },
      export: {
        lineNo: 'שורה',
        product: 'מוצר',
        variant: 'וריאנט',
        barcode: 'ברקוד',
        supplierCode: 'קוד ספק',
        supplierItemName: 'פריט ספק',
        expected: 'צפוי',
        accepted: 'התקבל',
        damaged: 'פגום',
        missing: 'חסר',
        corrected: 'תוקן',
        netAccepted: 'התקבל נטו',
        note: 'הערה',
      },
      correction: {
        action: 'תיקון',
        title: 'תיקון הכמות שהתקבלה',
        description:
          'מקטין את הכמות שהתקבלה בשורה זו ומסיר את היחידות מהמלאי. הקבלה המקורית נשארת ללא שינוי.',
        units: 'יחידות להסרה',
        available: 'במלאי כעת: {{count}}',
        remaining: 'ניתן לתיקון בשורה זו: {{count}}',
        reason: 'סיבה',
        reasons: {
          accepted_count_error: 'ספירת ההתקבל הייתה שגויה',
          damage_found_after_posting: 'נמצא נזק אחרי הרישום',
          wrong_variant_received: 'התקבל וריאנט שגוי',
          other: 'אחר',
        },
        reclassifyLabel: 'לרשום את היחידות שהוסרו בתור',
        reclassify: {
          missing: 'חסרות',
          damaged: 'פגומות',
        },
        note: 'הערה',
        noteRequired: 'נדרשת הערה עבור "אחר".',
        unitsInvalid: 'הזינו מספר שלם בין 1 ל-{{max}}.',
        increaseHint: 'כדי להוסיף יחידות או לרשום וריאנט אחר, קלטו משלוח חדש מקושר.',
        confirm: 'החלת התיקון',
        applying: 'מחיל…',
        applied: 'התיקון הוחל.',
        pausedAllowed: 'תיקונים נשארים זמינים בזמן שהקליטה מושהית.',
      },
      barcodeHint: {
        notRecorded: 'שינויים מהירים כאן אינם נרשמים כקבלות קליטה.',
        openReceiving: 'קלטו משלוח במקום זאת',
      },
      scan: {
        label: 'סריקה להוספה',
        liveRegion: 'תוצאות סריקה',
        added: '{{product}} — {{variant}}: צפוי {{expected}}, התקבל {{accepted}}',
        incremented: '{{product}} — {{variant}}: צפוי {{expected}}, התקבל {{accepted}}',
        packLine: 'הפריט הזה נקלט באריזות בשורה {{line}}. עדכנו שם את מספר האריזות.',
        duplicateLines: 'הווריאנט הזה נמצא בשורות {{lines}}. אחדו את השורות קודם.',
        unresolvedUnknown: 'ברקוד לא מוכר נוסף כשורה {{line}}. בחרו וריאנט כדי להמשיך.',
        unresolvedIneligible: 'הברקוד הזה שייך לווריאנט שנמחק. נוסף כשורה {{line}} לבדיקה.',
        alreadyUnresolved: 'הברקוד הזה כבר ממתין בשורה {{line}}.',
        invalid: 'זה אינו ברקוד תקין.',
        lineLimit: 'טיוטה יכולה להכיל עד {{max}} שורות.',
        quantityLimit: 'שורה {{line}} הגיעה לכמות המרבית.',
        lookupFailed: 'החיפוש נכשל. בדקו את החיבור וסרקו שוב.',
      },
      issues: {
        VARIANT_REQUIRED: 'בחרו וריאנט לשורה זו.',
        IDENTIFIER_UNKNOWN: 'אין וריאנט שתואם למזהה הזה. בחרו אחד ידנית.',
        IDENTIFIER_AMBIGUOUS: 'יותר מווריאנט אחד תואם למזהה הזה. בחרו אחד ידנית.',
        IDENTIFIER_CONFLICT: 'הברקוד ומזהה הווריאנט מצביעים על וריאנטים שונים. פתרו את ההתנגשות.',
        VARIANT_INELIGIBLE: 'הווריאנט הזה נמחק או כבר אינו זמין לקליטה.',
        PACK_CONFIRMATION_REQUIRED: 'אשרו את המרת היחידות לאריזה.',
        PACK_TOTAL_MISMATCH:
          'היחידות הצפויות חייבות להיות שוות למספר אריזות × יחידות לאריזה ({{product}}).',
        QUANTITY_MISSING: 'הזינו כמות.',
        QUANTITY_OUT_OF_RANGE: 'הזינו מספר שלם בטווח המותר.',
        QUANTITY_SUM_MISMATCH:
          'התקבל + פגום + חסר חייב להיות שווה לצפוי ({{expected}}). התקבל מחושב: {{calculated}}.',
        DUPLICATE_VARIANT: 'הווריאנט הזה מופיע ביותר משורה אחת. אחדו את השורות.',
        INVENTORY_LIMIT_EXCEEDED: 'הוספת הכמות הזו תחרוג ממגבלת המלאי של 999,999.',
        NO_LINES: 'הוסיפו לפחות שורה אחת.',
        TOO_MANY_LINES: 'טיוטה יכולה להכיל עד {{max}} שורות (כרגע {{count}}).',
        REFERENCE_ALREADY_RECEIVED: 'כבר קיימת קבלה עם ספק ואסמכתה אלה.',
        DUPLICATE_CONTENT_UNACKNOWLEDGED: 'אשרו את אזהרת התוכן הכפול לפני הרישום.',
        RECEIVING_DISABLED: 'הקליטה מושהית לחנות זו.',
        SIMILAR_RECENT_RECEIPT: 'קבלה דומה נרשמה לאחרונה לספק זה.',
      },
      errors: {
        F148_NOT_FOUND: 'הטיוטה או הקבלה לא נמצאו.',
        F148_DISABLED: 'הקליטה מושהית לחנות זו.',
        F148_VALIDATION: 'חלק מהערכים אינם תקינים. בדקו את השדות המסומנים.',
        F148_DRAFT_EXISTS: 'כבר קיימת טיוטה פתוחה עם ספק ואסמכתה אלה.',
        F148_DRAFT_VERSION_CONFLICT:
          'הטיוטה השתנתה בחלון אחר. טענו מחדש כדי לראות את הגרסה העדכנית.',
        F148_DRAFT_NOT_OPEN: 'הטיוטה הזו כבר נרשמה או בוטלה.',
        F148_REVIEW_STALE: 'הטיוטה השתנתה מאז שבדקתם אותה. בדקו אותה שוב.',
        F148_DRAFT_INVALID: 'בטיוטה יש בעיות חוסמות. תקנו אותן ובדקו שוב.',
        F148_REFERENCE_ALREADY_RECEIVED: 'כבר קיימת קבלה עם ספק ואסמכתה אלה.',
        F148_IDEMPOTENCY_KEY_REUSED: 'הבקשה הזו כבר שימשה עם ערכים אחרים. טענו מחדש ונסו שוב.',
        F148_VARIANT_INELIGIBLE: 'וריאנט בטיוטה זו נמחק או כבר אינו זמין. שום דבר לא נרשם.',
        F148_INVENTORY_LIMIT: 'הרישום יחרוג ממגבלת המלאי של 999,999 עבור וריאנט. שום דבר לא נרשם.',
        F148_STOCK_BUSY: 'המלאי עסוק. הטיוטה שלכם בטוחה; נסו שוב.',
        F148_CORRECTION_EXCEEDS_RECEIPT: 'התיקון חורג מהכמות הניתנת לתיקון בשורה זו.',
        F148_CORRECTION_EXCEEDS_AVAILABLE: 'אין מספיק יחידות במלאי לתיקון הזה.',
        F148_UNKNOWN: 'משהו השתבש. הטיוטה שלכם בטוחה; נסו שוב.',
      },
    },
    stock: {
      worklist: {
        scopeLabel: 'היקף התצוגה',
        scopeActive: 'וריאנטים פעילים',
        scopeAll: 'כל הווריאנטים',
        scopeSummary: 'סיכום: {{scope}}',
        scopeHelp: 'המספרים כוללים את כל ההיקף ואינם משתנים לפי החיפוש או מצב המלאי.',
        variants: 'וריאנטים',
        outCount: 'אזלו מהמלאי',
        lowCount: 'מלאי נמוך',
        available: 'זמין למכירה',
        availableHelp: 'הכמות הרשומה הזמינה למכירה, ולא ספירה פיזית.',
        lowRule: 'מלאי נמוך: 1–5 יחידות',
        defaultVariant: 'וריאנט ברירת מחדל',
        inactive: 'לא פעיל',
        unpublished: 'מוצר שלא פורסם',
        barcode: 'ברקוד',
        search: 'חיפוש לפי שם, אפשרויות או ברקוד',
        searchTooLong: 'יש להזין עד 100 תווים.',
        results: 'תוצאות תואמות: {{total}} · מוצגות: {{loaded}}',
        viewProduct: 'הצגת המוצר',
        viewProductLabel: 'הצגת המוצר: {{product}}, {{variant}}',
        backToStock: 'חזרה למלאי',
        loadMore: 'טעינת פריטים נוספים',
        loadingMore: 'טוען פריטים נוספים',
        end: 'סוף התוצאות האלה',
        clear: 'ניקוי החיפוש והמסננים',
        lastChecked: 'בדיקה אחרונה שהצליחה: {{time}}',
        paused: 'הרענון האוטומטי מושהה בזמן סקירת כמה עמודים. לרענון הנתונים לחצו על רענון.',
        changed: 'ייתכן שהמלאי השתנה. רעננו את הרשימה לעיון בתוצאות העדכניות.',
        restarted: 'הרשימה רועננה מההתחלה.',
        loadFailed: 'לא ניתן לטעון את המלאי. נסו שוב.',
        refreshFailed: 'הרענון נכשל. מוצגים הנתונים האחרונים שנטענו.',
        pageFailed: 'לא ניתן לטעון עוד. התוצאות שכבר נטענו נשמרו.',
        accessDenied: 'הגישה למלאי החנות אינה זמינה כעת.',
        invalidQuery: 'לא ניתן להשתמש בחיפוש הזה. נקו את החיפוש או רעננו את הרשימה.',
        noVariants: 'אין וריאנטים להצגה בחנות הזאת.',
        noActive: 'אין וריאנטים פעילים. אפשר להציג את כל הווריאנטים.',
        noMatches: 'לא נמצאו תוצאות לחיפוש ולמסננים האלה.',
        showAll: 'הצגת כל הווריאנטים',
        openProducts: 'הצגת המוצרים',
        viewStockLabel: 'סקירת מלאי: {{product}}, {{variant}}',
      },
      title: 'לוח מלאי',
      refresh: 'רענן',
      refreshing: 'מרענן...',
      loading: 'טוען מלאי...',
      summary: {
        heading: 'סקירת מלאי',
        totalSkus: 'סה״כ מוצרים',
        totalInventory: 'סה״כ מלאי',
        lowStockCount: 'מלאי נמוך',
        outOfStockCount: 'אזל המלאי',
      },
      columns: {
        product: 'מוצר',
        inventory: 'מלאי',
        available: 'זמין',
        status: 'סטטוס',
        actions: 'פעולות',
      },
      status: {
        healthy: 'במלאי',
        lowStock: 'מלאי נמוך',
        outOfStock: 'אזל המלאי',
      },
      filter: {
        all: 'הכל',
        lowStock: 'מלאי נמוך',
        outOfStock: 'אזל המלאי',
        searchPlaceholder: 'חפש מוצר...',
      },
      empty: {
        title: 'אין מוצרים',
        subtitle: 'הוסף מוצרים לחנות כדי לעקוב אחר המלאי.',
        noResults: 'אין תוצאות לסינון שנבחר.',
      },
      updateInventory: {
        trigger: 'עדכן מלאי',
        triggerForProduct: 'עדכון מלאי עבור {{name}}',
        modalTitle: 'עדכן מלאי {{name}}',
        currentInventory: 'מלאי נוכחי: {{count}}',
        explanation: 'זה משנה את סך המלאי הזמין למכירה.',
        newInventoryLabel: 'מלאי חדש',
        availablePreview: 'זמין לאחר העדכון: {{count}}',
        confirm: 'עדכן',
        confirming: 'מעדכן...',
        cancel: 'ביטול',
        errors: {
          negative: 'המלאי לא יכול להיות שלילי.',
          networkFailed: 'הבקשה נכשלה. נסה שוב.',
          unknown: 'אירעה שגיאה. נסה שוב.',
        },
        toasts: {
          updated: 'המלאי עודכן',
        },
      },
      errors: {
        networkFailed: 'לא ניתן לטעון נתוני מלאי. בדוק את החיבור ונסה שוב.',
        unknown: 'אירעה שגיאה בטעינת המלאי.',
      },
    },
  },
  storefront: {
    beauty: {
      shopAll: 'כל המוצרים',
      menu: 'פתיחת תפריט החנות',
      closeMenu: 'סגירת תפריט החנות',
      search: 'חיפוש בחנות',
      searchPlaceholder: 'חיפוש מוצרים',
      closeSearch: 'סגירת החיפוש',
      account: 'החשבון שלי',
      cart: 'סל הקניות',
      productCount: '{{count}} מוצרים',
      loadedCount: 'מוצגים {{loaded}} מתוך {{total}}',
      loadMore: 'הצגת עוד',
      sort: 'מיון מוצרים',
      clearSearch: 'ניקוי החיפוש',
      noResults: 'לא נמצאו מוצרים התואמים לחיפוש.',
      selectShade: 'בחירת גוון',
      selectOptions: 'בחירת אפשרויות',
      shadeCount: '{{count}} גוונים',
      shadeCount_one: 'גוון אחד',
      moreDetails: 'פרטים נוספים',
      details: 'פרטי המוצר',
      shippingReturns: 'משלוחים והחזרות',
      relatedHeading: 'עוד מהקטגוריה הזו',
      reviews: 'ביקורות',
      ratingSummary: 'דירוג {{average}} מתוך 5 לפי {{count}} ביקורות',
      previous: 'הקודם',
      next: 'הבא',
      community: 'הקהילה שלנו',
      browseProduct: 'הצגת {{name}}',
      shop: 'קנייה',
      contact: 'יצירת קשר',
      policies: 'מדיניות החנות',
      currency: 'המחירים בשקלים חדשים',
      newsletterInert: 'תצוגה מקדימה בלבד; אי אפשר לשלוח הרשמה כאן.',
      catalogLoadError: 'לא ניתן לטעון מוצרים. נסו שוב.',
      factsLoadError: 'לא ניתן לטעון את פרטי המוצרים הנוספים.',
      chooseOptions: 'בחרו את כל האפשרויות לפני ההוספה לסל.',
      backToShop: 'חזרה לחנות',
      newsletterHeading: 'נשארים מעודכנים',
      newsletterBody: 'הירשמו לקבלת עדכונים מהחנות.',
      galleryIndex: 'תמונה {{index}} מתוך {{total}}',
      searchSubmit: 'חיפוש',
      footerGroupToggle: 'פתיחה או סגירה של {{group}}',
      communityProductUnavailable: 'המוצר אינו זמין',
    },
    website: {
      luxury: {
        categories: 'גלו את הקטגוריות',
        discoverCategory: 'לגלות את הקולקציה',
        bestSellers: 'הנמכרים ביותר',
        sale: 'מבצעים',
        newArrivals: 'חדש בחנות',
        moreFromCategory: 'עוד מהקטגוריה',
        backToCategory: 'חזרה לקטגוריה',
        productDetails: 'פרטי המוצר',
        merchandisingError: 'לא ניתן לטעון את המוצרים. נסו שוב.',
      },
      fashion: {
        demoWhiteShirt: 'חולצה לבנה מכופתרת',
        demoBlackBag: 'תיק כתף שחור',
        demoCollection: 'פריטי הבסיס',
        viewCollection: 'צפייה בקולקציית {{category}}',
        campaignLoadError: 'לא הצלחנו לטעון את הקולקציה.',
        collectionUnavailableTitle: 'הקולקציה אינה זמינה כרגע',
        collectionUnavailableDescription: 'חזרו לחנות כדי לעיין במוצרים הזמינים.',
        retry: 'נסו שוב',
        previousProductImage: 'התמונה הקודמת של {{name}}',
        nextProductImage: 'התמונה הבאה של {{name}}',
        productImagePosition: 'תמונה {{index}} מתוך {{count}} של {{name}}',
        sizeGuideOpen: 'צפייה במדריך מידות',
        sizeGuideClose: 'סגירת מדריך המידות',
        newsletterCompany: 'חברה',
        sizeGuideTitle: 'מדריך מידות',
        description: 'תיאור',
        detailsCare: 'פרטים וטיפול',
        deliveryReturns: 'משלוחים והחזרות',
        generatedArtwork: 'איורי אופנה סינתטיים מקוריים שנוצרו לתבניות דוקאנטי.',
      },
      credits: {
        licenseScope: 'התמונות המקוריות והעיבודים שלנו כפופים לרישיונות המקושרים להלן.',
        title: 'קרדיטים לתמונות התבניות',
        intro:
          'התמונות המשמשות בתבניות האתרים של דוקאנטי ובתצוגות המקדימות שלהן. בעלי חנויות יכולים להחליף אותן בתמונות משלהם.',
        source: 'התמונה המקורית',
        license: 'רישיון',
        changes:
          'שינויים: חיתוך, שינוי גודל ודחיסה לפורמט WebP; התמונות משמשות גם בצילומי תצוגה מקדימה של התבניות.',
      },
      updating: {
        reload: 'טעינת החנות מחדש',
        reloadFailed: 'החנות עדיין זקוקה לגרסה חדשה יותר. נסו מאוחר יותר.',
        title: 'החנות מתעדכנת',
        body: 'אנא חזרו בעוד מעט.',
        browse: 'גלישה בדוכנתי',
      },
      skipToContent: 'דילוג לתוכן',
      nav: {
        label: 'ניווט בחנות',
        home: 'דף הבית',
        shop: 'חנות',
        about: 'אודות',
        cart: 'עגלה',
        account: 'חשבון',
        search: 'חיפוש',
        openMenu: 'פתיחת תפריט',
        closeMenu: 'סגירת תפריט',
      },
      hero: {
        previous: 'השקופית הקודמת',
        next: 'השקופית הבאה',
        slideStatus: 'שקופית {{current}} מתוך {{total}}',
      },
      media: {
        pause: 'השהיה',
        play: 'הפעלה',
      },
      categories: {
        heading: 'קנייה לפי קטגוריה',
      },
      products: {
        newArrivals: 'חדש באתר',
        bestSellers: 'הנמכרים ביותר',
        trending: 'פופולרי עכשיו',
        related: 'אולי תאהבו גם',
        viewAll: 'הצגת הכול',
      },
      about: {
        title: 'אודות החנות',
        delivery: 'משלוחים',
        returns: 'החזרות',
        contact: 'יצירת קשר',
      },
      product: {
        careTitle: 'טיפול',
        sizeGuideTitle: 'מדריך מידות',
      },
      confirmation: {
        title: 'ההזמנה התקבלה',
        continue: 'המשך קנייה',
      },
      footer: {
        powered: 'מופעל על ידי דוכנתי',
      },
      canvas: {
        checkoutDisabled: 'זהו דף התשלום האמיתי שלכם. שליחת הזמנות כבויה בזמן העריכה.',
        sampleProduct: 'מוצר לדוגמה',
        sampleCategory: 'קטגוריה לדוגמה',
        embeddedBlocked: 'לא ניתן להציג את הדף הזה כאן.',
        orderConfirmationNotice: 'אחרי שלקוח מזמין, הוא רואה כאן את אישור ההזמנה.',
        seeOrderConfirmation: 'הצגת דף אישור ההזמנה',
        notInEditor: 'הדף הזה אינו חלק מעורך חזית החנות.',
        backToStore: 'חזרה לדף הבית של החנות',
      },
    },
    storefrontEngine: {
      fallback: {
        sectionUnavailable: 'אי אפשר להציג את המדור כרגע.',
      },
      liveCanvas: {
        empty: {
          title: 'ממתין לבילדר',
          body: 'המסלול הזה מציג תוכן רק אחרי שבילדר הניהול פותח סשן קנבס מהימן.',
        },
        loading: 'ממתין לבילדר',
        ready: 'הקנבס מוכן',
        renderFailed: 'לא ניתן להציג את הקנבס.',
        invalidPayload: 'מטען הקנבס אינו תקין.',
        unavailable: 'הקנבס החי אינו זמין.',
        controlsDisabled: 'פקדי הקנבס אינם זמינים כרגע.',
        selectionLabel: 'בחר מדור בחנות',
        sections: {
          hero: 'מדור הירו',
          header: 'כותרת החנות',
          footer: 'תחתית החנות',
          mobileNav: 'ניווט במובייל',
          announcementBar: 'רצועת ההודעות',
          benefits: 'יתרונות',
          faq: 'שאלות נפוצות',
          aboutStore: 'על החנות',
          testimonials: 'המלצות',
          newsletterCta: 'קריאה לניוזלטר',
          trustBadge: 'תג אמון',
          promotionalAds: 'מודעות החנות',
          categories: 'קטגוריות',
          liveOffers: 'מבצעים חיים',
          products: 'מוצרים',
          trustSummary: 'סיכום אמון',
          editorialBanner: 'באנר עריכתי',
        },
        selection: {
          chromeLabel: 'מסומן',
          aria: {
            section: 'מקטע ניתן לבחירה: {{section}}',
            selectedSection: 'המקטע המסומן בקנבס: {{section}}',
          },
        },
        edit: {
          shortLabel: 'עריכה',
          editSection: 'עריכת {{section}}',
          lockedShortLabel: 'נעול',
          lockedSection: '{{section}} מוגן בקנבס הבילדר',
        },
        textFields: {
          editTextField: 'עריכת {{field}} בתוך {{section}}',
          labels: {
            heroHeadline: 'כותרת הירו',
            heroEyebrow: 'פתיח הירו',
            heroDescription: 'תיאור הירו',
            heroPrimaryActionLabel: 'פעולה ראשית בהירו',
            contentHeading: 'כותרת מדור',
            contentBody: 'גוף המדור',
            contentBenefitTitle: 'כותרת יתרון',
            contentBenefitBody: 'גוף יתרון',
            contentFaqQuestion: 'שאלת FAQ',
            contentFaqAnswer: 'תשובת FAQ',
            contentAboutParagraph: 'פסקת על החנות',
            contentTestimonialQuote: 'ציטוט המלצה',
            contentTestimonialName: 'שם ממליץ',
            contentTestimonialContext: 'פרטי המלצה',
            contentNewsletterButton: 'כפתור ניוזלטר',
            contentEditorialBannerButton: 'כפתור הבאנר',
          },
        },
        richContentFields: {
          editRichContentField: 'עריכת תוכן עשיר עבור {{field}} בתוך {{section}}',
          labels: {
            contentBenefitsBody: 'גוף יתרונות',
            contentBenefitBody: 'גוף יתרון',
            contentFaqBody: 'פתיח שאלות נפוצות',
            contentFaqAnswer: 'תשובה נפוצה',
            contentAboutParagraph: 'פסקת על החנות',
            contentTestimonialsBody: 'פתיח ציטוטים',
            contentTestimonialQuote: 'ציטוט המלצה',
            contentNewsletterBody: 'טקסט קריאת ניוזלטר',
            contentEditorialBannerBody: 'טקסט הבאנר',
          },
        },
        mediaFields: {
          replaceMediaField: 'החלפת {{field}} בתוך {{section}}',
          labels: {
            heroDesktop: 'תמונת הירו לדסקטופ',
            heroMobile: 'תמונת הירו למובייל',
            trustBadgeImage: 'תמונת תג אמון',
            editorialBannerDesktop: 'תמונת הבאנר למחשב',
            editorialBannerMobile: 'תמונת הבאנר לנייד',
          },
        },
        add: {
          shortLabel: 'הוסף',
          addAfterSection: 'הוסף מדור אחרי {{section}}',
        },
        lifecycle: {
          duplicate: 'שכפול {{section}}',
          hide: 'הסתרת {{section}}',
          show: 'הצגת {{section}}',
          delete: 'מחיקת {{section}}',
          hiddenPlaceholder: '{{section}} מוסתר בטיוטה.',
        },
        visibility: {
          deviceHiddenPlaceholder: '{{section}} מוסתר בגודל התצוגה הזה.',
        },
        heroSchedule: {
          always: 'פעיל תמיד',
          active: 'מוצג עכשיו',
          upcoming: 'מתוזמן',
          expired: 'פג תוקף',
        },
        reorder: {
          handle: 'גרור כדי לסדר מחדש את {{section}}',
          moveUp: 'העבר את {{section}} לפני המדור הקודם',
          moveDown: 'העבר את {{section}} אחרי המדור הבא',
          dropBefore: 'שחרור לפני {{section}}',
          dropAfter: 'שחרור אחרי {{section}}',
          movedBefore: '{{section}} הועבר לפני {{target}}.',
          movedAfter: '{{section}} הועבר אחרי {{target}}.',
        },
        inertAction: 'פעולות קונים מושבתות בקנבס הבילדר.',
        aria: {
          route: 'קנבס בונה החנות',
          selectedSection: 'מדור נבחר בקנבס',
          selectedControls: 'פקדי קנבס למדור {{section}}',
        },
      },
    },
    preview: {
      banner: 'מצב תצוגה מקדימה',
      expired: 'פג התוקף של קישור התצוגה המקדימה.',
      notAvailable: 'התצוגה המקדימה אינה זמינה.',
      noindexLabel: 'מוסתר ממנועי חיפוש',
      unsupportedTitle: 'דף התצוגה המקדימה אינו זמין',
      unsupportedDescription:
        'היעד הזה עדיין אינו חלק מהתצוגה המקדימה הבטוחה. המשך מדף הבית של התצוגה המקדימה.',
      backToPreview: 'חזרה לדף הבית של התצוגה המקדימה',
    },
    welcome: 'ברוכים הבאים ל-Dukanti',
    shopNow: 'קנה עכשיו',
    offerCampaigns: {
      homeRailTitle: 'קמפיינים פעילים',
      liveBadge: 'מבצע פעיל',
      endsIn: 'מסתיים בעוד {{time}}',
      endedTitle: 'המבצע הסתיים',
      endedDescription: 'בדוק את החנות למבצעים נוספים.',
      emptyTitle: 'אין מוצרים זמינים במבצע הזה',
      emptyDescription: 'ייתכן שהמוצרים אזלו או שכבר אינם במבצע.',
      variantLabel: 'אפשרות: {{variant}}',
      homeCta: 'צפייה במבצע',
      shareLabel: 'שיתוף המבצע',
      meta: {
        title: '{{campaignTitle}} מ-{{storeName}}',
        description: 'מבצע פעיל של {{storeName}} לזמן מוגבל.',
      },
    },
    courierManifest: {
      title: 'רשימת משלוחים',
      loading: 'טוען רשימת משלוחים...',
      retry: 'נסה שוב',
      error: {
        title: 'לא ניתן לטעון את רשימת המשלוחים',
        description: 'בדוק את החיבור ונסה שוב. אם הבעיה נמשכת, בקש קישור חדש מהחנות.',
      },
      batchCode: 'קבוצה {{displayCode}}',
      courierGreeting: 'עבור {{name}}',
      expiresAt: 'פג תוקף ב-{{expiresAt}}',
      orders: 'תחנות מסירה',
      orderCount: '{{count}} הזמנות',
      orderLabel: 'תחנה {{displayId}}',
      address: 'כתובת',
      customerPhone: 'טלפון לקוח',
      googleMaps: 'Google Maps',
      waze: 'Waze',
      packageCount: '{{count}} חבילה',
      packageBatchCount: '{{count}} תחנות מסירה',
      notes: 'הערות לקוח',
      openMap: 'פתח מפה',
      storeContact: 'התקשר לחנות: {{phone}}',
      storeContactUnavailable: 'פרטי קשר של החנות אינם זמינים',
      packageTag: 'חבילה {{tag}}',
      proof: {
        submit: 'שליחת אישור מסירה',
        replace: 'החלפת אישור',
        submitted: 'האישור נשלח',
        choosePhoto: 'בחר תמונה',
        chooseFromLibrary: 'בחירה מהספרייה',
        takePhoto: 'צילום תמונה',
        fileSizeKilobytes: '{{count}} קילובייט',
        fileSizeMegabytes: '{{count}} מגה-בייט',
        errors: {
          invalidType: 'יש להשתמש בתמונת JPG, PNG או WebP.',
          tooLarge: 'התמונה חייבת להיות עד 5 MB.',
          notShipped: 'לא ניתן למסור את התחנה הזו מכאן.',
          alreadyConfirmed: 'החנות כבר אישרה את המסירה הזו.',
          uploadFailed: 'לא ניתן להעלות את תמונת האישור. נסה שוב.',
        },
      },
      invalid: {
        title: 'קישור המשלוח אינו זמין',
        body: 'ייתכן שהקישור פג, בוטל או חסר. בקש קישור חדש מהחנות.',
        description: 'ייתכן שהקישור פג, בוטל או חסר. בקש קישור חדש מהחנות.',
      },
    },
    courierPortal: {
      title: 'פורטל שליח',
      invalid: {
        title: 'קישור פורטל השליח אינו זמין',
        description: 'ייתכן שהקישור בוטל או אינו תקין. בקש קישור חדש מהחנות.',
      },
      empty: {
        title: 'אין חבילות מוכנות כרגע',
        description: 'הזמנות שנשלחו ושויכו לשליח הזה יופיעו כאן.',
      },
      localities: {
        title: 'יישובים',
        count: '{{count}} חבילה',
      },
      locality: {
        back: 'חזרה ליישובים',
      },
      language: {
        label: 'שפה',
        ar: 'ערבית',
        he: 'עברית',
        en: 'אנגלית',
      },
      device: {
        forgetAction: 'שכח מכשיר זה',
        title: 'להסיר את המכשיר הזה?',
        description:
          'השתמש בזה אם זה לא הטלפון שלך. המכשיר הזה לא יפתח שוב את הפורטל אלא אם החנות תשלח את הקישור המלא מחדש.',
        confirm: 'הסר מכשיר זה',
      },
      packageCount: '{{count}} חבילה',
      customer: 'לקוח',
      proof: {
        required: 'יש לשלוח הוכחת מסירה לפני סימון החבילה כנמסרה.',
        submitted: 'אישור המסירה נשלח וממתין לאישור החנות.',
        confirmed: 'אישור המסירה אושר על ידי החנות.',
      },
    },
    storeChrome: {
      announcementBar: {
        label: 'הודעת החנות',
      },
      labels: {
        storeHome: 'בית החנות',
        storeCategories: 'קטגוריות',
        storeSales: 'מבצעים',
        bestSellers: 'הנמכרים ביותר',
        trendingNow: 'פופולרי עכשיו',
        newArrivals: 'חדש בחנות',
        category: 'קטגוריה',
        cart: 'עגלה',
        account: 'חשבון',
        orders: 'הזמנות',
        whatsapp: 'וואטסאפ',
        phone: 'טלפון',
        instagram: 'Instagram',
        facebook: 'Facebook',
      },
      footer: {
        quickLinks: 'קישורי חנות',
        socialLinks: 'רשתות חברתיות',
      },
    },
    home: {
      nav: {
        label: 'ניווט בדף הבית',
        home: 'בית',
        stores: 'חנויות',
        sales: 'מבצעים',
        orders: 'ההזמנות שלי',
        account: 'חשבון',
      },
      storeNav: {
        home: 'חנות',
        sales: 'מבצעים',
      },
      rootLanding: {
        eyebrow: 'Dukanti',
        title: 'קישור החנות המקומית שלך מוכן כשתצטרך אותו',
        subtitle: 'השתמש בקישור החנות שקיבלת, או נהל את הפרופיל וההזמנות שלך מכאן.',
        profile: 'פרופיל',
        openStore: 'פתח חנות',
      },
      hero: {
        badge: 'קנייה מקומית',
        title: 'גלה חנויות מקומיות',
        subtitle: 'עיין בחנויות מהכפר שלך והזמן ישירות מבעלי החנויות.',
        browseStores: 'עיין בחנויות',
        openYourStore: 'פתח חנות',
        fromProduct: 'ממוצר שפורסם',
        fromStore: 'מחנות שפורסמה',
      },
      products: {
        title: 'מוצרים מחנויות מקומיות',
        empty: 'עדיין אין מוצרים שפורסמו.',
        error: 'לא ניתן לטעון מוצרים. נסה שוב.',
        retry: 'נסה שוב',
        viewProductLabel: 'צפה ב-{{productName}}',
      },
      sales: {
        title: 'מבצעים והנחות',
        subtitle: 'מוצרים מוזלים מחנויות מקומיות',
        empty: 'אין מבצעים זמינים כרגע.',
        error: 'לא ניתן לטעון מבצעים. נסה שוב.',
        retry: 'נסה שוב',
      },
      publishedStores: {
        title: 'חנויות מקומיות',
        empty: 'עדיין אין חנויות שפורסמו.',
        error: 'לא ניתן לטעון חנויות. נסה שוב.',
        retry: 'נסה שוב',
      },
      featuredStores: {
        title: 'חנויות מובחרות',
        empty: 'אין עדיין חנויות. היה הראשון לפתוח חנות!',
        error: 'לא ניתן לטעון חנויות. נסה שוב.',
        retry: 'נסה שוב',
        viewStore: 'בקר בחנות',
        viewStoreLabel: 'בקר בחנות — {{storeName}}',
        storeLogoAlt: 'לוגו {{storeName}}',
      },
      howItWorks: {
        title: 'איך זה עובד?',
        step1Title: 'עיין בחנויות',
        step1Description: 'גלה חנויות מקומיות מהכפר שלך ועיין במוצרים שלהם.',
        step2Title: 'צור קשר עם המוכר',
        step2Description: 'צור קשר ישירות עם בעל החנות דרך וואטסאפ או טלפון.',
        step3Title: 'הזמן ואסוף',
        step3Description: 'השלם את ההזמנה ועקוב אחר הפרטים שלה מהחשבון שלך.',
      },
      meta: {
        title: 'Dukanti',
        description: 'פרופיל לקוחות וקישורי חנויות לקוני Dukanti.',
      },
    },
    sale: {
      onSale: 'מבצע',
      discountPercent: '{{percent}}% הנחה',
      originalPrice: 'המחיר המקורי {{price}}',
    },
    contactSeller: {
      prefilledMessage: 'שלום, אני מתעניין ב-{{productName}}. קישור: {{url}}',
      unavailable: 'פרטי התקשרות אינם זמינים',
      modal: {
        title: 'איך תרצה ליצור קשר?',
        whatsapp: 'פתח וואטסאפ',
        phone: 'התקשר',
        close: 'סגור',
      },
    },
    storeNotAvailable: {
      title: 'החנות אינה זמינה',
      description: 'חנות זו אינה זמינה כרגע או שאינה קיימת.',
      backHome: 'חזרה ל-Dukanti',
    },
    storePlaceholder: {
      liveBadge: 'חי',
      comingSoon: 'חוויית החנות המלאה בקרוב',
    },
    storeSales: {
      title: 'מוצרים במבצע',
      subtitle: 'מוצרים מוזלים מהחנות הזו בלבד.',
      emptyTitle: 'אין מבצעים כרגע',
      emptyDescription: 'בדוק את החנות הזו שוב בהמשך למבצעים חדשים.',
      error: 'לא ניתן לטעון מוצרים במבצע. נסה שוב.',
      meta: {
        title: 'המבצעים של {{storeName}}',
        description: 'עיין במוצרים מוזלים מ-{{storeName}}.',
      },
    },
    storeCollections: {
      bestSellers: {
        title: 'הנמכרים ביותר',
      },
      trendingNow: {
        title: 'פופולרי עכשיו',
      },
      newArrivals: {
        title: 'חדש בחנות',
      },
      subtitle: 'מוצרים נבחרים מ-{{storeName}}',
      emptyTitle: 'אין עדיין מוצרים באוסף הזה',
      emptyDescription: 'חזרו לבדוק בהמשך כשהחנות תקבל יותר פעילות.',
      meta: {
        title: '{{collectionName}} של {{storeName}}',
      },
    },
    customProductCollections: {
      subtitle: 'מוצרים נבחרים של {{storeName}}',
      emptyTitle: 'אין מוצרים באוסף הזה כרגע',
      emptyDescription: 'חזרו לבדוק בהמשך כשהחנות תעדכן את האוסף שלה.',
      meta: {
        title: '{{collectionName}} של {{storeName}}',
        description: 'עיינו ב-{{collectionName}} של {{storeName}}.',
      },
    },
    storeCategoriesPage: {
      title: 'כל הקטגוריות',
      subtitle: 'עיינו בכל הקטגוריות הפעילות של {{storeName}}',
      emptyTitle: 'אין קטגוריות עדיין',
      emptyDescription: 'החנות עדיין לא פרסמה קטגוריות עם מוצרים.',
      error: 'לא ניתן לטעון את הקטגוריות. נסו שוב.',
      meta: {
        title: 'הקטגוריות של {{storeName}}',
        description: 'עיינו בכל הקטגוריות של {{storeName}}.',
      },
    },
    storeHeader: {
      homeAriaLabel: 'חזרה אל {{storeName}}',
      storeLogoName: 'חנות {{storeName}}',
      cartAriaLabel: 'עגלה של {{storeName}}',
    },
    // F-005 Phase 4a stub strings — final Hebrew copy lands in Phase 4c.
    storeHome: {
      header: {
        wordmark: 'דוכנתי',
        wordmarkAriaLabel: 'דוכנתי — דף הבית',
      },
      languageSwitcher: 'שפה',
      hero: {
        storeLogoAlt: 'הלוגו של {{storeName}}',
      },
      conversionHero: {
        primaryCta: 'קנה עכשיו',
        categoriesCta: 'עיין בקטגוריות',
        featuredProduct: 'מהחנות',
        visualFallback: 'הצצה מ-{{storeName}}',
        descriptionFallback: 'מוצרים נבחרים של {{storeName}} במקום אחד.',
      },
      contact: {
        title: 'יצירת קשר ישיר עם החנות',
        description: 'בחרו וואטסאפ או שיחה לפי פרטי הקשר שבעל החנות פרסם.',
        whatsapp: 'וואטסאפ',
        phone: 'שיחה',
        whatsappAriaLabel: 'יצירת קשר עם {{storeName}} בוואטסאפ',
        phoneAriaLabel: 'התקשר אל {{storeName}}',
      },
      products: {
        title: 'מוצרים',
      },
      sections: {
        hero: 'חזית החנות',
        contact: 'יצירת קשר ישירה',
        bestSellers: 'הנמכרים ביותר',
        trendingNow: 'פופולרי עכשיו',
        newArrivals: 'חדש בחנות',
        specialOffers: 'מבצעים מיוחדים',
        selectedProducts: 'מוצרים נבחרים',
        customCollection: 'אוסף נבחר',
        sales: 'מבצעים',
        latestProducts: 'המוצרים האחרונים',
        availableNow: 'זמין עכשיו',
        unavailable: 'לא זמין כרגע',
        allProducts: 'כל המוצרים',
        viewAll: 'הצג הכל',
        productsUnavailableHint: 'אלה מוצרים שפורסמו אך אינם זמינים להזמנה כרגע.',
        emptyManualProducts: 'אין מוצרים נבחרים שניתן להציג כרגע.',
        emptyCustomCollection: 'אין מוצרים מהאוסף הזה שניתן להציג כרגע.',
        emptyAutomaticProducts: 'אין מוצרים כשירים שניתן להציג כרגע.',
        railError: 'לא ניתן לטעון את החלק הזה.',
        networkError: 'לא הצלחנו לטעון את המדור. בדקו את החיבור ונסו שוב.',
        unknownError: 'לא הצלחנו לטעון את המדור כרגע.',
      },
      newsletter: {
        contactTypeLabel: 'פרטי קשר',
        email: 'אימייל',
        phone: 'טלפון',
        emailLabel: 'כתובת אימייל',
        phoneLabel: 'מספר טלפון ישראלי',
        emailPlaceholder: 'name@example.com',
        phonePlaceholder: '050 123 4567',
        consentLabel: 'אני מסכים לקבל עדכונים מהחנות הזו דרך פרטי הקשר שאמסור.',
        submit: 'הצטרפות לעדכונים',
        pending: 'שומר...',
        successTitle: 'תודה',
        successBody: 'הבקשה התקבלה.',
        invalidEmail: 'הזינו כתובת אימייל תקינה.',
        invalidPhone: 'הזינו מספר טלפון ישראלי תקין.',
        consentRequired: 'אשרו הסכמה כדי להמשיך.',
        genericError: 'לא ניתן לשמור כרגע. נסו שוב מאוחר יותר.',
      },
      trust: {
        title: 'אמון לקוחות',
        summary: '{{average}} מתוך 5 מתוך {{count}} ביקורות מאומתות',
        badge: '{{average}} · {{count}} ביקורות מאומתות',
      },
      categories: {
        title: 'קנייה לפי קטגוריה',
        viewAll: 'הצגת הכל',
        viewCategory: 'צפייה בקטגוריה {{categoryName}}',
        productCount: '{{count}} מוצרים',
        loadError: 'לא ניתן לטעון את הקטגוריות.',
        imageAlt: 'תמונת קטגוריה {{categoryName}}',
      },
      ads: {
        slideAriaLabel: 'מודעה {{index}} מתוך {{total}}',
        openAd: 'פתיחת המודעה',
        destinationCue: 'לצפייה בפרטים',
        imageAlt: 'מודעה של {{storeName}}',
        previous: 'המודעה הקודמת',
        next: 'המודעה הבאה',
        goToSlide: 'מעבר למודעה {{index}}',
      },
      productImageAlt: 'תמונה של {{productName}}',
      viewProduct: 'צפייה במוצר',
      loadMore: 'הצג עוד',
      loadingMore: 'טוען...',
      productCard: {
        availability: {
          outOfStock: 'אזל מהמלאי',
          onlyNLeft: 'נותרו {{count}} בלבד',
        },
      },
      empty: {
        title: 'אין מוצרים עדיין',
        description: 'החנות הזו עדיין לא הוסיפה מוצרים — חזרו לבדוק מאוחר יותר.',
      },
      errors: {
        loadMoreFailed: 'לא ניתן היה לטעון עוד. נסו שוב.',
        networkFailed: 'החיבור נכשל. בדקו את הרשת שלכם.',
        unknown: 'משהו השתבש. נסו שוב.',
        loadFirstFailed: 'לא ניתן לטעון את המוצרים כעת.',
        loadFirstFailedHint: 'בדקו את החיבור לאינטרנט ונסו שוב.',
      },
      liveRegion: {
        loaded: 'מציג {{count}} מוצרים שנטענו',
        loadedFiltered: 'מוצגים {{visibleCount}} מתוך {{loadedCount}} מוצרים שנטענו',
      },
      loadedFilter: {
        label: 'סינון המוצרים שנטענו',
        placeholder: 'הקלידו שם מוצר מתוך המוצרים שנטענו',
        summary: 'מוצגים {{visibleCount}} מתוך {{loadedCount}} מוצרים שנטענו',
        clear: 'ניקוי הסינון',
        hideUnavailable: 'הסתרת מוצרים שאזלו מתוך המוצרים שנטענו',
        emptyTitle: 'אין מוצרים שנטענו בשם הזה',
        emptyDescription: 'נקו את הסינון או טענו עוד עמוד למוצרים המוצגים.',
      },
      loading: {
        srLabel: 'טוען חנות',
        ariaLabel: 'טוען חנות',
      },
      seo: {
        title: '{{storeName}}',
        fallbackDescription: 'קנייה מ-{{storeName}}',
      },
    },
    productCard: {
      fromPrice: 'החל מ-{{price}}',
      saleFromPrice: 'מבצע החל מ-{{price}}',
    },
    categoryCatalog: {
      backToStore: 'חזרה לחנות',
      productCount: '{{count}} מוצרים',
      search: {
        label: 'חיפוש בתוך {{categoryName}}',
        placeholder: 'חפשו מוצר בקטגוריה הזו',
        clear: 'ניקוי החיפוש',
      },
      sort: {
        label: 'מיון מוצרים',
        default: 'ברירת מחדל',
        priceAsc: 'מחיר: מהנמוך לגבוה',
        priceDesc: 'מחיר: מהגבוה לנמוך',
        newest: 'החדשים ביותר',
        nameAsc: 'שם: א-ת',
      },
      loading: 'טוענים את מוצרי הקטגוריה...',
      empty: {
        title: 'אין מוצרים תואמים',
        description: 'נסו חיפוש אחר או נקו את החיפוש כדי לראות את מוצרי הקטגוריה.',
      },
      emptySearch: {
        title: 'אין מוצרים שמתאימים ל-{{search}}',
        description: 'נסו חיפוש אחר או נקו את החיפוש כדי לראות את מוצרי הקטגוריה.',
        clear: 'ניקוי החיפוש',
      },
      errors: {
        loadFailed: 'לא ניתן לטעון את מוצרי הקטגוריה.',
        loadMoreFailed: 'לא ניתן לטעון מוצרים נוספים מהקטגוריה.',
        networkFailed: 'לא ניתן להתחבר. נסו שוב.',
        unknown: 'אירעה שגיאה לא צפויה.',
      },
      liveRegion: {
        loaded: 'מוצגים {{visibleCount}} מתוך {{totalCount}} מוצרים',
      },
      meta: {
        title: '{{categoryName}} — {{storeName}}',
        description: 'קנו מוצרי {{categoryName}} מ-{{storeName}}.',
      },
    },
    productPlaceholder: {
      title: 'דף המוצר בפיתוח',
      description: 'אנחנו עובדים על דפי מוצרים. תוכלו לחזור לחנות ולעיין במוצרים הזמינים.',
      backToStore: 'חזרה לחנות',
    },
    productDetail: {
      backToStore: 'חזרה ל-{{storeName}}',
      categoryLabel: 'קטגוריה',
      descriptionLabel: 'תיאור',
      contactSeller: 'פנייה למוכר',
      outOfStock: 'אזל מהמלאי',
      availability: {
        inStock: 'במלאי',
        lowStock: 'נותרו {{count}} בלבד',
        outOfStock: 'אזל מהמלאי',
      },
      variants: {
        chooseOption: 'בחר {{option}}',
        available: 'זמין',
        disabled: 'לא זמין למכירה',
        unavailable: 'לא זמין',
        outOfStock: 'אזל מהמלאי',
        lowStock: 'נותרו רק {{count}}',
        selectRequired: 'בחר אפשרות לפני הוספה לעגלה',
      },
      quantity: {
        label: 'כמות',
        decreaseAriaLabel: 'הפחת כמות',
        increaseAriaLabel: 'הוסף כמות',
        helperMustBeBetween: 'הזינו מספר שלם בין 1 ל-{{max}}',
        helperExceedsAvailable: 'זמינים רק {{available}}',
        helperOnlyNLeft: 'נותרו {{count}} בלבד',
        outOfStockReplacement: 'אזל מהמלאי',
        maxInCartReplacement: 'הכמות המרבית כבר בסל שלך',
      },
      gallery: {
        previousImage: 'התמונה הקודמת',
        nextImage: 'התמונה הבאה',
        goToImage: 'מעבר לתמונה {{index}}',
        paginationLabel: 'מעבר בין תמונות',
        thumbnailLabel: 'תמונה ממוזערת {{index}}',
        noImages: 'אין תמונות למוצר זה',
        zoomImage: 'הגדלת תמונה {{index}}',
        zoomOverlayLabel: 'תצוגת תמונה בגודל מלא',
        zoomClose: 'סגירה',
        zoomCounter: '{{current}} / {{total}}',
        zoomResetZoom: 'איפוס הגדלה',
      },
      seo: {
        title: '{{productName}} — {{storeName}}',
        fallbackDescription: 'קנייה של {{productName}} מ-{{storeName}}',
      },
      loading: {
        srLabel: 'טוען מוצר',
      },
      share: {
        button: 'שיתוף',
        copyButton: 'העתקת קישור',
        shareAriaLabel: 'שתף את {{productName}}',
        copyAriaLabel: 'העתק קישור אל {{productName}}',
        nativeText: '{{productName}} מ-{{storeName}}',
        toast: {
          sharedTitle: 'המוצר שותף',
          copiedTitle: 'הקישור הועתק',
          failedTitle: 'השיתוף נכשל',
          failedBody: 'לא הצלחנו לשתף או להעתיק את קישור המוצר. נסה שוב.',
        },
      },
      reviews: {
        title: 'ביקורות לקוחות',
        summary: '{{average}} · {{count}} ביקורות',
        retry: 'טעינת ביקורות מחדש',
        yourReviewTitle: 'הביקורת שלך',
        editYourReview: 'עריכת ביקורת',
        editTitle: 'עריכת הביקורת שלך',
        saveEdit: 'שמירת ביקורת',
        editSuccess: 'הביקורת שלך עודכנה',
        hiddenOwnReview:
          'הביקורת הזו מוסתרת מקונים כרגע. השינויים שלך יישארו מחוברים לאותה קנייה מאומתת.',
      },
    },
    cart: {
      addToCart: 'הוסף לסל',
      adding: 'מוסיף…',
      outOfStockButton: 'אזל מהמלאי',
      maxInCartButton: 'הכמות המרבית בסל',
      persistenceError:
        'לא הצלחנו לשמור את הפריט הזה בסל בדפדפן הזה. בדוק את הגדרות האחסון או הגלישה הפרטית ונסה שוב.',
      successToast: {
        title: 'נוסף לסל',
        body: '{{productName}} × {{quantity}}',
        viewCart: 'הצג סל',
      },
      errorToast: {
        title: 'לא ניתן להוסיף לסל',
      },
      line: {
        variantSummary: '{{summary}}',
      },
      primedBanner: {
        title: 'ממשיכים מאיפה שעצרנו — הוסף את {{storeName}} לסל שלך',
        dismiss: 'סגור',
      },
      postAddPanel: {
        title: '{{productName}} נוסף לסל שלך',
        body: 'בסל שלך יש עכשיו {{quantity}}.',
        viewCart: 'הצג סל',
        continueShopping: 'המשך קנייה',
        dismiss: 'סגור',
      },
      // F-015: cart header icon + badge + dropdown.
      // Hebrew CLDR plural rules use _one (1), _two (2), _many (20/30/...),
      // and _other (everything else). _zero and _few are never resolved by
      // CLDR for Hebrew, but we seed them with _other to satisfy the
      // i18n parity test (set-equality with ar.ts / en.ts).
      header: {
        // iconLabel (6 forms)
        iconLabel_zero: 'עגלה ריקה',
        iconLabel_one: 'עגלה — פריט אחד',
        iconLabel_two: 'עגלה — שני פריטים',
        iconLabel_few: 'עגלה — {{count}} פריטים', // seeded = _other
        iconLabel_many: 'עגלה — {{count}} פריטים', // seeded = _other
        iconLabel_other: 'עגלה — {{count}} פריטים',

        // static strings
        dropdownTitle: 'העגלה שלך',
        dropdownAriaLabel: 'תצוגה מקדימה של העגלה',
        subtotal: 'סכום ביניים',
        viewCart: 'הצג עגלה',
        emptyTitle: 'העגלה שלך ריקה',
        browseProducts: 'עיין במוצרים',
        // Security W4: pure translated string — no interpolation.
        loadError: 'טעינת העגלה נכשלה',

        // itemCountSuffix (6 forms)
        itemCountSuffix_zero: 'אין פריטים',
        itemCountSuffix_one: 'פריט אחד',
        itemCountSuffix_two: 'שני פריטים',
        itemCountSuffix_few: '{{count}} פריטים',
        itemCountSuffix_many: '{{count}} פריטים',
        itemCountSuffix_other: '{{count}} פריטים',

        // moreItems (6 forms)
        moreItems_zero: '+אין נוספים',
        moreItems_one: '+פריט נוסף',
        moreItems_two: '+שני פריטים נוספים',
        moreItems_few: '+{{count}} נוספים',
        moreItems_many: '+{{count}} נוספים',
        moreItems_other: '+{{count}} נוספים',

        // itemsUnavailable (6 forms)
        itemsUnavailable_zero: 'אין פריטים לא זמינים',
        itemsUnavailable_one: 'פריט אחד אינו זמין',
        itemsUnavailable_two: 'שני פריטים אינם זמינים',
        itemsUnavailable_few: '{{count}} פריטים אינם זמינים',
        itemsUnavailable_many: '{{count}} פריטים אינם זמינים',
        itemsUnavailable_other: '{{count}} פריטים אינם זמינים',
      },
      // F-016: full cart page strings.
      page: {
        title: 'עגלת הקניות',
        subtitle: 'בדוק את הפריטים לפני המעבר לתשלום',
        breadcrumbBack: 'חזרה לחנות',
        empty: {
          title: 'העגלה שלך ריקה',
          body: 'עוד לא הוספת פריטים לעגלה.',
          browseProducts: 'עיין במוצרים',
        },
        line: {
          removeAriaLabel: 'הסר את {{productName}} מהעגלה',
          unitPrice: '{{price}} ליחידה',
          lineSubtotal: 'סכום ביניים לשורה',
          priceUpdated: 'המחיר השתנה',
          priceWas: 'היה: {{oldPrice}}',
          priceNow: 'עכשיו: {{newPrice}}',
          unavailable: 'לא זמין',
          unknownProduct: 'המוצר אינו זמין עוד',
          imageAlt: 'תמונה של {{productName}}',
        },
        unavailableBanner: {
          title: 'חלק מהפריטים אינם זמינים עוד',
          body: '{{count}} פריטים אינם זמינים יותר לרכישה. הסר אותם כדי להמשיך לאישור ההזמנה.',
        },
        handoffRecovery: {
          retrying: 'מעבירים את העגלה אחרי ההתחברות...',
          partial: 'לא הצלחנו להעביר את כל פריטי העגלה. בדוק את העגלה ואז נסה לאשר את ההזמנה שוב.',
          savedIntentTitle: 'חלק מהפריטים השמורים דורשים בדיקה',
          savedIntentBody:
            'הפריטים האלה עדיין שמורים בדפדפן הזה ולא עברו לעגלת החשבון. הסר מה שאינך רוצה ואז נסה לאשר את ההזמנה שוב.',
          retrySavedItems: 'נסה להעביר שוב את הפריטים השמורים',
        },
        summary: {
          title: 'סיכום ההזמנה',
          subtotal: 'סכום ביניים',
          itemCount_zero: 'אין פריטים',
          itemCount_one: 'פריט אחד',
          itemCount_two: 'שני פריטים',
          itemCount_few: '{{count}} פריטים',
          itemCount_many: '{{count}} פריטים',
          itemCount_other: '{{count}} פריטים',
          stockCheckNote: 'הפריטים נשארים בעגלה בלי לשמור מלאי. הזמינות תאושר בעת שליחת ההזמנה.',
          proceedToCheckout: 'המשך לאישור ההזמנה',
          checkoutDisabledHint: 'הסר פריטים שאינם זמינים כדי להמשיך',
          checkoutDisabledHandoffHint: 'בדוק או הסר פריטי עגלה שמורים לפני ההמשך',
          signinRequiredDialog: {
            title: 'אמת את הטלפון כדי לאשר את ההזמנה',
            body: 'נשלח קוד אחד ואז נחזיר אותך לאישור ההזמנה. העגלה שלך תישאר שמורה כאן.',
            continue: 'המשך עם טלפון',
            cancel: 'הישאר בעגלה',
          },
        },
        removeDialog: {
          title: 'להסיר את {{productName}}?',
          body: '{{productName}} יוסר מהעגלה.',
          confirm: 'הסר',
          cancel: 'ביטול',
        },
        errors: {
          refetchFailed: 'טעינת העגלה נכשלה. נסה שוב.',
          updateFailed: 'עדכון העגלה נכשל',
          removeFailed: 'הסרת הפריט מהעגלה נכשלה',
        },
        toast: {
          removed: '{{productName}} הוסר מהעגלה',
        },
        skeleton: {
          loadingAriaLabel: 'טוען את העגלה',
        },
        retryButton: 'נסה שוב',
      },
    },
    // F-017: real checkout flow.
    checkout: {
      review: {
        cartChanged: 'הפריטים בסל השתנו. בדקו את הסל המעודכן ואשרו מחדש.',
        cartRefreshFailed: 'לא ניתן לרענן את הסל. נסו שוב לפני אישור ההזמנה.',
        verificationFailed: 'לא ניתן לאמת את פריטי הסל. נסו שוב לפני האישור.',
      },
      page: {
        title: 'השלמת הזמנה',
        backToCart: 'חזרה לעגלה',
        shippingSection: 'כתובת למשלוח',
        changeAddress: 'שנה כתובת',
        useDifferentAddress: 'השתמש בכתובת אחרת',
        manageAddresses: 'ניהול כתובות שמורות',
        saveForNextTime: 'שמור כתובת זו לפעם הבאה',
        localityPlaceholder: 'בחר עיר או יישוב',
        localityLoading: 'טוען יישובים...',
        localityError: 'לא ניתן לטעון יישובים. נסה שוב.',
        notesSection: 'הערות למוכר',
        submitCta: 'אישור הזמנה',
        deliveryPriceNoticeTitle: 'מחיר המשלוח יאושר בנפרד',
        deliveryPriceNotice:
          'מחיר המשלוח עדיין לא כלול. החנות תיצור איתך קשר כדי לאשר את עלות המשלוח לפני שליחת ההזמנה.',
      },
      deliveryMethod: {
        title: 'שיטת משלוח',
        location: 'מיקום',
        address: 'כתובת',
      },
      deliveryInfo: {
        title: 'פרטי משלוח',
        description: 'ספרו לחנות לאן לשלוח. מיקום מדויק הוא אופציונלי.',
        localityLabel: 'עיר או יישוב',
        postalCodeLabel: 'מיקוד',
        recipientLabel: 'שם הנמען',
        backupPhoneLabel: 'טלפון חלופי',
        errors: {
          localityRequired: 'בחרו עיר או יישוב.',
          postalCodeRequired: 'הזינו מיקוד.',
          postalCodeInvalid: 'הזינו מיקוד ישראלי תקין.',
          recipientRequired: 'הזינו את שם הנמען.',
          recipientTooLong: 'שם הנמען ארוך מדי.',
          backupPhoneInvalid: 'הזינו מספר טלפון חלופי תקין.',
        },
      },
      deliveryLocation: {
        title: 'מיקום מדויק למשלוח',
        description: 'שתף את המיקום הנוכחי כדי שהסוחר יוכל להגיע לנקודת המשלוח המדויקת.',
        localityLabel: 'עיר או יישוב',
        localityRequired: 'בחר עיר או יישוב לפני שיתוף המיקום.',
        homeWarning: 'השתמש באפשרות הזו רק כשאתה בבית או במקום שבו אתה בדרך כלל מקבל משלוחים.',
        cta: 'שתף את המיקום המדויק שלי',
        update: 'עדכן מיקום מדויק',
        locating: 'מאתר מיקום...',
        shared: 'מיקום מדויק נוסף למשלוח',
        clear: 'הסר מיקום',
        denied: 'הרשאת המיקום נדחתה. אפשר עדיין להשלים את ההזמנה בלי GPS.',
        deniedWithExisting: 'הרשאת המיקום נדחתה. המיקום המדויק שנוסף קודם עדיין מצורף להזמנה הזו.',
        unavailable: 'מיקום מדויק אינו זמין במכשיר הזה. אפשר עדיין להשלים את ההזמנה בלי GPS.',
        unavailableWithExisting:
          'מיקום מדויק אינו זמין במכשיר הזה. המיקום שנוסף קודם עדיין מצורף להזמנה הזו.',
      },
      locationModal: {
        title: 'לשתף מיקום מדויק?',
        body: 'הדפדפן יבקש הרשאה. נוסיף את הקואורדינטות להזמנה הזו בלבד.',
        confirmCta: 'שתף מיקום',
        cancelCta: 'ביטול',
      },
      modal: {
        title: 'אישור הזמנה',
        body: 'אתה עומד לשלוח הזמנה ל{{storeName}}.',
        itemCount_one: 'פריט אחד',
        itemCount_other: '{{count}} פריטים',
        subtotal: 'סכום ביניים',
        confirmCta: 'אישור',
        cancelCta: 'ביטול',
      },
    },
  },
  // F-017: order domain namespace.
  order: {
    submit: 'שלח הזמנה',
    confirm: 'אשר הזמנה',
    cancel: 'בטל הזמנה',
    placed: 'ההזמנה נשלחה',
    tracking: 'מעקב הזמנה',
    shippingAddress: 'כתובת למשלוח',
    deliveryInformation: 'פרטי משלוח',
    preciseLocation: 'מיקום מדויק למשלוח',
    orderSummary: 'סיכום הזמנה',
    stockCheckNotice: 'המלאי נשמר בעת שליחת ההזמנה. המוכר ייצור איתך קשר לתיאום המשלוח.',
    notes: {
      placeholder: 'הוסף הערות למוכר (אופציונלי)',
      maxLengthHint: '{{current}}/{{max}}',
    },
    status: {
      ordered: 'הוזמן',
      shipped: 'נשלח',
      delivered: 'נמסר',
      cancelled: 'בוטל',
      rejected: 'נדחה',
    },
    // F-018: order confirmation page keys
    headline: {
      placed: 'ההזמנה התקבלה!',
      ordered: 'ההזמנה התקבלה!',
      shipped: 'ההזמנה נשלחה!',
      delivered: 'ההזמנה הגיעה!',
      cancelled: 'ההזמנה בוטלה',
      rejected: 'ההזמנה נדחתה',
    },
    whatHappensNext: 'מה קורה עכשיו?',
    whatHappensNextBody:
      'המוכר יבדוק את ההזמנה שלך וייצור איתך קשר דרך WhatsApp או טלפון כדי לאשר משלוח ולסדר תשלום. אפשר לעקוב אחרי סטטוס ההזמנה כאן בכל זמן.',
    contactMerchant: 'יצירת קשר עם המוכר',
    contactMerchantWhatsappMessage:
      'שלום {{storeName}}, אני רוצה לשאול על ההזמנה שלי מספר {{orderId}}',
    contactMerchantWhatsappAriaLabel: 'שליחת הודעת ווטסאפ אל {{storeName}} לגבי הזמנה זו',
    contactMerchantPhoneAriaLabel: 'התקשר אל {{storeName}} לגבי הזמנה זו',
    id: 'מספר הזמנה',
    placedDate: 'תאריך הזמנה',
    cancelButton: 'ביטול הזמנה',
    cancelQuestion: 'שינית את דעתך?',
    cancelConfirmTitle: 'לבטל את ההזמנה?',
    cancelConfirmBody: 'הפעולה תבטל את ההזמנה ותחזיר את הפריטים למלאי החנות.',
    cancelConfirmCta: 'כן, בטל הזמנה',
    cancelSuccess: 'ההזמנה שלך בוטלה',
    timeline: {
      title: 'מעקב הזמנה',
      completedOn: 'הושלם ב-{{- date}}',
    },
    viewAllOrders: 'צפייה בכל ההזמנות',
    backToStore: 'חזרה לחנות',
    customerNotes: 'ההערות שלך למוכר',
    loadingDetails: 'טוען פרטי הזמנה',
    reviewPrompt: {
      title: 'ביקורות להזמנה הזו',
      submit: 'שליחת ביקורת',
      alreadyReviewed: 'כבר נכתבה ביקורת למוצר הזה',
      ratingRequired: 'בחרו דירוג מ-1 עד 5',
      textTooLong: 'הטקסט חייב להיות עד 1000 תווים',
      whitespaceOnly: 'כתבו טקסט ברור או השאירו את השדה ריק',
      success: 'הביקורת נשלחה',
      openDialog: 'כתיבת ביקורת',
      ratingOnlyHint: 'אפשר לשלוח דירוג בלבד או להוסיף טקסט קצר.',
      reviewedHint: 'הביקורות ששלחת נשארות מחוברות למוצרים שנמסרו.',
      yourReview: 'הביקורת שלך',
      editReview: 'עריכת ביקורת',
      hiddenReview: 'מוסתרת מקונים כרגע. העריכה שומרת על קישור הקנייה המאומת.',
      merchantResponse: 'תגובת המוכר',
      textLabel: 'טקסט הביקורת',
      textPlaceholder: 'כתבו מה חשבתם על המוצר',
      dialogTitle: 'ביקורת על {{productName}}',
      close: 'סגירה',
    },
    errors: {
      productUnavailable: 'חלק מהמוצרים אינם זמינים יותר: {{names}}',
      variantUnavailable: 'אחת האפשרויות כבר לא זמינה. בדוק את העגלה.',
      cartEmpty: 'העגלה ריקה. הוסף מוצרים לפני השלמת ההזמנה.',
      storeUnavailable: 'החנות אינה מקבלת הזמנות כרגע.',
      networkFailed: 'שגיאת חיבור. בדוק את הרשת ונסה שוב.',
      unknown: 'אירעה שגיאה. נסה שוב.',
      // F-018: cancel-specific error keys
      cancelFailed: 'לא ניתן לבטל את ההזמנה. נסה שוב.',
      cancelAlreadyProcessed: 'לא ניתן לבטל הזמנה זו במצבה הנוכחי.',
      orderNotFound: 'ההזמנה לא נמצאה.',
      // F-023: merchant transition error keys
      invalidTransition: 'לא ניתן לבצע פעולה זו במצב הנוכחי של ההזמנה.',
      transitionUnauthorized: 'אין לך הרשאה לשנות את סטטוס ההזמנה הזו.',
      shipFailed: 'עדכון המלאי נכשל בעת המשלוח. נסה שוב.',
      deliverFailed: 'רישום המסירה נכשל. נסה שוב.',
      courierProofRequired: 'השליח חייב לשלוח תמונת אישור מסירה מקישור המשלוח.',
      manualApprovalRequired: 'אשר את ההזמנה לפני פעולות טיפול.',
      rejectFailed: 'דחיית ההזמנה נכשלה. נסה שוב.',
    },
    history: {
      title: 'ההזמנות שלי',
      totalOrders: '{{count}} הזמנות',
      activeOrders: '{{count}} פעילות',
      filterLabel: 'סינון לפי סטטוס',
      filterAll: 'הכל',
      itemCount: '{{count}} פריטים',
      viewOrder: 'צפה',
      loadMore: 'טען עוד',
      loadingMore: 'טוען...',
      loadingOrders: 'טוען הזמנות',
      backToAccount: 'חשבון',
      emptyAllCta: 'עיין בחנויות',
      emptyAllSubtitle: 'עיין בחנויות והתחל לקנות',
      emptyFilteredHint: 'נסה סינון אחר או בדוק מאוחר יותר',
      empty: {
        all: 'לא הוגשו הזמנות עדיין',
        ordered: 'אין הזמנות שממתינות למשלוח',
        shipped: 'אין הזמנות שנשלחו',
        delivered: 'אין הזמנות שנמסרו',
        cancelled: 'אין הזמנות מבוטלות',
        rejected: 'אין הזמנות שנדחו',
      },
    },
    // F-020: status-change toast key
    statusChangedToast: 'ההזמנה שלך עכשיו {{status}}',
  },
  promotionKit: {
    whatsapp: {
      storeHome: 'בקרו בחנות {{storeName}}: {{url}}',
      product: 'ראו את {{targetName}} מ{{storeName}}: {{url}}',
      category: 'עיינו ב{{targetName}} מ{{storeName}}: {{url}}',
      liveOfferCampaign: 'מבצע פעיל מ{{storeName}}: {{targetName}} {{url}}',
      salesPage: 'המבצעים של {{storeName}} מחכים לכם: {{url}}',
      reviewHighlight: 'לקוחות אוהבים את {{targetName}} מ{{storeName}}. ראו עוד: {{url}}',
    },
    poster: { cta: 'סרקו והזמינו מהחנות' },
    story: { cta: 'הזמינו מהחנות' },
  },
  errors: {
    notFound: 'הדף לא נמצא',
    networkFailed: 'החיבור לרשת נכשל',
    title: 'אירעה שגיאה לא צפויה',
    description: 'אנו מתנצלים על אי-הנוחות. ניתן לנסות שוב.',
    retry: 'נסה שוב',
  },
};
